/*!
 * Browser tracker for Snowplow v0.6.8 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (O, fa) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" !== typeof module ? fa(exports) : "function" === typeof define && define.amd ? define(["exports"], fa) : (O = "undefined" !== typeof globalThis ? globalThis : O || self, fa(O.snowplowBrowserTracking = {}));
})(this, function (O) {
  function fa(a, c, b) {
    if (b || 2 === arguments.length) for (var d = 0, f = c.length, g; d < f; d++) {
      !g && d in c || (g || (g = Array.prototype.slice.call(c, 0, d)), g[d] = c[d]);
    }
    return a.concat(g || Array.prototype.slice.call(c));
  }

  function Lf(a) {
    var c = 0,
        b = 0;
    var d = "";
    var f = [];
    if (!a) return a;
    a += "";

    do {
      var g = pb.indexOf(a.charAt(c++));
      var l = pb.indexOf(a.charAt(c++));
      d = pb.indexOf(a.charAt(c++));
      var m = pb.indexOf(a.charAt(c++));
      var q = g << 18 | l << 12 | d << 6 | m;
      g = q >> 16 & 255;
      l = q >> 8 & 255;
      q &= 255;
      64 === d ? f[b++] = String.fromCharCode(g) : 64 === m ? f[b++] = String.fromCharCode(g, l) : f[b++] = String.fromCharCode(g, l, q);
    } while (c < a.length);

    d = f.join("");
    return function (r) {
      return decodeURIComponent(r.split("").map(function (y) {
        return "%" + ("00" + y.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }(d.replace(/\0+$/, ""));
  }

  function xc() {
    var a = {},
        c = [],
        b = [],
        d = [],
        f,
        g = function g(l, m) {
      null != m && "" !== m && (a[l] = m);
    };

    return {
      add: g,
      addDict: function addDict(l) {
        for (var m in l) {
          Object.prototype.hasOwnProperty.call(l, m) && g(m, l[m]);
        }
      },
      addJson: function addJson(l, m, q) {
        q && ne(q) && (l = {
          keyIfEncoded: l,
          keyIfNotEncoded: m,
          json: q
        }, b.push(l), c.push(l));
      },
      addContextEntity: function addContextEntity(l) {
        d.push(l);
      },
      getPayload: function getPayload() {
        return a;
      },
      getJson: function getJson() {
        return c;
      },
      withJsonProcessor: function withJsonProcessor(l) {
        f = l;
      },
      build: function build() {
        null === f || void 0 === f ? void 0 : f(this, b, d);
        return a;
      }
    };
  }

  function Mf(a) {
    return function (c, b, d) {
      for (var f = function f(r, y, w) {
        r = JSON.stringify(r);

        if (a) {
          w = c.add;

          if (r) {
            var u = 0,
                k = 0,
                h = [];

            if (r) {
              r = unescape(encodeURIComponent(r));

              do {
                var t = r.charCodeAt(u++);
                var x = r.charCodeAt(u++);
                var v = r.charCodeAt(u++);
                var E = t << 16 | x << 8 | v;
                t = E >> 18 & 63;
                x = E >> 12 & 63;
                v = E >> 6 & 63;
                E &= 63;
                h[k++] = pb.charAt(t) + pb.charAt(x) + pb.charAt(v) + pb.charAt(E);
              } while (u < r.length);

              u = h.join("");
              r = r.length % 3;
              r = (r ? u.slice(0, r - 3) : u) + "===".slice(r || 3);
            }

            r = r.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
          }

          w.call(c, y, r);
        } else c.add(w, r);
      }, g = function g(r, y) {
        if (!r) {
          var w = c.getPayload();

          if (a ? w.cx : w.co) {
            r = JSON;
            var u = r.parse;

            if (a) {
              if (w = w.cx) {
                switch (4 - w.length % 4) {
                  case 2:
                    w += "==";
                    break;

                  case 3:
                    w += "=";
                }

                w = w.replace(/-/g, "+").replace(/_/g, "/");
                w = Lf(w);
              }
            } else w = w.co;

            r = u.call(r, w);
          } else r = void 0;
        }

        r ? r.dt = r.dt.concat(y.dt) : r = y;
        return r;
      }, l = void 0, m = 0; m < b.length; m++) {
        var q = b[m];
        "cx" === q.keyIfEncoded ? l = g(l, q.json) : f(q.json, q.keyIfEncoded, q.keyIfNotEncoded);
      }

      b.length = 0;
      d.length && (b = {
        sc: "sp/ctx/1-0-0",
        dt: fa([], d, !0)
      }, l = g(l, b), d.length = 0);
      l && f(l, "cx", "co");
    };
  }

  function ne(a) {
    if (!oe(a)) return !1;

    for (var c in a) {
      if (Object.prototype.hasOwnProperty.call(a, c)) return !0;
    }

    return !1;
  }

  function oe(a) {
    return "undefined" !== typeof a && null !== a && (a.constructor === {}.constructor || a.constructor === [].constructor);
  }

  function Nf() {
    var a = [],
        c = [];
    return {
      getGlobalPrimitives: function getGlobalPrimitives() {
        return a;
      },
      getConditionalProviders: function getConditionalProviders() {
        return c;
      },
      addGlobalContexts: function addGlobalContexts(b) {
        for (var d = [], f = [], g = 0; g < b.length; g++) {
          var l = b[g];
          pe(l) ? d.push(l) : Nb(l) && f.push(l);
        }

        a = a.concat(f);
        c = c.concat(d);
      },
      clearGlobalContexts: function clearGlobalContexts() {
        c = [];
        a = [];
      },
      removeGlobalContexts: function removeGlobalContexts(b) {
        for (var d = function d(g) {
          pe(g) ? c = c.filter(function (l) {
            return JSON.stringify(l) !== JSON.stringify(g);
          }) : Nb(g) && (a = a.filter(function (l) {
            return JSON.stringify(l) !== JSON.stringify(g);
          }));
        }, f = 0; f < b.length; f++) {
          d(b[f]);
        }
      },
      getApplicableContexts: function getApplicableContexts(b) {
        a: {
          var d = 0;

          for (var f = b.getJson(); d < f.length; d++) {
            var g = f[d];

            if ("ue_px" === g.keyIfEncoded && "object" === _typeof(g.json.data) && (g = g.json.data.schema, "string" == typeof g)) {
              d = g;
              break a;
            }
          }

          d = "";
        }

        f = b.getPayload().e;
        g = "string" === typeof f ? f : "";
        f = [];
        var l = Zc(a, b, g, d);
        f.push.apply(f, l);
        b = Of(c, b, g, d);
        f.push.apply(f, b);
        return f;
      }
    };
  }

  function Pf(a) {
    return {
      addPluginContexts: function addPluginContexts(c) {
        var b = c ? fa([], c, !0) : [];
        a.forEach(function (d) {
          try {
            d.contexts && b.push.apply(b, d.contexts());
          } catch (f) {
            Pa.error("Error adding plugin contexts", f);
          }
        });
        return b;
      }
    };
  }

  function Qf(a) {
    if ("*" === a[0] || "*" === a[1]) return !1;

    if (0 < a.slice(2).length) {
      var c = !1,
          b = 0;

      for (a = a.slice(2); b < a.length; b++) {
        if ("*" === a[b]) c = !0;else if (c) return !1;
      }

      return !0;
    }

    return 2 == a.length ? !0 : !1;
  }

  function qe(a) {
    return (a = a.split(".")) && 1 < a.length ? Qf(a) : !1;
  }

  function re(a) {
    a = /^iglu:((?:(?:[a-zA-Z0-9-_]+|\*).)+(?:[a-zA-Z0-9-_]+|\*))\/([a-zA-Z0-9-_.]+|\*)\/jsonschema\/([1-9][0-9]*|\*)-(0|[1-9][0-9]*|\*)-(0|[1-9][0-9]*|\*)$/.exec(a);
    if (null !== a && qe(a[1])) return a.slice(1, 6);
  }

  function $c(a) {
    if (a = re(a)) {
      var c = a[0];
      return 5 === a.length && qe(c);
    }

    return !1;
  }

  function Rf(a) {
    return Array.isArray(a) && a.every(function (c) {
      return "string" === typeof c;
    });
  }

  function se(a) {
    return Rf(a) ? a.every(function (c) {
      return $c(c);
    }) : "string" === typeof a ? $c(a) : !1;
  }

  function $b(a) {
    return ne(a) && "schema" in a && "data" in a ? "string" === typeof a.sc && "object" === _typeof(a.dt) : !1;
  }

  function Sf(a) {
    var c = 0;

    if (null != a && "object" === _typeof(a) && !Array.isArray(a)) {
      if (Object.prototype.hasOwnProperty.call(a, "accept")) if (se(a.accept)) c += 1;else return !1;
      if (Object.prototype.hasOwnProperty.call(a, "reject")) if (se(a.reject)) c += 1;else return !1;
      return 0 < c && 2 >= c;
    }

    return !1;
  }

  function yc(a) {
    return "function" === typeof a && 1 >= a.length;
  }

  function Nb(a) {
    return yc(a) || $b(a);
  }

  function te(a) {
    return Array.isArray(a) && 2 === a.length ? Array.isArray(a[1]) ? yc(a[0]) && a[1].every(Nb) : yc(a[0]) && Nb(a[1]) : !1;
  }

  function ue(a) {
    return Array.isArray(a) && 2 === a.length ? Sf(a[0]) ? Array.isArray(a[1]) ? a[1].every(Nb) : Nb(a[1]) : !1 : !1;
  }

  function pe(a) {
    return te(a) || ue(a);
  }

  function Tf(a, c) {
    var b = 0,
        d = 0,
        f = a.accept;
    Array.isArray(f) ? a.accept.some(function (g) {
      return zc(g, c);
    }) && d++ : "string" === typeof f && zc(f, c) && d++;
    f = a.reject;
    Array.isArray(f) ? a.reject.some(function (g) {
      return zc(g, c);
    }) && b++ : "string" === typeof f && zc(f, c) && b++;
    return 0 < d && 0 === b ? !0 : !1;
  }

  function zc(a, c) {
    if (!$c(a)) return !1;
    a = re(a);
    c = /^iglu:([a-zA-Z0-9-_.]+)\/([a-zA-Z0-9-_]+)\/jsonschema\/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$/.exec(c);
    c = null !== c ? c.slice(1, 6) : void 0;

    if (a && c) {
      if (!Uf(a[0], c[0])) return !1;

      for (var b = 1; 5 > b; b++) {
        if (!ve(a[b], c[b])) return !1;
      }

      return !0;
    }

    return !1;
  }

  function Uf(a, c) {
    c = c.split(".");
    a = a.split(".");

    if (c && a) {
      if (c.length !== a.length) return !1;

      for (var b = 0; b < a.length; b++) {
        if (!ve(c[b], a[b])) return !1;
      }

      return !0;
    }

    return !1;
  }

  function ve(a, c) {
    return a && c && "*" === a || a === c;
  }

  function we(a) {
    return Array.isArray(a) ? a : [a];
  }

  function Zc(a, c, b, d) {
    var f;
    a = we(a).map(function (g) {
      a: if ($b(g)) g = [g];else {
        if (yc(g)) {
          b: {
            var l = void 0;

            try {
              var m = {
                event: c.getPayload(),
                eventType: b,
                eventSchema: d
              };
              l = g(m);

              if (Array.isArray(l) && l.every($b) || $b(l)) {
                var q = l;
                break b;
              }

              q = void 0;
              break b;
            } catch (r) {}

            q = void 0;
          }

          if ($b(q)) {
            g = [q];
            break a;
          } else if (Array.isArray(q)) {
            g = q;
            break a;
          }
        }

        g = void 0;
      }

      if (g && 0 !== g.length) return g;
    });
    return (f = []).concat.apply(f, a.filter(function (g) {
      return null != g && g.filter(Boolean);
    }));
  }

  function Of(a, c, b, d) {
    var f;
    a = we(a).map(function (g) {
      a: {
        if (te(g)) {
          var l = g[0],
              m = !1;

          try {
            var q = {
              event: c.getPayload(),
              eventType: b,
              eventSchema: d
            };
            m = l(q);
          } catch (r) {
            m = !1;
          }

          if (!0 === m) {
            g = Zc(g[1], c, b, d);
            break a;
          }
        } else if (ue(g) && Tf(g[0], d)) {
          g = Zc(g[1], c, b, d);
          break a;
        }

        g = [];
      }

      if (g && 0 !== g.length) return g;
    });
    return (f = []).concat.apply(f, a.filter(function (g) {
      return null != g && g.filter(Boolean);
    }));
  }

  function Vf(a) {
    return null == a ? {
      type: "dtm",
      value: new Date().getTime()
    } : "number" === typeof a ? {
      type: "dtm",
      value: a
    } : "ttm" === a.type ? {
      type: "ttm",
      value: a.value
    } : {
      type: "dtm",
      value: a.value || new Date().getTime()
    };
  }

  function Wf(a) {
    void 0 === a && (a = {});
    var c = a.base64,
        b = a.corePlugins,
        d = null !== b && void 0 !== b ? b : [];

    c = function (g, l, m) {
      function q(k, h) {
        k = y.getApplicableContexts(k);
        var t = [];
        h && h.length && t.push.apply(t, h);
        k && k.length && t.push.apply(t, k);
        return t;
      }

      var r = Pf(l),
          y = Nf(),
          w = g,
          u = {};
      return {
        track: function track(k, h, t) {
          k.withJsonProcessor(Mf(w));
          k.add("eid", qb.v4());
          k.addDict(u);
          t = Vf(t);
          k.add(t.type, t.value.toString());
          h = q(k, r.addPluginContexts(h));
          h = h && h.length ? {
            sc: "sp/ctx/1-0-0",
            dt: h
          } : void 0;
          void 0 !== h && k.addJson("cx", "co", h);
          l.forEach(function (v) {
            try {
              v.beforeTrack && v.beforeTrack(k);
            } catch (E) {
              Pa.error("Plugin beforeTrack", E);
            }
          });
          "function" === typeof m && m(k);
          var x = k.build();
          l.forEach(function (v) {
            try {
              v.afterTrack && v.afterTrack(x);
            } catch (E) {
              Pa.error("Plugin afterTrack", E);
            }
          });
          return x;
        },
        addPayloadPair: function addPayloadPair(k, h) {
          u[k] = h;
        },
        configuration: a,
        getConfig: function getConfig() {
          return a;
        },
        setConfig: function setConfig(k) {
          k && ("undefined" !== typeof k.base64 && (w = a.base64 = k.base64), "undefined" !== typeof k.linkClickTracking && (a.linkClickTracking = k.linkClickTracking), "undefined" !== typeof k.lifecycleAutotracking && (a.lifecycleAutotracking = k.lifecycleAutotracking), "undefined" !== typeof k.cacheRefreshInterval && (a.cacheRefreshInterval = k.cacheRefreshInterval), "undefined" !== typeof k.buttonClickTracking && (a.buttonClickTracking = k.buttonClickTracking), "undefined" !== typeof k.customEvent && (a.customEvent = k.customEvent), "undefined" !== typeof k.exceptionAutotracking && (a.exceptionAutotracking = k.exceptionAutotracking), "undefined" !== typeof k.enablePeriodicHeartbeat && (a.enablePeriodicHeartbeat = k.enablePeriodicHeartbeat), "undefined" !== typeof k.periodicHeartbeatInterval && (a.periodicHeartbeatInterval = k.periodicHeartbeatInterval), "undefined" !== typeof k.enc && (a.enc = k.enc), "undefined" !== typeof k.mend && (a.mend = k.mend), "undefined" !== typeof k.maxLocalStorageQueueSize && (a.maxLocalStorageQueueSize = k.maxLocalStorageQueueSize), "undefined" !== typeof k.maxPostBytes && (a.maxPostBytes = k.maxPostBytes), "undefined" !== typeof k.maxGetBytes && (a.maxGetBytes = k.maxGetBytes), "undefined" !== typeof k.bufferSize && (a.bufferSize = k.bufferSize), "undefined" !== typeof k.customEventTrackingConfiguration && (a.customEventTrackingConfiguration = k.customEventTrackingConfiguration), "undefined" !== typeof k.convivaVideoEventTrackingConfiguration && (a.convivaVideoEventTrackingConfiguration = k.convivaVideoEventTrackingConfiguration), "undefined" !== typeof k.ajaxTrackingConfiguration && (a.ajaxTrackingConfiguration = k.ajaxTrackingConfiguration), "undefined" !== typeof k.networkRequestTrackingConfiguration && (a.networkRequestTrackingConfiguration = k.networkRequestTrackingConfiguration), "undefined" !== typeof k.traceparentconfig && (a.traceparentconfig = k.traceparentconfig), "undefined" !== typeof k.metaTagsTrackingConfiguration && (a.metaTagsTrackingConfiguration = k.metaTagsTrackingConfiguration), "undefined" !== typeof k.performanceContextConfig && (a.performanceContextConfig = k.performanceContextConfig));
        },
        getBase64Encoding: function getBase64Encoding() {
          return w;
        },
        setBase64Encoding: function setBase64Encoding(k) {
          w = k;
        },
        addPayloadDict: function addPayloadDict(k) {
          for (var h in k) {
            Object.prototype.hasOwnProperty.call(k, h) && (u[h] = k[h]);
          }
        },
        resetPayloadPairs: function resetPayloadPairs(k) {
          u = oe(k) ? k : {};
        },
        setTrackerVersion: function setTrackerVersion(k) {
          u.tv = k;
        },
        setTrackerNamespace: function setTrackerNamespace(k) {
          u.tna = k;
        },
        setAppId: function setAppId(k) {
          u.aid = k;
        },
        setPlatform: function setPlatform(k) {
          u.p = k;
        },
        setUserId: function setUserId(k) {
          u.uid = k;
        },
        setScreenResolution: function setScreenResolution(k, h) {
          u.res = k + "x" + h;
        },
        setViewport: function setViewport(k, h) {
          u.vp = k + "x" + h;
        },
        setColorDepth: function setColorDepth(k) {
          u.cd = k;
        },
        setTimezone: function setTimezone(k) {
          u.tz = k;
        },
        setLang: function setLang(k) {
          u.lang = k;
        },
        setIpAddress: function setIpAddress(k) {
          u.ip = k;
        },
        setUseragent: function setUseragent(k) {
          u.ua = k;
        },
        addGlobalContexts: function addGlobalContexts(k) {
          y.addGlobalContexts(k);
        },
        clearGlobalContexts: function clearGlobalContexts() {
          y.clearGlobalContexts();
        },
        removeGlobalContexts: function removeGlobalContexts(k) {
          y.removeGlobalContexts(k);
        }
      };
    }(null !== c && void 0 !== c ? c : !0, d, a.callback);

    var f = _ha(_ha({}, c), {
      addPlugin: function addPlugin(g) {
        var l, m;
        g = g.plugin;
        d.push(g);
        null === (l = g.logger) || void 0 === l ? void 0 : l.call(g, Pa);
        null === (m = g.activateCorePlugin) || void 0 === m ? void 0 : m.call(g, f);
      }
    });

    null === d || void 0 === d ? void 0 : d.forEach(function (g) {
      var l, m;
      null === (l = g.logger) || void 0 === l ? void 0 : l.call(g, Pa);
      null === (m = g.activateCorePlugin) || void 0 === m ? void 0 : m.call(g, f);
    });
    return f;
  }

  function zb(a) {
    var c = a.event;
    a = c.sc;
    var b = c.dt;
    c = xc();
    a = {
      sc: "sp/ue/1-0-0",
      dt: {
        sc: a,
        dt: b
      }
    };
    c.add("e", "ue");
    c.addJson("ue_px", "ue_pr", a);
    return c;
  }

  function Xf(a) {
    var c = a.pageUrl,
        b = a.pageTitle;
    a = a.referrer;
    var d = xc();
    d.add("e", "pv");
    d.add("url", c);
    d.add("page", b);
    d.add("refr", a);
    return d;
  }

  function Yf(a) {
    return zb({
      event: {
        sc: "cv/re/1-0-1",
        dt: Ob({
          name: a.name,
          data: a.data
        })
      }
    });
  }

  function Zf(a) {
    return zb({
      event: {
        sc: "cv/ve/1-0-5",
        dt: Ob({
          name: a.name,
          sid: a.sid,
          iid: a.iid,
          clid: a.clid,
          st: a.st,
          cen: a.cen,
          ced: a.ced,
          an: a.an
        })
      }
    });
  }

  function Ob(a, c) {
    void 0 === c && (c = {});
    var b = {},
        d;

    for (d in a) {
      if (c[d] || null !== a[d] && "undefined" !== typeof a[d]) b[d] = a[d];
    }

    return b;
  }

  function Pb(a) {
    var c = a.length;

    for (; 0 <= --c;) {
      a[c] = 0;
    }
  }

  function ad(a, c, b, d, f) {
    this.static_tree = a;
    this.extra_bits = c;
    this.extra_base = b;
    this.elems = d;
    this.max_length = f;
    this.has_stree = a && a.length;
  }

  function bd(a, c) {
    this.dyn_tree = a;
    this.max_code = 0;
    this.stat_desc = c;
  }

  function bb(a, c, b, d, f) {
    this.good_length = a;
    this.max_lazy = c;
    this.nice_length = b;
    this.max_chain = d;
    this.func = f;
  }

  function $f() {
    this.strm = null;
    this.status = 0;
    this.pending_buf = null;
    this.wrap = this.pending = this.pending_out = this.pending_buf_size = 0;
    this.gzhead = null;
    this.gzindex = 0;
    this.method = Ac;
    this.last_flush = -1;
    this.w_mask = this.w_bits = this.w_size = 0;
    this.window = null;
    this.window_size = 0;
    this.head = this.prev = null;
    this.nice_match = this.good_match = this.strategy = this.level = this.max_lazy_match = this.max_chain_length = this.prev_length = this.lookahead = this.match_start = this.strstart = this.match_available = this.prev_match = this.match_length = this.block_start = this.hash_shift = this.hash_mask = this.hash_bits = this.hash_size = this.ins_h = 0;
    this.dyn_ltree = new Uint16Array(1146);
    this.dyn_dtree = new Uint16Array(122);
    this.bl_tree = new Uint16Array(78);
    rb(this.dyn_ltree);
    rb(this.dyn_dtree);
    rb(this.bl_tree);
    this.bl_desc = this.d_desc = this.l_desc = null;
    this.bl_count = new Uint16Array(16);
    this.heap = new Uint16Array(573);
    rb(this.heap);
    this.heap_max = this.heap_len = 0;
    this.depth = new Uint16Array(573);
    rb(this.depth);
    this.bi_valid = this.bi_buf = this.insert = this.matches = this.static_len = this.opt_len = this.sym_end = this.sym_next = this.lit_bufsize = this.sym_buf = 0;
  }

  function ac(a) {
    a = this.options = Bc.assign({
      level: ag,
      method: bg,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: cg
    }, a || {});
    a.raw && 0 < a.windowBits ? a.windowBits = -a.windowBits : a.gzip && 0 < a.windowBits && 16 > a.windowBits && (a.windowBits += 16);
    this.err = 0;
    this.msg = "";
    this.ended = !1;
    this.chunks = [];
    this.strm = new xe();
    this.strm.avail_out = 0;
    var c = bc.deflateInit2(this.strm, a.level, a.method, a.windowBits, a.memLevel, a.strategy);
    if (c !== Cc) throw Error(Ab[c]);
    a.header && bc.deflateSetHeader(this.strm, a.header);

    if (a.dictionary) {
      a = "string" === typeof a.dictionary ? cc.string2buf(a.dictionary) : "[object ArrayBuffer]" === ye.call(a.dictionary) ? new Uint8Array(a.dictionary) : a.dictionary;
      c = bc.deflateSetDictionary(this.strm, a);
      if (c !== Cc) throw Error(Ab[c]);
      this._dict_set = !0;
    }
  }

  function cd(a, c) {
    c = new ac(c);
    c.push(a, !0);
    if (c.err) throw c.msg || Ab[c.err];
    return c.result;
  }

  function dg() {
    this.strm = null;
    this.mode = 0;
    this.last = !1;
    this.wrap = 0;
    this.havedict = !1;
    this.total = this.check = this.dmax = this.flags = 0;
    this.head = null;
    this.wnext = this.whave = this.wsize = this.wbits = 0;
    this.window = null;
    this.extra = this.offset = this.length = this.bits = this.hold = 0;
    this.distcode = this.lencode = null;
    this.have = this.ndist = this.nlen = this.ncode = this.distbits = this.lenbits = 0;
    this.next = null;
    this.lens = new Uint16Array(320);
    this.work = new Uint16Array(288);
    this.distdyn = this.lendyn = null;
    this.was = this.back = this.sane = 0;
  }

  function dc(a) {
    var c = this.options = Bc.assign({
      chunkSize: 65536,
      windowBits: 15,
      to: ""
    }, a || {});
    c.raw && 0 <= c.windowBits && 16 > c.windowBits && (c.windowBits = -c.windowBits, 0 === c.windowBits && (c.windowBits = -15));
    !(0 <= c.windowBits && 16 > c.windowBits) || a && a.windowBits || (c.windowBits += 32);
    15 < c.windowBits && 48 > c.windowBits && 0 === (c.windowBits & 15) && (c.windowBits |= 15);
    this.err = 0;
    this.msg = "";
    this.ended = !1;
    this.chunks = [];
    this.strm = new xe();
    this.strm.avail_out = 0;
    a = kb.inflateInit2(this.strm, c.windowBits);
    if (a !== ec) throw Error(Ab[a]);
    this.header = new eg();
    kb.inflateGetHeader(this.strm, this.header);
    if (c.dictionary && ("string" === typeof c.dictionary ? c.dictionary = cc.string2buf(c.dictionary) : "[object ArrayBuffer]" === ze.call(c.dictionary) && (c.dictionary = new Uint8Array(c.dictionary)), c.raw && (a = kb.inflateSetDictionary(this.strm, c.dictionary), a !== ec))) throw Error(Ab[a]);
  }

  function dd(a, c) {
    c = new dc(c);
    c.push(a);
    if (c.err) throw c.msg || Ab[c.err];
    return c.result;
  }

  function Ae(a) {
    return Number.isInteger && Number.isInteger(a) || "number" === typeof a && isFinite(a) && Math.floor(a) === a;
  }

  function ed(a) {
    if (!a || "string" !== typeof a.valueOf()) {
      a = a.text || "";
      var c = document.getElementsByTagName("title");
      c && null != c[0] && (a = c[0].text);
    }

    return a;
  }

  function fd(a) {
    var c = /^(?:(?:https?|ftp):)\/*(?:[^@]+@)?([^:/#]+)/.exec(a);
    return c ? c[1] : a;
  }

  function Be(a) {
    var c = a.length;
    "." === a.charAt(--c) && (a = a.slice(0, c));
    "*." === a.slice(0, 2) && (a = a.slice(1));
    return a;
  }

  function gd(a) {
    var c = window,
        b = fc("referrer", c.location.href) || fc("referer", c.location.href);
    if (b) return b;
    if (a) return a;

    try {
      if (c.top) return c.top.document.referrer;
      if (c.parent) return c.parent.document.referrer;
    } catch (d) {}

    return document.referrer;
  }

  function sb(a, c, b, d) {
    if (a.addEventListener) return a.addEventListener(c, b, d), !0;
    if (a.attachEvent) return a.attachEvent("on" + c, b);
    a["on" + c] = b;
  }

  function fc(a, c) {
    return (a = new RegExp("^[^#]*[?&]" + a + "=([^&#]*)").exec(c)) ? decodeURIComponent(a[1].replace(/\+/g, " ")) : null;
  }

  function Dc(a, c, b) {
    void 0 === b && (b = 63072E3);

    try {
      var d = window.localStorage,
          f = Date.now() + 1E3 * b;
      d.setItem("".concat(a, ".expires"), f.toString());
      d.setItem(a, c);
      return !0;
    } catch (g) {
      return !1;
    }
  }

  function Ce(a) {
    try {
      var c = window.localStorage;
      c.removeItem(a);
      c.removeItem(a + ".expires");
      return !0;
    } catch (b) {
      return !1;
    }
  }

  function fg(a, c) {
    for (var b = window.location.hostname, d = "_sp_root_domain_test_" + new Date().getTime(), f = "_test_value_" + new Date().getTime(), g = b.split("."), l = g.length - 1; 0 <= l;) {
      var m = g.slice(l, g.length).join(".");
      cb(d, f, 0, "/", m, a, c);

      if (cb(d) === f) {
        cb(d, "", -1, "/", m, a, c);
        b = document.cookie.split("; ");
        d = [];

        for (f = 0; f < b.length; f++) {
          "_sp_root_domain_test_" === b[f].substring(0, 21) && d.push(b[f]);
        }

        b = d;

        for (d = 0; d < b.length; d++) {
          cb(b[d], "", -1, "/", m, a, c);
        }

        return m;
      }

      --l;
    }

    return b;
  }

  function cb(a, c, b, d, f, g, l) {
    return 1 < arguments.length ? document.cookie = a + "=" + encodeURIComponent(null !== c && void 0 !== c ? c : "") + (b ? "; Expires=" + new Date(+new Date() + 1E3 * b).toUTCString() : "") + (d ? "; Path=" + d : "") + (f ? "; Domain=" + f : "") + (g ? "; SameSite=" + g : "") + (l ? "; Secure" : "") : decodeURIComponent((("; " + document.cookie).split("; " + a + "=")[1] || "").split(";")[0]);
  }

  function gg(a, c) {
    var b = [qa.request_body, qa.response_body, qa.request_headers, qa.response_headers],
        d = {};
    if (c && 0 < c.length) for (var f = 0; f < c.length; f++) {
      var g = c[f],
          l = g.conditions;
      var m = void 0;
      var q = ["conditions"],
          r = {};

      for (m in g) {
        Object.prototype.hasOwnProperty.call(g, m) && 0 > q.indexOf(m) && (r[m] = g[m]);
      }

      if (null != g && "function" === typeof Object.getOwnPropertySymbols) {
        var y = 0;

        for (m = Object.getOwnPropertySymbols(g); y < m.length; y++) {
          0 > q.indexOf(m[y]) && Object.prototype.propertyIsEnumerable.call(g, m[y]) && (r[m[y]] = g[m[y]]);
        }
      }

      m = r;

      try {
        a: {
          g = a;

          try {
            for (q = 0; q < l.length; q++) {
              var w = l[q];
              r = !1;

              if (0 < Object.keys(w).length) {
                y = 0;

                for (var u = Object.entries(w); y < u.length; y++) {
                  var k = u[y],
                      h = k[1],
                      t = g[k[0]];

                  if (0 < h.length) {
                    for (var x = 0, v = 0, E = h; v < E.length; v++) {
                      var F = E[v],
                          V = "contains",
                          ca = F;
                      if ("object" === _typeof(F) && F.length) V = F[1], ca = F[0];else if ("boolean" === typeof F || null === F) V = "equal", ca = F;

                      if (hg(t, V, ca)) {
                        r = !0;
                        break;
                      } else if (r = !1, x + 1 === h.length) break;

                      x++;
                    }

                    if (!1 === r) break;
                  }
                }
              }

              if (r) {
                var G = !0;
                break a;
              }
            }
          } catch (Ja) {
            console.warn("Conviva App Tracker: Error in Applying nwreqConfig ".concat(Ja));
          }

          G = !1;
        }

        if (G) {
          g = 0;

          for (var K = Object.entries(a); g < K.length; g++) {
            var ka = K[g],
                ma = ka[0],
                ia = ka[1];
            if (b.includes(ma)) try {
              if (m[ma] && 0 < m[ma].length) {
                q = !1;
                if (ma === qa.response_headers || ma === qa.request_headers) q = !0;
                var ja = a[ma];
                l = {};

                try {
                  r = 0;

                  for (var X = m[ma]; r < X.length; r++) {
                    var R = X[r];
                    y = ja;
                    x = l;
                    q && (R = R.toLowerCase());
                    var Aa = R.split(".");

                    for (v = 0; v < Aa.length; v++) {
                      var Z = Aa[v];
                      "undefined" !== typeof y && null !== y && y.hasOwnProperty(Z) && (v === Aa.length - 1 ? x[Z] = y[Z] : (x[Z] = x[Z] || {}, y = y[Z], x = x[Z]));
                    }
                  }
                } catch (Ja) {
                  console.warn("Conviva App Tracker: Error in filtering schema object nwreq ".concat(Ja));
                }

                var Y = l;
                0 !== Object.keys(Y).length && (d[ma] = Y);
              }
            } catch (Ja) {
              d[ma] = void 0;
            } else d[ma] = ia;
          }

          return d;
        }
      } catch (Ja) {
        console.warn("Conviva App Tracker: Error in collecting attributes nwreqConfig ".concat(Ja));
      }
    }
    d = _ha({}, a);

    for (a = 0; a < b.length; a++) {
      c = b[a], "undefined" !== typeof d && null !== d && d.hasOwnProperty(c) && delete d[c];
    }

    return d;
  }

  function hg(a, c, b) {
    try {
      if ("string" === typeof b && "string" === typeof a && "*" === b.trim()) return !0;

      switch (c) {
        case "==":
        case "equal":
          return a === b;

        case "!=":
          return a !== b;

        case ">":
          return a > b;

        case "<":
          return a < b;

        case ">=":
          return a >= b;

        case "<=":
          return a <= b;

        case "contains":
          return "" !== b && "string" === typeof a && "string" === typeof b && -1 !== a.toLowerCase().indexOf(b.toLowerCase());

        default:
          return !1;
      }
    } catch (d) {
      return console.warn("Conviva App Tracker: Error in Compare values nwreq ".concat(d)), !1;
    }
  }

  function ig() {
    try {
      var a = !!window.localStorage;
    } catch (b) {
      a = !0;
    }

    if (!a) return !1;

    try {
      var c = window.localStorage;
      c.setItem("modernizr", "modernizr");
      c.removeItem("modernizr");
      return !0;
    } catch (b) {
      return !1;
    }
  }

  function jg(a, c, b, d, f, g, l, m, q, r, y, w, u, k, h, t, x) {
    function v(B) {
      var Q = Object.keys(B).map(function (N) {
        return [N, B[N]];
      }).reduce(function (N, L) {
        N[L[0]] = L[1].toString();
        return N;
      }, {});
      return {
        evt: Q,
        bytes: E(JSON.stringify(Q))
      };
    }

    function E(B) {
      for (var Q = 0, N = 0; N < B.length; N++) {
        var L = B.charCodeAt(N);
        127 >= L ? Q += 1 : 2047 >= L ? Q += 2 : 55296 <= L && 57343 >= L ? (Q += 4, N++) : Q = 65535 > L ? Q + 3 : Q + 4;
      }

      return Q;
    }

    function F(B, Q) {
      Q = ca(Q, !0, !1);
      B = G(K([B.evt]));

      try {
        "none" !== x().toLowerCase() && (B = De.gzip(B, {
          level: 6
        }), Q.setRequestHeader("Content-Encoding", "gzip"));
      } catch (N) {}

      Q.send(B);
    }

    function V(B) {
      for (void 0 === B && (B = !1); X.length && "string" !== typeof X[0] && "object" !== _typeof(X[0]);) {
        X.shift();
      }

      if (1 > X.length) ia = !1;else {
        if (!ja || "string" !== typeof ja.valueOf()) throw "No collector configured";
        ia = !0;

        if (Z) {
          var Q = function Q(na) {
            for (var db = 0, Bb = 0; db < na.length && !(Bb += na[db].bytes, Bb >= l());) {
              db += 1;
            }

            return db;
          },
              N = void 0;

          if (Qb(X)) {
            N = ja;
            var L = ca(N, !0, B);
            var ea = Q(X);
          } else N = ka(X[0]), L = ca(N, !1, B), ea = 1;

          var ua = setTimeout(function () {
            L.abort();
            ia = !1;
          }, y),
              eb = function eb(na) {
            for (var db = 0; db < na; db++) {
              X.shift();
            }

            b && Dc(Cb, JSON.stringify(X.slice(-1 * r())));
          };

          L.onreadystatechange = function () {
            if (4 === L.readyState && 200 <= L.status) if (clearTimeout(ua), 300 > L.status) eb(ea), V();else {
              var na = L.status;
              na = 200 <= na && 300 > na ? !1 : h.includes(na) ? !0 : !t.includes(na);
              na || (Pa.error("Status ".concat(L.status, ", will not retry.")), eb(ea));
              ia = !1;
            }
          };

          if (Qb(X)) {
            if (Q = X.slice(0, ea), 0 < Q.length) {
              B = !1;
              Q = Q.map(function (na) {
                return na.evt;
              });

              if (Aa) {
                var hd = new Blob([G(K(Q))], {
                  type: "application/json"
                });

                try {
                  B = navigator.sendBeacon(N, hd);
                } catch (na) {
                  B = !1;
                }
              }

              if (!0 === B) eb(ea), V();else {
                N = G(K(Q));

                try {
                  "none" !== x().toLowerCase() && (N = De.gzip(N, {
                    level: 6
                  }), L.setRequestHeader("Content-Encoding", "gzip"));
                } catch (na) {}

                L.send(N);
              }
            }
          } else L.send();
        } else if (w || Qb(X)) ia = !1;else {
          N = new Image(1, 1);
          var tb = !0;

          N.onload = function () {
            tb && (tb = !1, X.shift(), b && Dc(Cb, JSON.stringify(X.slice(-1 * r()))), V());
          };

          N.onerror = function () {
            tb && (ia = tb = !1);
          };

          N.src = ka(X[0]);
          setTimeout(function () {
            tb && ia && (tb = !1, V());
          }, y);
        }
      }
    }

    function ca(B, Q, N) {
      var L = new XMLHttpRequest();
      Q ? (L.open("POST", B, !N), L.setRequestHeader("Content-Type", "application/json; charset=UTF-8")) : L.open("GET", B, !N);
      L.withCredentials = k;
      w && L.setRequestHeader("SP-Anonymous", "*");

      for (var ea in u) {
        Object.prototype.hasOwnProperty.call(u, ea) && L.setRequestHeader(ea, u[ea]);
      }

      return L;
    }

    function G(B) {
      return JSON.stringify({
        sc: "sp/pd/1-0-4",
        dt: B
      });
    }

    function K(B) {
      for (var Q = new Date().getTime().toString(), N = 0; N < B.length; N++) {
        B[N].stm = Q;
      }

      return B;
    }

    function ka(B) {
      return q ? ja + B.replace("?", "?stm=" + new Date().getTime() + "&") : ja + B;
    }

    function ma(B) {
      function Q(L, ea, ua) {
        return (ua = ua.match("(Macintosh;.*Mac OS X (d+)_(d+)[_d]*.*) AppleWebKit/")) && ua.length ? parseInt(ua[0]) <= L || parseInt(ua[0]) === L && parseInt(ua[1]) <= ea : !1;
      }

      function N(L) {
        return L.match("Version/.* Safari/") && !L.match("Chrom(e|ium)");
      }

      return function (L, ea) {
        return (ea = ea.match("(iP.+; CPU .*OS (d+)[_d]*.*) AppleWebKit/")) && ea.length ? parseInt(ea[0]) <= L : !1;
      }(13, B) || Q(10, 15, B) && N(B);
    }

    var ia = !1,
        ja,
        X = [];
    d = "string" === typeof d ? d.toLowerCase() : d;
    var R = !0 === d || "beacon" === d || "true" === d,
        Aa = !(!(R && window.navigator && window.navigator.sendBeacon) || ma(window.navigator.userAgent)) && R,
        Z = !!(window.XMLHttpRequest && "withCredentials" in new XMLHttpRequest()),
        Y = "get" !== d && Z && ("post" === d || R),
        Ja = Y ? f : "/i",
        Cb = "snowplowOutQueue_".concat(a, "_").concat(Y ? "post2" : "get");
    R && (u = {});
    g = b && ig() && Y && g || 1;
    if (b) try {
      var gc = window.localStorage.getItem(Cb);
      X = gc ? JSON.parse(gc) : [];
    } catch (B) {}
    Array.isArray(X) || (X = []);
    c.outQueues.push(X);
    Z && 1 < g && c.bufferFlushers.push(function (B) {
      ia || V(B);
    });

    var Qb = function Qb(B) {
      return "object" === _typeof(B[0]);
    };

    return {
      enqueueRequest: function enqueueRequest(B, Q) {
        ja = Q + Ja;

        if (Y) {
          B = v(B);
          Q = l();

          if (B.bytes >= Q) {
            Pa.warn("Event (" + B.bytes + "B) too big, max is " + Q);
            F(B, ja);
            return;
          }

          X.push(B);
        } else {
          var N = "?";
          var L = {
            co: !0,
            cx: !0
          },
              ea = !0,
              ua;

          for (ua in B) {
            B.hasOwnProperty(ua) && !L.hasOwnProperty(ua) && (ea ? ea = !1 : N += "&", N += encodeURIComponent(ua) + "=" + encodeURIComponent(B[ua]));
          }

          for (var eb in L) {
            B.hasOwnProperty(eb) && L.hasOwnProperty(eb) && (N += "&" + eb + "=" + encodeURIComponent(B[eb]));
          }

          L = m();

          if (0 < L && (ea = ka(N), ea = E(ea), ea >= L)) {
            Pa.warn("Event (" + ea + "B) too big, max is " + L);
            Z && (B = v(B), F(B, Q + f));
            return;
          }

          X.push(N);
        }

        Q = !1;
        b && (Q = Dc(Cb, JSON.stringify(X.slice(-1 * r()))));
        ia || Q && !(X.length >= g) || V();
      },
      executeQueue: function executeQueue() {
        ia || V();
      },
      setUseLocalStorage: function setUseLocalStorage(B) {
        b = B;
      },
      setAnonymousTracking: function setAnonymousTracking(B) {
        w = B;
      },
      setCollectorUrl: function setCollectorUrl(B) {
        ja = B + Ja;
      },
      setBufferSize: function setBufferSize(B) {
        g = B;
      },
      setCustomHeaders: function setCustomHeaders(B) {
        u = B;
      }
    };
  }

  function Ee(a, c, b) {
    if ("translate.googleusercontent.com" === a) "" === b && (b = c), a = (a = /^(?:https?|ftp)(?::\/*(?:[^?]+))([?][^#]+)/.exec(c)) && 1 < (null === a || void 0 === a ? void 0 : a.length) ? fc("u", a[1]) : null, c = null !== a && void 0 !== a ? a : "", a = fd(c);else if ("cc.bingj.com" === a || "webcache.googleusercontent.com" === a) c = document.links[0].href, a = fd(c);
    return [a, c, b];
  }

  function kg(a, c, b, d) {
    var f = Math.round(new Date().getTime() / 1E3);
    a ? (a = a.split("."), a.unshift("0")) : a = ["1", c, f, d, f, "", b];
    a[6] && "undefined" !== a[6] || (a[6] = qb.v4());
    a[7] && "undefined" !== a[7] || (a[7] = "");
    a[8] && "undefined" !== a[8] || (a[8] = "");
    a[9] && "undefined" !== a[9] || (a[9] = "");
    a[10] && "undefined" !== a[10] || (a[10] = -1);

    var g = function g(l, m) {
      l = parseInt(l);
      return isNaN(l) ? m : l;
    };

    c = function c(l) {
      return l ? g(l, void 0) : void 0;
    };

    return [a[0], a[1], g(a[2], f), g(a[3], d), g(a[4], f), c(a[5]), a[6], a[7], a[8], c(a[9]), g(a[10], -1)];
  }

  function hc(a, c) {
    void 0 === c && (c = 1);
    "0" === a[0] ? (a[7] = a[6], a[5] = a[4], a[3]++) : a[3] = c;
    c = qb.v4();
    a[6] = c;
    a[10] = -1;
    a[8] = "";
    a[9] = void 0;
    return c;
  }

  function id(a) {
    a[4] = Math.round(new Date().getTime() / 1E3);
  }

  function jd(a) {
    function c() {
      var d, f, g;

      try {
        var l = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance || {};

        if (l.getEntriesByType) {
          var m = l.getEntriesByType("navigation")[0],
              q = null !== (d = null === l || void 0 === l ? void 0 : l.timeOrigin) && void 0 !== d ? d : 0;
          if (!m) return [];
          var r = {
            st: Math.floor(q + m.startTime),
            dls: Math.floor(q + m.domainLookupStart),
            dle: Math.floor(q + m.domainLookupEnd),
            rss: Math.floor(q + m.responseStart),
            rse: Math.floor(q + m.responseEnd),
            le: Math.floor(q + m.loadEventEnd),
            dur: Math.floor(q + m.duration),
            as: Math.floor(q + m.activationStart)
          };
          if (null === da || void 0 === da ? 0 : da.startTime) r.lcp = {
            rt: Math.floor(q + da.startTime),
            url: 128 < (null === (f = null === da || void 0 === da ? void 0 : da.url) || void 0 === f ? void 0 : f.length) ? null === (g = null === da || void 0 === da ? void 0 : da.url) || void 0 === g ? void 0 : g.substring(0, 128) : da.url,
            sz: da.size
          };
          return [{
            schema: "iglu:com.conviva/performance_context/jsonschema/1-0-1",
            data: r
          }];
        }

        return [];
      } catch (y) {
        return console.warn("ConvivaAppTracker: issue will getting performance Navigation timing context"), [];
      }
    }

    function b() {
      return {
        contexts: function contexts() {
          var d, f, g;

          try {
            if ("undefined" != typeof (null === da || void 0 === da ? void 0 : da.startTime) && "number" === typeof (null === da || void 0 === da ? void 0 : da.startTime)) return [{
              schema: "iglu:com.conviva/largestContentfulPaint/jsonschema/1-0-0",
              data: {
                lcp: Math.round(da.startTime) - (null !== (d = da.performanceNavigationActivationStart) && void 0 !== d ? d : 0),
                url: 128 < (null === (f = null === da || void 0 === da ? void 0 : da.url) || void 0 === f ? void 0 : f.length) ? null === (g = null === da || void 0 === da ? void 0 : da.url) || void 0 === g ? void 0 : g.substring(0, 128) : da.url
              }
            }];
          } catch (l) {}

          return [];
        }
      };
    }

    return {
      activateLCPObserver: function activateLCPObserver() {
        try {
          PerformanceObserver && new PerformanceObserver(function (d) {
            try {
              d.getEntries().forEach(function (f) {
                var g;

                if ("largest-contentful-paint" === f.entryType) {
                  var l = null === performance || void 0 === performance ? void 0 : performance.getEntriesByType("navigation"),
                      m = void 0;
                  l && 0 < (null === l || void 0 === l ? void 0 : l.length) && (m = null === (g = l[0]) || void 0 === g ? void 0 : g.activationStart);
                  da = _ha(_ha({}, f.toJSON()), {
                    performanceNavigationActivationStart: null !== m && void 0 !== m ? m : 0
                  });
                }
              });
            } catch (f) {
              console.warn("convivaAppTracker error in conviva lcp observer " + f);
            }
          }).observe({
            type: "largest-contentful-paint",
            buffered: !0
          });
        } catch (d) {
          console.warn("convivaAppTracker conviva_lcp failed " + d);
        }
      },
      contexts: function contexts() {
        try {
          switch (a) {
            case aa.PERFORMANCE_CONTEXT.DISABLED:
              return [];

            case aa.PERFORMANCE_CONTEXT.PERFORMANCE_NAVIGATION_TIMING:
              return c();

            default:
              var d = window,
                  f = d.performance || d.mozPerformance || d.msPerformance || d.webkitPerformance,
                  g = f.timing;
              var l = f ? [{
                sc: "w3/pt/1-0-0",
                dt: {
                  navigationStart: g.navigationStart,
                  domainLookupStart: g.domainLookupStart,
                  domainLookupEnd: g.domainLookupEnd,
                  responseStart: g.responseStart,
                  responseEnd: g.responseEnd,
                  loadEventEnd: g.loadEventEnd
                }
              }] : [];
              return fa(fa([], l, !0), b().contexts(), !0);
          }
        } catch (m) {
          return console.warn("convivaAppTracker problem in perfromance context " + m), [];
        }
      }
    };
  }

  function lg(a, c, b, d, f, g) {
    function l(r, y) {
      return fa(fa([], r, !0), y, !0).reduce(function (w, u) {
        var k = w.find(function (h) {
          return h.key === u.key;
        });
        k ? u.condition && (k.condition = fa(fa([], k.condition || [], !0), u.condition, !0)) : w.push(_ha({}, u));
        return w;
      }, []);
    }

    void 0 === g && (g = {});
    var m = [];

    a = function (r, y, w, u, k, h) {
      function t() {
        Db = Ee(window.location.hostname, window.location.href, gd());
        Db[1] !== ub && (ic = gd(ub));
        Fe = Be(Db[0]);
        ub = Db[1];
      }

      function x(e) {
        try {
          var n = new Date().getTime(),
              p = e.currentTarget;

          if (null === p || void 0 === p ? 0 : p.href) {
            e = "_sp=" + (Ec + "." + n);
            var z = p.href.split("#"),
                A = z[0].split("?"),
                C = A.shift(),
                I = A.join("?");

            if (I) {
              A = !0;
              var S = I.split("&");

              for (n = 0; n < S.length; n++) {
                if ("_sp=" === S[n].substr(0, 4)) {
                  A = !1;
                  S[n] = e;
                  I = S.join("&");
                  break;
                }
              }

              A && (I = e + "&" + I);
            } else I = e;

            z[0] = C + "?" + I;
            var J = z.join("#");
            p.href = J;
          }
        } catch (D) {
          console.warn("Conviva App Tracker:: Error in linkDecorationHandler of decorateLinks ".concat(D));
        }
      }

      function v(e) {
        if ("undefined" != typeof document && document.links && 0 < document.links.length) for (var n = 0; n < document.links.length; n++) {
          var p = document.links[n];
          !p.spDecorationEnabled && e(p) && (sb(p, "click", x, !0), sb(p, "mousedown", x, !0), p.spDecorationEnabled = !0);
        }
      }

      function E(e) {
        if (Ge) {
          var n = /#.*/;
          e = e.replace(n, "");
        }

        He && (n = /[{}]/g, e = e.replace(n, ""));
        return e;
      }

      function F(e) {
        return (e = /^([a-z]+):/.exec(e)) ? e[1] : null;
      }

      function V(e) {
        e = Rb + e + "." + Eb;

        if ("localStorage" == oa) {
          try {
            var n = window.localStorage,
                p = n.getItem(e + ".expires");
            if (null === p || +p > Date.now()) var z = n.getItem(e);else n.removeItem(e), n.removeItem(e + ".expires"), z = void 0;
          } catch (A) {
            z = void 0;
          }

          return z;
        }

        if ("cookie" == oa || "cookieAndLocalStorage" == oa) return cb(e);
      }

      function ca() {
        t();
        Eb = mg((jc || Fe) + (kd || "/")).slice(0, 4);
      }

      function G() {
        ld = new Date().getTime();
      }

      function K() {
        var e = ka(),
            n = e[0];
        n < Fc ? Fc = n : n > Gc && (Gc = n);
        e = e[1];
        e < Hc ? Hc = e : e > Ic && (Ic = e);
        G();
      }

      function ka() {
        var e = "undefined" != typeof document ? null === document || void 0 === document ? void 0 : document.documentElement : void 0;
        return e ? [e.scrollLeft || window.pageXOffset, e.scrollTop || window.pageYOffset] : [0, 0];
      }

      function ma() {
        var e = ka(),
            n = e[0];
        Gc = Fc = n;
        Ic = Hc = e = e[1];
      }

      function ia() {
        X(Rb + "ses." + Eb, "*", Ie);
      }

      function ja(e) {
        var n = Rb + "id." + Eb;
        e.shift();
        e = e.join(".");
        X(n, e, Je);
      }

      function X(e, n, p) {
        if (!kc || Jc) "localStorage" == oa ? Dc(e, n, p) : ("cookie" == oa || "cookieAndLocalStorage" == oa) && cb(e, n, p, kd, jc, Kc, Lc);
      }

      function R(e) {
        var n = Rb + "id." + Eb,
            p = Rb + "ses." + Eb;
        Ce(n);
        Ce(p);
        cb(n, "", -1, "/", jc, Kc, Lc);
        cb(p, "", -1, "/", jc, Kc, Lc);
        null !== e && void 0 !== e && e.preserveSession || (Fb = qb.v4(), fb = 1);
        null !== e && void 0 !== e && e.preserveUser || (Ec = qb.v4(), Gb = null);
      }

      function Aa(e) {
        e && e.stateStorageStrategy && (h.stateStorageStrategy = e.stateStorageStrategy, oa = Ke(h));
        kc = !!h.anonymousTracking;
        Jc = Le(h);
        md = Me(h);
        lb.setUseLocalStorage("localStorage" == oa || "cookieAndLocalStorage" == oa);
        lb.setAnonymousTracking(md);
      }

      function Z() {
        try {
          var e = window.localStorage.getItem(nd + "." + od),
              n = JSON.parse(e || "{}");
          "{}" === n || "undefined" === typeof n ? (lc = B(), Mc = Q(), vb = -1) : (lc = n.clId || B(), vb = n[mc] && 2147483648 > n[mc] ? n[mc] : -1, Mc = Q());
          Qb();
        } catch (z) {
          console.warn(z);
        }

        if (!kc || Jc) {
          e = "none" != oa && !!V("ses");
          n = Y();
          if (n[1]) var p = n[1];else p = kc ? "" : qb.v4(), n[1] = p;
          Ec = p;
          Fb = e ? n[6] : hc(n);
          fb = n[3];
          "none" != oa && (ia(), id(n), ja(n));
        }
      }

      function Y() {
        if ("none" == oa) return ["1", "", 0, 0, 0, void 0, "", "", "", void 0, 0];
        var e = V("id") || void 0;
        return kg(e, Ec, Fb, fb);
      }

      function Ja(e, n) {
        var p,
            z,
            A,
            C,
            I = !0,
            S = Ka.getConfig();
        "undefined" !== typeof S.mend ? I = S.mend : "undefined" !== typeof (null === (z = null === (p = null === h || void 0 === h ? void 0 : h.configs) || void 0 === p ? void 0 : p.network) || void 0 === z ? void 0 : z.mergeEndpoint) && (I = null === (C = null === (A = null === h || void 0 === h ? void 0 : h.configs) || void 0 === A ? void 0 : A.network) || void 0 === C ? void 0 : C.mergeEndpoint);
        return 0 === e.indexOf("http") ? (n && I && (e = e.replace(/^(https?:\/\/)(.*)$/, "$1" + n + ".$2")), e) : n && I ? ("https:" === document.location.protocol ? "https" : "http") + "://" + n + "." + e : ("https:" === document.location.protocol ? "https" : "http") + "://" + e;
      }

      function Cb() {
        Ne && null != k.pageViewId || (k.pageViewId = qb.v4());
      }

      function gc() {
        null == k.pageViewId && (k.pageViewId = qb.v4());
        return k.pageViewId;
      }

      function Qb() {
        try {
          var e = window.localStorage,
              n = {
            clId: lc,
            iid: Mc,
            eventIndex: vb
          },
              p = null;

          try {
            p = JSON.stringify(n);
          } catch (z) {
            return;
          }

          return e.setItem(nd + "." + od, p);
        } catch (z) {}
      }

      function B() {
        try {
          return L({
            "First Launch": "Yes"
          }), Math.floor(2147483647 * Math.random()).toString() + "." + Math.floor(2147483647 * Math.random()).toString() + "." + Math.floor(2147483647 * Math.random()).toString() + "." + Math.floor(2147483647 * Math.random()).toString();
        } catch (e) {
          console.warn(e);
        }
      }

      function Q() {
        try {
          return Math.floor(2147483647 * Math.random());
        } catch (e) {
          return console.warn(e), -1;
        }
      }

      function N(e) {
        try {
          return "object" === _typeof(JSON.parse(e));
        } catch (n) {
          return !1;
        }
      }

      function L(e) {
        try {
          var n = Object.keys(e);
          N(JSON.stringify(e)) ? n.forEach(function (p) {
            "" !== p && Object.defineProperty(pd, p, {
              value: "" + e[p],
              writable: !0,
              enumerable: !0,
              configurable: !0
            });
          }) : console.warn("Conviva AppTracker:: Invalid JSON Format: Error Message=");
        } catch (p) {
          console.warn("Conviva AppTracker:: Invalid JSON Format: Error Message=", p);
        }
      }

      function ea(e) {
        try {
          e.forEach(function (n) {
            delete pd[n];
          });
        } catch (n) {
          console.warn("Conviva AppTracker:: Failed to unset Custom tag(s). Check format of keys set.");
        }
      }

      function ua(e) {
        try {
          var n = Object.keys(e);
          N(JSON.stringify(e)) ? n.forEach(function (p) {
            "" !== p && Object.defineProperty(qd, p, {
              value: "" + e[p],
              writable: !0,
              enumerable: !0,
              configurable: !0
            });
          }) : console.warn("Conviva AppTracker:: Invalid JSON Format: Error Message=");
        } catch (p) {
          console.warn("Conviva AppTracker:: Invalid JSON Format: Error Message=", p);
        }
      }

      function eb(e) {
        var n = e.title,
            p = e.context,
            z = e.timestamp;
        e = e.contextCallback;
        t();
        rd && Cb();
        rd = !0;
        wb = document.title;
        Sb = n;
        n = ed(Sb || wb);
        Ka.track(Xf({
          pageUrl: E(Tb || ub),
          pageTitle: n,
          referrer: E(Nc || ic)
        }), (p || []).concat(e ? e() : []), z);
        z = new Date();
        n = !1;

        if (La.enabled && !La.installed) {
          n = La.installed = !0;
          var A = {
            update: function update() {
              if ("undefined" !== typeof window && "function" === typeof window.addEventListener) {
                var I = !1,
                    S = Object.defineProperty({}, "passive", {
                  get: function get() {
                    I = !0;
                  },
                  set: function set() {}
                }),
                    J = function J() {};

                window.addEventListener("testPassiveEventSupport", J, S);
                window.removeEventListener("testPassiveEventSupport", J, S);
                A.hasSupport = I;
              }
            }
          };
          A.update();
          var C = "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll";
          Object.prototype.hasOwnProperty.call(A, "hasSupport") ? sb(document, C, G, {
            passive: !0
          }) : sb(document, C, G);
          ma();

          C = function C(I, S) {
            void 0 === S && (S = G);
            return function (J) {
              return sb(document, J, S);
            };
          };

          "click mouseup mousedown mousemove keypress keydown keyup".split(" ").forEach(C(document));
          ["resize", "focus", "blur"].forEach(C(window));
          C(window, K)("scroll");
        }

        if (La.enabled && (ng || n)) for (z in ld = z.getTime(), z = void 0, La.configurations) {
          if (n = La.configurations[z]) window.clearInterval(n.activityInterval), tb(n, p, e);
        }
      }

      function hd() {
        var e, n, p, z, A, C, I, S, J, D, ba, xa, Ba, Qa, Ra, Sa, Ta, Ua, Va, Wa, Xa, Ya, Za, $a, mb, ab, gb, hb, Ca, Ea, ya;

        try {
          var T = q.core.getConfig(),
              H = void 0;
          qd = {};
          var Ma = Ub.MERGE;
          "undefined" !== typeof (null === (n = null === (e = null === h || void 0 === h ? void 0 : h.configs) || void 0 === e ? void 0 : e.metaTagsTracking) || void 0 === n ? void 0 : n.preference) ? Ma = null === (z = null === (p = null === h || void 0 === h ? void 0 : h.configs) || void 0 === p ? void 0 : p.metaTagsTracking) || void 0 === z ? void 0 : z.preference : !0 === (null === (C = null === (A = null === h || void 0 === h ? void 0 : h.configs) || void 0 === A ? void 0 : A.metaTagsTracking) || void 0 === C ? void 0 : C.force) ? Ma = Ub.APP : "undefined" !== typeof (null === (I = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === I ? void 0 : I.pref) && (Ma = null === (S = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === S ? void 0 : S.pref);

          switch (Ma) {
            case Ub.APP:
              if (!1 === (null === (D = null === (J = null === h || void 0 === h ? void 0 : h.configs) || void 0 === J ? void 0 : J.metaTagsTracking) || void 0 === D ? void 0 : D.enabled)) return;
              0 < (null === (Ba = null === (xa = null === (ba = null === h || void 0 === h ? void 0 : h.configs) || void 0 === ba ? void 0 : ba.metaTagsTracking) || void 0 === xa ? void 0 : xa.tags) || void 0 === Ba ? void 0 : Ba.length) && (H = fa([], null === (Ra = null === (Qa = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Qa ? void 0 : Qa.metaTagsTracking) || void 0 === Ra ? void 0 : Ra.tags, !0));
              break;

            case Ub.REMOTE:
              if (!1 === (null === (Sa = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === Sa ? void 0 : Sa.enabled)) return;
              "undefined" != typeof (null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) && 0 < (null === (Ua = null === (Ta = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === Ta ? void 0 : Ta.tags) || void 0 === Ua ? void 0 : Ua.length) && (H = fa([], null === (Va = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === Va ? void 0 : Va.tags, !0));
              break;

            default:
              if ("undefined" == typeof (null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) && !1 === (null === (Xa = null === (Wa = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Wa ? void 0 : Wa.metaTagsTracking) || void 0 === Xa ? void 0 : Xa.enabled) || "undefined" == typeof (null === (Ya = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Ya ? void 0 : Ya.metaTagsTracking) && !1 === (null === (Za = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === Za ? void 0 : Za.enabled)) return;
              var ra = null === (mb = null === ($a = null === h || void 0 === h ? void 0 : h.configs) || void 0 === $a ? void 0 : $a.metaTagsTracking) || void 0 === mb ? void 0 : mb.tags,
                  la = null === (ab = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === ab ? void 0 : ab.tags;
              !1 === (null === (hb = null === (gb = null === h || void 0 === h ? void 0 : h.configs) || void 0 === gb ? void 0 : gb.metaTagsTracking) || void 0 === hb ? void 0 : hb.enabled) && (ra = []);
              !1 === (null === (Ca = null === T || void 0 === T ? void 0 : T.metaTagsTrackingConfiguration) || void 0 === Ca ? void 0 : Ca.enabled) && (la = []);
              H = fa([], l(ra || [], la || []), !0);
          }

          if ("undefined" != typeof H && 0 < (null === H || void 0 === H ? void 0 : H.length)) {
            e = {};
            var Fa = null === document || void 0 === document ? void 0 : document.head,
                U = null === Fa || void 0 === Fa ? void 0 : Fa.getElementsByTagName("meta");
            if ("undefined" != typeof U && 0 < (null === U || void 0 === U ? void 0 : U.length)) for (Fa = 0; Fa < U.length; Fa++) {
              var va = U[Fa];

              for (n = 0; n < H.length; n++) {
                var Ga = va.getAttribute(H[n].key),
                    Oc = va.getAttribute(H[n].value);
                p = void 0;
                if (null === (Ea = H[n]) || void 0 === Ea ? 0 : Ea.condition) p = null === (ya = H[n]) || void 0 === ya ? void 0 : ya.condition;
                Ga && (p && p.includes(Ga) ? e[Ga] = Oc : p && 0 !== p.length || (e[Ga] = Oc));
              }
            }
            q.setMetaCustomTags(e);
          }
        } catch (sd) {
          console.warn("Conviva App Tracker:: setPageMetaTagsAsCustomTags", sd);
        }
      }

      function tb(e, n, p) {
        var z = function z(I, S) {
          t();
          var J = q.core.getConfig();
          J.enablePeriodicHeartbeat ? void 0 != J.periodicHeartbeatInterval && (J = 1E3 * J.periodicHeartbeatInterval, J != e.configHeartBeatTimer && (window.clearInterval(e.activityInterval), e.activityInterval = window.setInterval(C, J))) : window.clearInterval(e.activityInterval);
          I({
            context: S,
            pageViewId: gc(),
            minXOffset: Fc,
            minYOffset: Hc,
            maxXOffset: Gc,
            maxYOffset: Ic
          });
          ma();
        },
            A = new Date();

        window.setTimeout(function () {
          z(e.callback, (n || []).concat(p ? p() : []));
        }, 2E3);

        var C = function C() {
          var I = new Date();
          if (A.getTime() + e.configHeartBeatTimer > I.getTime() || ld + e.configHeartBeatTimer > I.getTime()) A = I, z(e.callback, (n || []).concat(p ? p() : []));
        };

        e.activityInterval = window.setInterval(C, e.configHeartBeatTimer);
      }

      function na(e) {
        var n = e.minimumVisitLength,
            p = e.heartbeatDelay;
        e = e.callback;
        if (Ae(n) && Ae(p)) return {
          configMinimumVisitLength: 1E3 * n,
          configHeartBeatTimer: 1E3 * p,
          callback: e
        };
        Pa.error("Activity tracking minimumVisitLength & heartbeatDelay must be integers");
      }

      function db(e) {
        var n = e.context,
            p = e.minXOffset,
            z = e.minYOffset,
            A = e.maxXOffset,
            C = e.maxYOffset;
        e = document.title;
        e !== wb && (wb = e, Sb = void 0);
        e = Ka;
        var I = e.track,
            S = E(Tb || ub),
            J = ed(Sb || wb),
            D = E(Nc || ic);
        p = Math.round(p);
        A = Math.round(A);
        z = Math.round(z);
        C = Math.round(C);
        var ba = xc();
        ba.add("e", "pp");
        ba.add("url", S);
        ba.add("page", J);
        ba.add("refr", D);
        p && !isNaN(Number(p)) && ba.add("pp_mix", p.toString());
        A && !isNaN(Number(A)) && ba.add("pp_max", A.toString());
        z && !isNaN(Number(z)) && ba.add("pp_miy", z.toString());
        C && !isNaN(Number(C)) && ba.add("pp_may", C.toString());
        I.call(e, ba, n);
      }

      function Bb(e) {
        var n, p, z, A, C, I, S, J, D, ba, xa, Ba, Qa, Ra, Sa, Ta, Ua, Va, Wa, Xa, Ya, Za, $a, mb, ab, gb, hb, Ca, Ea, ya, T;

        try {
          if (q && e) {
            var H = q.core.getConfig(),
                Ma = aa.CONFIG_PREFERENCES.MERGE,
                ra = [];
            "undefined" !== typeof (null === (p = null === (n = null === h || void 0 === h ? void 0 : h.configs) || void 0 === n ? void 0 : n.traceparentGeneration) || void 0 === p ? void 0 : p.force) && !0 === (null === (A = null === (z = null === h || void 0 === h ? void 0 : h.configs) || void 0 === z ? void 0 : z.traceparentGeneration) || void 0 === A ? void 0 : A.force) ? Ma = aa.CONFIG_PREFERENCES.APP : "undefined" !== typeof (null === (C = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === C ? void 0 : C.pref) && (Ma = null === (I = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === I ? void 0 : I.pref);

            switch (Ma) {
              case aa.CONFIG_PREFERENCES.APP:
                if (!1 === (null === (J = null === (S = null === h || void 0 === h ? void 0 : h.configs) || void 0 === S ? void 0 : S.traceparentGeneration) || void 0 === J ? void 0 : J.enabled)) return "";
                if (null === (xa = null === (ba = null === (D = null === h || void 0 === h ? void 0 : h.configs) || void 0 === D ? void 0 : D.traceparentGeneration) || void 0 === ba ? void 0 : ba.targetUrl) || void 0 === xa ? 0 : xa.length) ra = fa([], null === (Qa = null === (Ba = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Ba ? void 0 : Ba.traceparentGeneration) || void 0 === Qa ? void 0 : Qa.targetUrl, !0);
                break;

              case aa.CONFIG_PREFERENCES.REMOTE:
                if (!1 === (null === (Ra = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === Ra ? void 0 : Ra.enabled)) return "";
                "undefined" != typeof (null === H || void 0 === H ? void 0 : H.traceparentconfig) && (null === (Ta = null === (Sa = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === Sa ? void 0 : Sa.targetUrl) || void 0 === Ta ? 0 : Ta.length) && (ra = fa([], null === (Ua = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === Ua ? void 0 : Ua.targetUrl, !0));
                break;

              default:
                if ("undefined" == typeof (null === H || void 0 === H ? void 0 : H.traceparentconfig) && !1 === (null === (Wa = null === (Va = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Va ? void 0 : Va.traceparentGeneration) || void 0 === Wa ? void 0 : Wa.enabled) || "undefined" == typeof (null === (Xa = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Xa ? void 0 : Xa.traceparentGeneration) && !1 === (null === (Ya = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === Ya ? void 0 : Ya.enabled)) return "";
                var la = null === ($a = null === (Za = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Za ? void 0 : Za.traceparentGeneration) || void 0 === $a ? void 0 : $a.targetUrl,
                    Fa = null === (mb = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === mb ? void 0 : mb.targetUrl;
                !1 === (null === (gb = null === (ab = null === h || void 0 === h ? void 0 : h.configs) || void 0 === ab ? void 0 : ab.traceparentGeneration) || void 0 === gb ? void 0 : gb.enabled) && (la = []);
                !1 === (null === (hb = null === H || void 0 === H ? void 0 : H.traceparentconfig) || void 0 === hb ? void 0 : hb.enabled) && (Fa = []);
                var U = new Set(fa(fa([], Fa || [], !0), la || [], !0));
                ra = Array.from(U);
            }

            var va = null === (Ea = null === (Ca = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Ca ? void 0 : Ca.networkRequestTracking) || void 0 === Ea ? void 0 : Ea.safelist,
                Ga = null === (ya = null === H || void 0 === H ? void 0 : H.networkRequestTrackingConfiguration) || void 0 === ya ? void 0 : ya.blocklist,
                Oc = (null === Ga || void 0 === Ga ? void 0 : Ga.includes("*")) || (null === Ga || void 0 === Ga ? void 0 : Ga.some(function (za) {
              return 0 < (null === za || void 0 === za ? void 0 : za.length) && e.toLowerCase().includes(za.toLowerCase());
            })),
                sd = null === va || void 0 === va ? void 0 : va.some(function (za) {
              return 0 < (null === za || void 0 === za ? void 0 : za.length) && e.toLowerCase().includes(za.toLowerCase());
            });

            if (0 < (null === ra || void 0 === ra ? void 0 : ra.length) && ((null === ra || void 0 === ra ? 0 : ra.includes("*")) || (null === ra || void 0 === ra ? 0 : ra.some(function (za) {
              return 0 < (null === za || void 0 === za ? void 0 : za.length) && e.toLowerCase().includes(za.toLowerCase());
            }))) && (null === (T = null === H || void 0 === H ? void 0 : H.networkRequestTrackingConfiguration) || void 0 === T ? 0 : T.enabled) && (sd || !Oc)) {
              var og = Array.from({
                length: 32
              }, function () {
                return Math.floor(16 * Math.random()).toString(16);
              }).join(""),
                  pg = Array.from({
                length: 16
              }, function () {
                return Math.floor(16 * Math.random()).toString(16);
              }).join("");
              return "00-" + og + "-" + pg + "-00";
            }
          }

          return "";
        } catch (za) {
          return "";
        }
      }

      function Oe(e) {
        h.trackerConfigUrl ? (Vb(h.trackerConfigUrl), Wb = window.setInterval(Vb, 6E4 * e, h.trackerConfigUrl)) : (Vb(td), Wb = window.setInterval(Vb, 6E4 * e, td));
      }

      var ud,
          vd,
          wd,
          xd,
          yd,
          zd,
          Ad,
          Bd,
          Cd,
          Dd,
          Ed,
          Fd,
          Gd,
          Hd,
          Id,
          Jd,
          Kd,
          Ld,
          Md,
          Nd,
          Od,
          Pd,
          wa = {
        cacheRefreshInterval: 30,
        base64: !1,
        linkClickTracking: !0,
        buttonClickTracking: !0,
        lifecycleAutotracking: !0,
        customEvent: !0,
        exceptionAutotracking: !0,
        enablePeriodicHeartbeat: !0,
        periodicHeartbeatInterval: 40,
        customEventTrackingConfiguration: {},
        convivaVideoEventTrackingConfiguration: {},
        ajaxTrackingConfiguration: {
          blocklist: ["*"]
        },
        networkRequestTrackingConfiguration: {
          blocklist: ["*"]
        },
        traceparentconfig: {
          enabled: !0,
          pref: aa.CONFIG_PREFERENCES.MERGE,
          targetUrl: []
        },
        performanceContextConfig: 1
      },
          M = {},
          Wb = null;

      if ("undefined" != typeof window && (null === window || void 0 === window ? 0 : window.localStorage)) {
        var Pe = localStorage.getItem(aa.REMOTE_CONFIG_STORAGE_KEY) ? localStorage.getItem(aa.REMOTE_CONFIG_STORAGE_KEY) : JSON.stringify(M);
        var Qd = localStorage.getItem(aa.END_POINT_STORAGE_KEY) ? localStorage.getItem(aa.END_POINT_STORAGE_KEY) : aa.DEFAULT_END_POINT;
      } else Qd = aa.DEFAULT_END_POINT, Pe = JSON.stringify(M);

      u = h.gatewayUrl ? h.gatewayUrl : Qd ? Qd : aa.DEFAULT_END_POINT;
      y || (y = "CAT");
      var P = JSON.parse(Pe);
      M.base64 = "undefined" != typeof P.base64 ? P.base64 : wa.base64;
      M.cacheRefreshInterval = "undefined" != typeof P.cacheRefreshInterval ? P.cacheRefreshInterval : wa.cacheRefreshInterval;
      M.linkClickTracking = "undefined" != typeof P.linkClickTracking ? P.linkClickTracking : wa.linkClickTracking;
      M.lifecycleAutotracking = "undefined" != typeof P.lifecycleAutotracking ? P.lifecycleAutotracking : wa.lifecycleAutotracking;
      M.buttonClickTracking = "undefined" != typeof P.buttonClickTracking ? P.buttonClickTracking : wa.buttonClickTracking;
      M.exceptionAutotracking = "undefined" != typeof P.exceptionAutotracking ? P.exceptionAutotracking : wa.exceptionAutotracking;
      M.enablePeriodicHeartbeat = "undefined" != typeof P.enablePeriodicHeartbeat ? P.enablePeriodicHeartbeat : wa.enablePeriodicHeartbeat;
      M.periodicHeartbeatInterval = "undefined" != typeof P.periodicHeartbeatInterval ? P.periodicHeartbeatInterval : wa.periodicHeartbeatInterval;
      "undefined" != typeof P.enc && (M.enc = P.enc);
      "undefined" != typeof P.maxLocalStorageQueueSize && (M.maxLocalStorageQueueSize = P.maxLocalStorageQueueSize);
      "undefined" != typeof P.maxPostBytes && (M.maxPostBytes = P.maxPostBytes);
      "undefined" != typeof P.maxGetBytes && (M.maxGetBytes = P.maxGetBytes);
      "undefined" != typeof P.bufferSize && (M.bufferSize = P.bufferSize);
      M.customEventTrackingConfiguration = "undefined" != typeof P.customEventTrackingConfiguration ? P.customEventTrackingConfiguration : _ha({}, wa.customEventTrackingConfiguration);
      M.convivaVideoEventTrackingConfiguration = "undefined" != typeof P.convivaVideoEventTrackingConfiguration ? P.convivaVideoEventTrackingConfiguration : _ha({}, wa.convivaVideoEventTrackingConfiguration);
      M.ajaxTrackingConfiguration = "undefined" != typeof P.ajaxTrackingConfiguration ? P.ajaxTrackingConfiguration : _ha({}, wa.ajaxTrackingConfiguration);
      M.networkRequestTrackingConfiguration = "undefined" != typeof P.networkRequestTrackingConfiguration ? P.networkRequestTrackingConfiguration : _ha({}, wa.networkRequestTrackingConfiguration);
      "undefined" != typeof P.metaTagsTrackingConfiguration && (M.metaTagsTrackingConfiguration = P.metaTagsTrackingConfiguration);
      M.traceparentconfig = "undefined" != typeof P.traceparentconfig ? P.traceparentconfig : _ha({}, wa.traceparentconfig);
      "undefined" != typeof P.mend && (M.mend = P.mend);
      M.performanceContextConfig = "undefined" != typeof P.performanceContextConfig ? P.performanceContextConfig : wa.performanceContextConfig;
      null === (ud = jd(M.performanceContextConfig)) || void 0 === ud ? void 0 : ud.activateLCPObserver();

      (function () {
        try {
          var e = 0,
              n = 0;
          null === window || void 0 === window ? void 0 : window.addEventListener("load", function () {
            var p;

            try {
              var z = null === (p = null === q || void 0 === q ? void 0 : q.core) || void 0 === p ? void 0 : p.getConfig();
              null === q || void 0 === q ? void 0 : q.trackCustomEvent({
                name: "conviva_window_loaded",
                data: "{}",
                context: jd(null === z || void 0 === z ? void 0 : z.performanceContextConfig).contexts()
              });
            } catch (A) {
              console.warn("ConvivaAppTracker : issue while registering window loaded event", A);
            }
          });
          null === document || void 0 === document ? void 0 : document.addEventListener("visibilitychange", function () {
            var p;

            try {
              if ("hidden" === document.visibilityState) setTimeout(function () {
                var A;

                try {
                  var C = null === (A = null === q || void 0 === q ? void 0 : q.core) || void 0 === A ? void 0 : A.getConfig();
                  n++;

                  if (null === C || void 0 === C ? 0 : C.lifecycleAutotracking) {
                    var I = q.core,
                        S = I.track;
                    var J = zb({
                      event: {
                        sc: "sp/abg/1-0-0",
                        dt: Ob({
                          backgroundIndex: n
                        })
                      }
                    });
                    S.call(I, J);
                  }

                  "hidden" !== document.visibilityState || rd || (null === q || void 0 === q ? void 0 : q.trackCustomEvent({
                    name: "conviva_app_backgrnd_before_page_view",
                    data: "{}"
                  }));
                } catch (D) {
                  console.warn("ConvivaAppTracker : issue while tracking visibility change", D);
                }
              }, 0);else {
                var z = null === (p = null === q || void 0 === q ? void 0 : q.core) || void 0 === p ? void 0 : p.getConfig();
                e++;
                (null === z || void 0 === z ? 0 : z.lifecycleAutotracking) && q.core.track(zb({
                  event: {
                    sc: "sp/afg/1-0-0",
                    dt: Ob({
                      foregroundIndex: e
                    })
                  }
                }));
              }
            } catch (A) {
              console.warn("convivaAppTracker visibilitychange failed " + A);
            }
          });
          "undefined" != typeof document && document && document.addEventListener && document.addEventListener("convivaVideoEvent", function (p) {
            p && q && (null === q || void 0 === q ? void 0 : q.trackVideoEvent(p));
          });
        } catch (p) {
          console.warn("convivaAppTracker error in page load metrics" + p);
        }
      })();

      try {
        var Hb = XMLHttpRequest,
            Pc = null === (vd = null === window || void 0 === window ? void 0 : window.fetch) || void 0 === vd ? void 0 : vd.bind(window);

        if (Hb) {
          var qg = function qg(e) {
            var n = {};
            e.trim().split(/[\r\n]+/).forEach(function (p) {
              p = p.split(":");
              var z = p[1];
              n[p[0].trim()] = null === z || void 0 === z ? void 0 : z.trim();
            });
            return n;
          },
              Qc = function Qc(e, n, p) {
            try {
              var z = {
                status: null === e || void 0 === e ? void 0 : e.status,
                statusText: ("" !== (null === e || void 0 === e ? void 0 : e.statusText) ? null === e || void 0 === e ? void 0 : e.statusText : void 0) || ("load" != p ? p : void 0),
                responseTimestamp: null === Date || void 0 === Date ? void 0 : Date.now(),
                responseTime: (null === performance || void 0 === performance ? void 0 : performance.now()) || (null === Date || void 0 === Date ? void 0 : Date.now())
              };
              p = void 0;

              try {
                p = qg(e.getAllResponseHeaders()), z.headers = p;
              } catch (A) {}

              try {
                z.body = null === e || void 0 === e ? void 0 : e.response;
              } catch (A) {}

              q.trackNetworkRequest({
                requestDetails: n,
                responseDetails: z
              });
            } catch (A) {
              console.warn("Conviva App Tracker:: Unable to track network request error while handleResponse ".concat(A));
            }
          },
              Rd = function Rd() {
            var e = new Hb();

            try {
              var n,
                  p,
                  z = {},
                  A,
                  C = e.setRequestHeader;

              e.setRequestHeader = function (J, D) {
                z[J] = D;
                C.call(this, J, D);
              };

              var I = e.open;

              e.open = function () {
                for (var J = [], D = 0; D < arguments.length; D++) {
                  J[D] = arguments[D];
                }

                n = J[0];
                p = J[1];

                try {
                  /^(?:[a-z]+:)?\/\//i.test(p) || (p = 0 === p.indexOf("/") ? window.location.origin + p : window.location.origin + "/" + p);
                } catch (ba) {}

                I.call(e, J[0], J[1], !0);
              };

              var S = e.send;

              e.send = function (J) {
                try {
                  var D = null;
                  aa.TRACEPARENT_HEADER_KEY in z || (D = Bb(p), null !== D && "" !== D && e.setRequestHeader(aa.TRACEPARENT_HEADER_KEY, D));
                  S.call(e, J);
                  A = {
                    method: n,
                    url: p,
                    headers: z,
                    body: J,
                    requestTimestamp: null === Date || void 0 === Date ? void 0 : Date.now(),
                    requestTime: (null === performance || void 0 === performance ? void 0 : performance.now()) || (null === Date || void 0 === Date ? void 0 : Date.now())
                  };
                  null !== D && "" !== D && (A[aa.TRACEPARENT_HEADER_KEY] = D);
                } catch (ba) {
                  console.warn("Conviva App Tracker:: Unable to track network request while send ".concat(ba));
                }
              };

              e.addEventListener("load", function () {
                return Qc(e, A, "load");
              });
              e.addEventListener("error", function () {
                return Qc(e, A, "error");
              });
              e.addEventListener("abort", function () {
                return Qc(e, A, "abort");
              });
              e.addEventListener("timeout", function () {
                return Qc(e, A, "timeout");
              });
            } catch (J) {
              console.warn("Conviva App Tracker:: Unable to track network request while interceptRequest ".concat(J));
            }

            return e;
          },
              Rc;

          for (Rc in Hb) {
            Hb.hasOwnProperty(Rc) && (Rd[Rc] = Hb[Rc]);
          }

          Rd.prototype = Hb.prototype;
          window.XMLHttpRequest = Rd;
        }

        if (Pc) {
          var Qe = function Qe(e) {
            var n = {};
            e.forEach(function (p, z) {
              n[z] = p;
            });
            return n;
          };

          window.fetch = function (e, n) {
            var p,
                z = null;

            if (e instanceof Request) {
              e = null === e || void 0 === e ? void 0 : e.clone();

              try {
                var A = !1;
                null === (p = null === e || void 0 === e ? void 0 : e.headers) || void 0 === p ? void 0 : p.forEach(function (D, ba) {
                  aa.TRACEPARENT_HEADER_KEY === ba && (A = !0);
                });
                A || (z = Bb(e.url), null !== z && "" !== z && e.headers.set(aa.TRACEPARENT_HEADER_KEY, z));
              } catch (D) {
                console.warn("ConvivaAppTracker: Issue while adding traceparent header", D);
              }

              p = Pc(e);
            } else {
              try {
                if (n && n.headers) {
                  var C = new Headers(n.headers),
                      I = !1;
                  C.forEach(function (D, ba) {
                    aa.TRACEPARENT_HEADER_KEY === ba && (I = !0);
                  });
                  I || (z = Bb(e), null !== z && "" !== z && C.set(aa.TRACEPARENT_HEADER_KEY, z));
                } else C = new Headers(), z = Bb(e), null !== z && "" !== z && C.set(aa.TRACEPARENT_HEADER_KEY, z), n || (n = {});

                n.headers = C;
              } catch (D) {
                console.warn("ConvivaAppTracker: Issue while adding traceparent header", D);
              }

              p = Pc(e, n);
              e = new Request(e, n).clone();
            }

            try {
              C = void 0;

              try {
                C = Qe(e.headers);
              } catch (D) {}

              var S = void 0;

              try {
                S = null === n || void 0 === n ? void 0 : n.body;
              } catch (D) {}

              var J = {
                method: e.method,
                url: e.url,
                headers: C,
                body: S,
                requestTimestamp: null === Date || void 0 === Date ? void 0 : Date.now(),
                requestTime: (null === performance || void 0 === performance ? void 0 : performance.now()) || (null === Date || void 0 === Date ? void 0 : Date.now())
              };
              null !== z && "" !== z && (J[aa.TRACEPARENT_HEADER_KEY] = z);
              p.then(function (D) {
                try {
                  var ba = Qe(D.headers);
                } catch (Ba) {}

                var xa = {
                  status: null === D || void 0 === D ? void 0 : D.status,
                  statusText: "" !== (null === D || void 0 === D ? void 0 : D.statusText) ? null === D || void 0 === D ? void 0 : D.statusText : void 0,
                  headers: ba,
                  size: 0,
                  responseTimestamp: null === Date || void 0 === Date ? void 0 : Date.now(),
                  responseTime: (null === performance || void 0 === performance ? void 0 : performance.now()) || (null === Date || void 0 === Date ? void 0 : Date.now())
                };
                D.clone().json().then(function (Ba) {
                  xa.body = Ba;
                  q.trackNetworkRequest({
                    requestDetails: J,
                    responseDetails: xa
                  });
                })["catch"](function () {
                  q.trackNetworkRequest({
                    requestDetails: J,
                    responseDetails: xa
                  });
                });
              })["catch"](function (D) {
                D = {
                  statusText: D.toString(),
                  responseTimestamp: null === Date || void 0 === Date ? void 0 : Date.now(),
                  responseTime: (null === performance || void 0 === performance ? void 0 : performance.now()) || (null === Date || void 0 === Date ? void 0 : Date.now())
                };
                q.trackNetworkRequest({
                  requestDetails: J,
                  responseDetails: D
                });
              });
            } catch (D) {
              console.warn("Conviva App Tracker:: Unable to track network request while fetch interceptRequest ".concat(D));
            }

            return p;
          };
        }

        try {
          Hb || Pc || PerformanceObserver && new PerformanceObserver(function (e) {
            try {
              e.getEntries().forEach(function (n) {
                q && q.trackAjaxEvent(n);
              });
            } catch (n) {
              console.warn("Conviva PerformanceObserver error in listeneing ajax request observer ".concat(n));
            }
          }).observe({
            type: "resource",
            buffered: !0
          });
        } catch (e) {
          console.warn("Conviva PerformanceObserver failed to report ajax request" + e);
        }
      } catch (e) {
        console.warn("Conviva App Tracker:: Unable to track network request ".concat(e));
      }

      var rg = w.split("js-")[1],
          td = aa.REMOTE_CONFIG_URL_PREFIX + h.convivaCustomerKey + "/" + rg + aa.REMOTE_CONFIG_FILE_NAME;

      if (window.XMLHttpRequest) {
        var Xb = new XMLHttpRequest(),
            Sd = 0;

        Xb.onreadystatechange = function () {
          try {
            if (4 == Xb.readyState) if (200 == Xb.status) {
              Sd = 0;
              var e = JSON.parse(Xb.response);
              e.cacheRefreshInterval || (e.cacheRefreshInterval = wa.cacheRefreshInterval);
              M.cacheRefreshInterval != e.cacheRefreshInterval && (M.cacheRefreshInterval = e.cacheRefreshInterval, "number" === typeof Wb && window.clearInterval(Wb), Oe(e.cacheRefreshInterval));
              var n = "cws.conviva.com /wsg /ctp remote_config pings.conviva.com .m3u8 .mpd .ism .m4 .mp4 .ts .png .jpg .jpeg .bmp google-analytics.com googlesyndication.com googleapis stats.g.doubleclick chartbeat.com omtrdc.net app-measurement.com firebase nr-data.net newrelic bitmovin.com/impression bitmovin.com/analytics api.segment.io youbora hotjar mixpanel.com clevertap auryc .aac .vtt .googlevideo webp appsflyer facebook dynatrace mparticle npaw doubleclick .pdf bookkeeper kochava mp3 marketingcloudapis demdex scorecardresearch lura.live perimeterx.net permutive.app segment.com vaicore.site boomtrain ketchcdn qualtrics .svg amplitude datadoghq branch.io hotjar splunkcloud".split(" "),
                  p = JSON.parse(JSON.stringify(wa));
              "undefined" != typeof e.cacheRefreshInterval && (p.cacheRefreshInterval = e.cacheRefreshInterval);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.base64Encoding && (p.base64 = e.configurationBundle[0].trackerConfiguration.base64Encoding);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.linkClickTracking && (p.linkClickTracking = e.configurationBundle[0].trackerConfiguration.linkClickTracking);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.lifecycleAutotracking && (p.lifecycleAutotracking = e.configurationBundle[0].trackerConfiguration.lifecycleAutotracking);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.buttonClickTracking && (p.buttonClickTracking = e.configurationBundle[0].trackerConfiguration.buttonClickTracking);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.customEvent && (p.customEvent = e.configurationBundle[0].trackerConfiguration.customEvent);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.exceptionAutotracking && (p.exceptionAutotracking = e.configurationBundle[0].trackerConfiguration.exceptionAutotracking);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.enablePeriodicHeartbeat && (p.enablePeriodicHeartbeat = e.configurationBundle[0].trackerConfiguration.enablePeriodicHeartbeat);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.periodicHeartbeatInterval && (p.periodicHeartbeatInterval = e.configurationBundle[0].trackerConfiguration.periodicHeartbeatInterval);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.enc && (p.enc = e.configurationBundle[0].networkConfiguration.enc);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.maxLocalStorageQueueSize && (p.maxLocalStorageQueueSize = e.configurationBundle[0].networkConfiguration.maxLocalStorageQueueSize);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.maxPostBytes && (p.maxPostBytes = e.configurationBundle[0].networkConfiguration.maxPostBytes);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.maxGetBytes && (p.maxGetBytes = e.configurationBundle[0].networkConfiguration.maxGetBytes);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.bufferSize && (p.bufferSize = e.configurationBundle[0].networkConfiguration.bufferSize);
              "undefined" != typeof e.configurationBundle[0].customEventTrackingConfiguration && (p.customEventTrackingConfiguration = e.configurationBundle[0].customEventTrackingConfiguration);
              "undefined" != typeof e.configurationBundle[0].convivaVideoEventTrackingConfiguration && (p.convivaVideoEventTrackingConfiguration = e.configurationBundle[0].convivaVideoEventTrackingConfiguration);
              "undefined" != typeof e.configurationBundle[0].ajaxTrackingConfiguration && (p.ajaxTrackingConfiguration = e.configurationBundle[0].ajaxTrackingConfiguration);
              "undefined" != typeof e.configurationBundle[0].networkRequestTrackingConfiguration && (p.networkRequestTrackingConfiguration = e.configurationBundle[0].networkRequestTrackingConfiguration);
              "undefined" != typeof e.configurationBundle[0].traceparentconfig && (p.traceparentconfig = e.configurationBundle[0].traceparentconfig);
              "undefined" != typeof e.configurationBundle[0].networkConfiguration.mend && (p.mend = e.configurationBundle[0].networkConfiguration.mend);
              p.ajaxTrackingConfiguration && (p.ajaxTrackingConfiguration.blocklist || (p.ajaxTrackingConfiguration.blocklist = []), p.ajaxTrackingConfiguration.blocklist.push(e.configurationBundle[0].networkConfiguration.endpoint), p.ajaxTrackingConfiguration.blocklist = p.ajaxTrackingConfiguration.blocklist.concat(n));
              p.networkRequestTrackingConfiguration && (p.networkRequestTrackingConfiguration.blocklist || (p.networkRequestTrackingConfiguration.blocklist = []), p.networkRequestTrackingConfiguration.blocklist.push(e.configurationBundle[0].networkConfiguration.endpoint), p.networkRequestTrackingConfiguration.blocklist = p.networkRequestTrackingConfiguration.blocklist.concat(n));
              "undefined" != typeof e.configurationBundle[0].metaTagsTrackingConfiguration && (p.metaTagsTrackingConfiguration = e.configurationBundle[0].metaTagsTrackingConfiguration);
              "undefined" != typeof e.configurationBundle[0].trackerConfiguration.perfCx && (p.performanceContextConfig = e.configurationBundle[0].trackerConfiguration.perfCx);
              q.core.setConfig(p);
              q.setCollectorUrl(e.configurationBundle[0].networkConfiguration.endpoint, g.convivaCustomerKey);

              try {
                window.localStorage && (localStorage.removeItem("ConvivaRemoteConfig"), localStorage.removeItem("ConvivaEndpoint"), localStorage.setItem("ConvivaRemoteConfig", JSON.stringify(p)), localStorage.setItem("ConvivaEndpoint", e.configurationBundle[0].networkConfiguration.endpoint));
              } catch (z) {
                console.warn("Conviva: Error while saving remote-config to localstorage", z);
              }
            } else try {
              3 > Sd && ((null === h || void 0 === h ? 0 : h.trackerConfigUrl) ? Vb(null === h || void 0 === h ? void 0 : h.trackerConfigUrl) : Vb(td));
            } catch (z) {}
          } catch (z) {
            console.warn("Conviva App Tracker:: Error in fetching remote-config ".concat(z));
          }
        };

        var Vb = function Vb(e) {
          try {
            Sd++, Xb.open("GET", e, !0), Xb.send();
          } catch (n) {}
        };

        "number" === typeof Wb && window.clearInterval(Wb);
        Oe(M.cacheRefreshInterval);
      }

      h.eventMethod = null !== (wd = h.eventMethod) && void 0 !== wd ? wd : "post";

      var Ke = function Ke(e) {
        var n;
        return null !== (n = e.stateStorageStrategy) && void 0 !== n ? n : "cookieAndLocalStorage";
      },
          Le = function Le(e) {
        var n, p;
        return "boolean" === typeof e.anonymousTracking ? !1 : null !== (p = !0 === (null === (n = e.anonymousTracking) || void 0 === n ? void 0 : n.withSessionTracking)) && void 0 !== p ? p : !1;
      },
          Me = function Me(e) {
        var n, p;
        return "boolean" === typeof e.anonymousTracking ? !1 : null !== (p = !0 === (null === (n = e.anonymousTracking) || void 0 === n ? void 0 : n.withServerAnonymisation)) && void 0 !== p ? p : !1;
      };

      m.push(function () {
        return {
          beforeTrack: function beforeTrack(e) {
            var n = V("ses"),
                p = Y();
            Td = Ud ? !!cb(Ud) : !1;
            Re || Td ? R() : ("0" === p[0] ? (Fb = n || "none" == oa ? p[6] : hc(p), fb = p[3]) : new Date().getTime() - Vd > 1E3 * Ie && (fb++, Fb = hc(p, fb)), id(p), -1 === p[10] && (n = e.build(), p[8] = n.eid, n = n.dtm || n.ttm, p[9] = n ? parseInt(n) : void 0), p[10] += 1, e.add("uid", kc ? null : Gb), t(), e.add("refr", E(Nc || ic)), document && (wb = document.title, n = ed(Sb || wb), e.add("page", n)), e.add("url", E(Tb || ub)), "none" != oa && (ja(p), ia()), Vd = new Date().getTime());
          }
        };
      }());
      m.push(function () {
        return {
          contexts: function contexts() {
            var e = lc,
                n = Mc.toString(),
                p = sg;

            try {
              var z = window.localStorage.getItem(nd + "." + od),
                  A = JSON.parse(z || "{}");
              "{}" !== A && "undefined" !== typeof A && "undefined" !== typeof A[mc] && (vb = A[mc]);
              2147483647 <= vb ? vb = 0 : vb++;
              Qb();
              var C = vb;
            } catch (I) {
              console.warn(I), C = void 0;
            }

            return [{
              sc: "cv/clid/1-0-2",
              dt: {
                clid: e,
                iid: n,
                ck: p,
                eventIndex: C
              }
            }];
          }
        };
      }());
      m.push(function () {
        return {
          contexts: function contexts() {
            return [{
              sc: "cv/ct/1-0-0",
              dt: {
                data: _ha(_ha({}, pd), qd)
              }
            }];
          }
        };
      }());
      m.push(function () {
        return {
          contexts: function contexts() {
            return [{
              sc: "spm/app/1-0-0",
              dt: {
                build: Se,
                version: Se
              }
            }];
          }
        };
      }());

      try {
        (null !== (xd = null === h || void 0 === h ? void 0 : h.plugins) && void 0 !== xd ? xd : []).forEach(function (e) {
          e.contexts || m.push(e);
        });
      } catch (e) {
        console.warn("ConvivaAppTracker : issue while processing customer passed pligins", e);
      }

      var Ka = Wf({
        base64: M.base64,
        corePlugins: m,
        callback: function callback(e) {
          Re || Td || lb.enqueueRequest(e.build(), Wd);
        },
        linkClickTracking: M.linkClickTracking,
        buttonClickTracking: M.buttonClickTracking,
        customEvent: !0,
        exceptionAutotracking: M.exceptionAutotracking,
        enablePeriodicHeartbeat: M.enablePeriodicHeartbeat,
        periodicHeartbeatInterval: M.periodicHeartbeatInterval,
        enc: M.enc,
        mend: M.mend,
        maxLocalStorageQueueSize: M.maxLocalStorageQueueSize,
        maxPostBytes: M.maxPostBytes,
        maxGetBytes: M.maxGetBytes,
        bufferSize: M.bufferSize,
        customEventTrackingConfiguration: M.customEventTrackingConfiguration,
        convivaVideoEventTrackingConfiguration: M.convivaVideoEventTrackingConfiguration,
        ajaxTrackingConfiguration: M.ajaxTrackingConfiguration,
        networkRequestTrackingConfiguration: M.networkRequestTrackingConfiguration,
        metaTagsTrackingConfiguration: M.metaTagsTrackingConfiguration,
        performanceContextConfig: M.performanceContextConfig,
        lifecycleAutotracking: M.lifecycleAutotracking
      }),
          Db = Ee(window.location.hostname, window.location.href, gd()),
          Fe = Be(Db[0]),
          ub = Db[1],
          ic = Db[2],
          Nc,
          tg = null !== (yd = h.platform) && void 0 !== yd ? yd : "web",
          Wd = Ja(u, h.convivaCustomerKey),
          ug = null !== (zd = h.postPath) && void 0 !== zd ? zd : "/ctp",
          vg = null !== (Ad = h.appId) && void 0 !== Ad ? Ad : "",
          sg = null !== (Bd = h.convivaCustomerKey) && void 0 !== Bd ? Bd : "",
          Se = null !== (Cd = h.appVersion) && void 0 !== Cd ? Cd : "",
          Tb,
          pd = {},
          qd = {},
          wb = "undefined" !== typeof document ? document.title : void 0,
          Sb,
          ng = null !== (Dd = h.resetActivityTrackingOnPageView) && void 0 !== Dd ? Dd : !0,
          Ge,
          He,
          Rb = null !== (Ed = h.cookieName) && void 0 !== Ed ? Ed : "_sp_",
          jc = null !== (Fd = h.cookieDomain) && void 0 !== Fd ? Fd : void 0,
          kd = "/",
          Kc = null !== (Gd = h.cookieSameSite) && void 0 !== Gd ? Gd : "None",
          Lc = null !== (Hd = h.cookieSecure) && void 0 !== Hd ? Hd : !0,
          Te = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack,
          Re = "undefined" !== typeof h.respectDoNotTrack ? h.respectDoNotTrack && ("yes" === Te || "1" === Te) : !1,
          Ud,
          Je = null !== (Id = h.cookieLifetime) && void 0 !== Id ? Id : 63072E3,
          Ie = null !== (Jd = h.sessionCookieTimeout) && void 0 !== Jd ? Jd : 1800,
          Jc = Le(h),
          md = Me(h),
          kc = !!h.anonymousTracking,
          oa = Ke(h),
          nd = "Conviva",
          od = "sdkConfig",
          mc = "eventIndex",
          lc,
          Mc,
          vb = -1,
          ld,
          Vd = new Date().getTime(),
          Fc,
          Gc,
          Hc,
          Ic,
          Eb,
          Ec,
          Fb,
          fb = 1,
          Gb,
          lb = jg(r, k, "localStorage" == oa || "cookieAndLocalStorage" == oa, h.eventMethod, ug, function () {
        var e,
            n = Ka.getConfig();
        return null !== (e = n.bufferSize ? n.bufferSize : h.bufferSize) && void 0 !== e ? e : 1;
      }(), function () {
        var e,
            n = Ka.getConfig();
        return null !== (e = n.maxPostBytes ? n.maxPostBytes : h.maxPostBytes) && void 0 !== e ? e : 2E4;
      }, function () {
        var e,
            n = Ka.getConfig();
        return null !== (e = n.maxGetBytes ? n.maxGetBytes : h.maxGetBytes) && void 0 !== e ? e : 0;
      }, null !== (Kd = h.useStm) && void 0 !== Kd ? Kd : !0, function () {
        var e,
            n = Ka.getConfig();
        return null !== (e = n.maxLocalStorageQueueSize ? n.maxLocalStorageQueueSize : h.maxLocalStorageQueueSize) && void 0 !== e ? e : 10;
      }, null !== (Ld = h.connectionTimeout) && void 0 !== Ld ? Ld : 5E3, md, null !== (Md = h.customHeaders) && void 0 !== Md ? Md : {}, null !== (Nd = h.withCredentials) && void 0 !== Nd ? Nd : !1, null !== (Od = h.retryStatusCodes) && void 0 !== Od ? Od : [], (null !== (Pd = h.dontRetryStatusCodes) && void 0 !== Pd ? Pd : []).concat([400, 401, 403, 410, 422]), function () {
        var e,
            n,
            p,
            z = Ka.getConfig();
        return null !== (p = (null === z || void 0 === z ? 0 : z.enc) ? z.enc : null === (n = null === (e = null === h || void 0 === h ? void 0 : h.configs) || void 0 === e ? void 0 : e.network) || void 0 === n ? void 0 : n.encoding) && void 0 !== p ? p : "gzip";
      }),
          Ne = !1,
          rd = !1,
          La = {
        enabled: !0,
        installed: !1,
        configurations: {
          pagePing: {
            configMinimumVisitLength: 5E3,
            configHeartBeatTimer: 4E4,
            callback: db
          }
        }
      },
          Td;
      h.hasOwnProperty("discoverRootDomain") && h.discoverRootDomain && (jc = fg(Kc, Lc));
      Ka.setTrackerVersion(w);
      Ka.setAppId(vg);
      Ka.setPlatform(tg);
      ca();
      Z();
      lb.setCustomHeaders({
        "x-client-id": "" + lc
      });
      h.crossDomainLinker && v(h.crossDomainLinker);
      return _ha(_ha({}, {
        getDomainSessionIndex: function getDomainSessionIndex() {
          return fb;
        },
        getPageViewId: function getPageViewId() {
          return gc();
        },
        newSession: function newSession() {
          var e = Y();
          "0" === e[0] ? (Fb = "none" != oa ? hc(e) : e[6], fb = e[3], ia()) : (fb++, Fb = hc(e, fb));
          id(e);
          "none" != oa && (ja(e), ia());
          Vd = new Date().getTime();
        },
        getCookieName: function getCookieName(e) {
          return Rb + e + "." + Eb;
        },
        getUserId: function getUserId() {
          return Gb;
        },
        getDomainUserId: function getDomainUserId() {
          return Y()[1];
        },
        getDomainUserInfo: function getDomainUserInfo() {
          return Y();
        },
        setReferrerUrl: function setReferrerUrl(e) {
          Nc = e;
        },
        setCustomUrl: function setCustomUrl(e) {
          t();
          var n = ub,
              p;
          F(e) ? Tb = e : "/" === e.slice(0, 1) ? Tb = F(n) + "://" + fd(n) + e : (n = E(n), 0 <= (p = n.indexOf("?")) && (n = n.slice(0, p)), (p = n.lastIndexOf("/")) !== n.length - 1 && (n = n.slice(0, p + 1)), Tb = n + e);
        },
        setDocumentTitle: function setDocumentTitle(e) {
          wb = document.title;
          Sb = e;
        },
        discardHashTag: function discardHashTag(e) {
          Ge = e;
        },
        discardBrace: function discardBrace(e) {
          He = e;
        },
        setCookiePath: function setCookiePath(e) {
          kd = e;
          ca();
        },
        setVisitorCookieTimeout: function setVisitorCookieTimeout(e) {
          Je = e;
        },
        crossDomainLinker: function crossDomainLinker(e) {
          v(e);
        },
        enableActivityTracking: function enableActivityTracking(e) {
          La.configurations.pagePing || (La.enabled = !0, La.configurations.pagePing = na(_ha(_ha({}, e), {
            callback: db
          })));
        },
        enableActivityTrackingCallback: function enableActivityTrackingCallback(e) {
          La.configurations.callback || (La.enabled = !0, La.configurations.callback = na(e));
        },
        updatePageActivity: function updatePageActivity() {
          G();
        },
        setOptOutCookie: function setOptOutCookie(e) {
          Ud = e;
        },
        setUserId: function setUserId(e) {
          Gb = e;
        },
        setUserIdFromLocation: function setUserIdFromLocation(e) {
          t();
          Gb = fc(e, ub);
        },
        setUserIdFromReferrer: function setUserIdFromReferrer(e) {
          t();
          Gb = fc(e, ic);
        },
        setUserIdFromCookie: function setUserIdFromCookie(e) {
          Gb = cb(e);
        },
        setCollectorUrl: function setCollectorUrl(e, n) {
          Wd = Ja(e, n);
          lb.setCollectorUrl(Wd);
        },
        setBufferSize: function setBufferSize(e) {
          lb.setBufferSize(e);
        },
        flushBuffer: function flushBuffer(e) {
          void 0 === e && (e = {});
          lb.executeQueue();
          e.newBufferSize && lb.setBufferSize(e.newBufferSize);
        },
        trackPageView: function trackPageView(e) {
          void 0 === e && (e = {});
          hd();
          var n = this.core.getConfig();

          try {
            e = _ha(_ha({}, e), {
              context: jd(null === n || void 0 === n ? void 0 : n.performanceContextConfig).contexts()
            });
          } catch (p) {
            console.warn("Conviva App Tracker:: error adding performacetiming context to page view", p);
          }

          eb(e);
        },
        trackVideoEvent: function trackVideoEvent(e) {
          var n;
          void 0 === e && (e = {});

          try {
            var p = this.core.getConfig();
            "" != e.name && void 0 != e.name || console.warn("Conviva App Tracker:: Video event could not be tracked due to missing name property!!");
            var z = null === (n = null === p || void 0 === p ? void 0 : p.customEventTrackingConfiguration) || void 0 === n ? void 0 : n.blocklist;
            (null === z || void 0 === z ? 0 : z.includes("*")) || (null === z || void 0 === z ? 0 : z.some(function (A) {
              return 0 < (null === A || void 0 === A ? void 0 : A.length) && e.name.toLowerCase().includes(A.toLowerCase());
            })) || this.core.track(Zf({
              name: e.name,
              sid: e.sid,
              iid: e.iid,
              clid: e.clid,
              st: e.st,
              sst: e.sst,
              an: e.an,
              cl: e.cl,
              lv: e.lv,
              pn: e.pn,
              vid: e.vid,
              fw: e.fw,
              fwv: e.fwv,
              mn: e.mn,
              mv: e.mv,
              url: e.url,
              tags: e.tags,
              cen: e.cen,
              ced: e.ced,
              oldsc: e.old,
              newsc: e["new"],
              err: e.err,
              br: e.br,
              ft: e.ft
            }), e.context, e.timestamp);
          } catch (A) {
            console.warn("Conviva App Tracker:: Video event could not be tracked due to an exception!!", A);
          }
        },
        trackCustomEvent: function trackCustomEvent(e) {
          var n;
          void 0 === e && (e = {});

          try {
            var p = q.core.getConfig();
            "" != e.name && void 0 != e.name || console.warn("Conviva App Tracker:: custom event name is mandatory for trackCustomEvent API!!");
            var z = e.data;

            try {
              "string" !== typeof e.data && (z = JSON.stringify(e.data));
            } catch (C) {}

            var A = null === (n = null === p || void 0 === p ? void 0 : p.customEventTrackingConfiguration) || void 0 === n ? void 0 : n.blocklist;
            (null === A || void 0 === A ? 0 : A.includes("*")) || (null === A || void 0 === A ? 0 : A.some(function (C) {
              return 0 < (null === C || void 0 === C ? void 0 : C.length) && e.name.toLowerCase().includes(C.toLowerCase());
            })) || q.core.track(Yf({
              name: e.name,
              data: z
            }), e.context, e.timestamp);
          } catch (C) {
            console.warn("Conviva App Tracker:: Unable to track custom event! " + C);
          }
        },
        trackAjaxEvent: function trackAjaxEvent(e) {
          void 0 === e && (e = {});

          try {
            if ("xmlhttprequest" === e.initiatorType || "fetch" === e.initiatorType) {
              var n = this.core.getConfig();
              if ("" == e.name || void 0 == e.name) console.warn("Conviva App Tracker:: Ajax request could not be tracked due to missing URL property!!");else if (void 0 != n.ajaxTrackingConfiguration && void 0 != n.ajaxTrackingConfiguration.blocklist && 0 < n.ajaxTrackingConfiguration.blocklist.length) {
                var p = n.ajaxTrackingConfiguration.blocklist;

                if (-1 == p.indexOf("*")) {
                  n = !1;

                  for (var z = 0; z < p.length; z++) {
                    "" !== p[z] && -1 !== e.name.toLowerCase().indexOf(p[z].toLowerCase()) && (n = !0);
                  }

                  if (!n) {
                    var A = this.core,
                        C = A.track;
                    var I = zb({
                      event: {
                        sc: "cv/nr/1-0-2",
                        dt: Ob({
                          targetUrl: e.name,
                          responseStatusCode: e.responseStatus,
                          duration: e.duration
                        })
                      }
                    });
                    C.call(A, I, e.context, e.timestamp);
                  }
                }
              }
            }
          } catch (S) {
            console.warn("Conviva App Tracker:: Ajax request could not be tracked due to an exception!!", S);
          }
        },
        trackNetworkRequest: function trackNetworkRequest(e) {
          var n, p, z, A, C, I, S, J, D, ba, xa, Ba, Qa, Ra, Sa, Ta, Ua, Va, Wa, Xa, Ya, Za, $a;
          void 0 === e && (e = {});

          try {
            var mb = this.core.getConfig(),
                ab = e.responseDetails.responseTime - e.requestDetails.requestTime;

            try {
              ab = parseFloat(ab.toFixed(3));
            } catch (U) {
              console.warn("Conviva App Tracker:: exception while converting duration to 3 decimal", U);
            }

            var gb = function gb(U) {
              try {
                var va = void 0;
                "undefined" != typeof U && null !== U && (va = U["content-type"] || U["Content-Type"] || U["Content-type"]);
                return va;
              } catch (Ga) {}
            },
                hb = function (U) {
              try {
                var va = void 0;
                "undefined" != typeof U && null !== U && (va = U["content-length"] || U["Content-Length"] || U["Content-length"]);
                return "undefined" == typeof va || null === va || isNaN(va) ? va : Number(va);
              } catch (Ga) {}
            }(null === (z = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === z ? void 0 : z.headers),
                Ca = gb(null === (A = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === A ? void 0 : A.headers),
                Ea = gb(null === (C = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === C ? void 0 : C.headers);

            try {
              var ya = (n = {
                targetUrl: null === (I = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === I ? void 0 : I.url,
                method: null === (S = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === S ? void 0 : S.method,
                responseStatusCode: null === (J = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === J ? void 0 : J.status
              }, n[qa.request_headers] = null === (D = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === D ? void 0 : D.headers, n[qa.response_headers] = null === (ba = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === ba ? void 0 : ba.headers, n.duration = ab, n);
              if ("undefined" !== typeof Ca && (Ca.toLowerCase().includes("text/plain") || Ca.toLowerCase().includes("json") || Ca.toLowerCase().includes("text/javascript") || Ca.toLowerCase().includes("application/javascript")) || "undefined" === typeof Ca) if ("string" === typeof (null === (xa = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === xa ? void 0 : xa.body)) try {
                1E4 >= (null === (Ba = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === Ba ? void 0 : Ba.body.length) && (ya[qa.request_body] = JSON.parse(null === (Qa = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === Qa ? void 0 : Qa.body));
              } catch (U) {} else "object" === _typeof(null === (Ra = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === Ra ? void 0 : Ra.body) && (ya[qa.request_body] = null === (Sa = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === Sa ? void 0 : Sa.body);
              if ("undefined" !== typeof Ea && (Ea.toLowerCase().includes("text/plain") || Ea.toLowerCase().includes("json") || Ea.toLowerCase().includes("text/javascript") || Ea.toLowerCase().includes("application/javascript")) && "undefined" !== typeof hb && 1E4 >= hb) if ("string" === typeof (null === (Ta = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === Ta ? void 0 : Ta.body)) try {
                ya[qa.response_body] = JSON.parse(null === (Ua = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === Ua ? void 0 : Ua.body);
              } catch (U) {} else "object" === _typeof(null === (Va = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === Va ? void 0 : Va.body) && (ya[qa.response_body] = null === (Wa = null === e || void 0 === e ? void 0 : e.responseDetails) || void 0 === Wa ? void 0 : Wa.body);
              var T = mb.networkRequestTrackingConfiguration;

              if (T && T.enabled) {
                var H = T.blocklist,
                    Ma = null === (Ya = null === (Xa = null === h || void 0 === h ? void 0 : h.configs) || void 0 === Xa ? void 0 : Xa.networkRequestTracking) || void 0 === Ya ? void 0 : Ya.safelist,
                    ra = (null === H || void 0 === H ? void 0 : H.includes("*")) || (null === H || void 0 === H ? void 0 : H.some(function (U) {
                  return 0 < (null === U || void 0 === U ? void 0 : U.length) && ya.targetUrl.toLowerCase().includes(U.toLowerCase());
                }));

                if ((null === Ma || void 0 === Ma ? 0 : Ma.some(function (U) {
                  return 0 < (null === U || void 0 === U ? void 0 : U.length) && ya.targetUrl.toLowerCase().includes(U.toLowerCase());
                })) || !ra) {
                  var la = gg(ya, T.collectattr);

                  if (null === (Za = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === Za ? 0 : Za[aa.TRACEPARENT_HEADER_KEY]) {
                    var Fa = (p = {}, p[aa.TRACEPARENT_HEADER_KEY] = null === ($a = null === e || void 0 === e ? void 0 : e.requestDetails) || void 0 === $a ? void 0 : $a[aa.TRACEPARENT_HEADER_KEY], p);
                    la[qa.request_headers] = la[qa.request_headers] ? _ha(_ha({}, la[qa.request_headers]), Fa) : Fa;
                  }

                  this.core.track(zb({
                    event: {
                      sc: "cv/nr/1-0-4",
                      dt: Ob({
                        targetUrl: la.targetUrl,
                        method: la.method,
                        queryParameters: la.queryParameters,
                        responseStatusCode: la.responseStatusCode,
                        responseStatusText: la.responseStatusText,
                        rqh: la.rqh,
                        rsh: la.rsh,
                        rqb: la.rqb,
                        rsb: la.rsb,
                        requestSize: la.requestSize,
                        responseSize: la.responseSize,
                        duration: la.duration,
                        contentType: la.contentType,
                        requestTimestamp: la.requestTimestamp,
                        responseTimestamp: la.responseTimestamp
                      })
                    }
                  }), e.context, e.timestamp);
                }
              }
            } catch (U) {
              console.warn("Conviva App Tracker:: Network request could not be tracked due to an exception!!", U);
            }
          } catch (U) {
            console.warn("Conviva App Tracker:: Network request could not be tracked due to an exception!!", U);
          }
        },
        setCustomTags: function setCustomTags(e) {
          void 0 === e && (e = {});
          L(e);
        },
        setMetaCustomTags: function setMetaCustomTags(e) {
          void 0 === e && (e = {});
          ua(e);
        },
        unsetCustomTags: function unsetCustomTags(e) {
          void 0 === e && (e = {});
          ea(e);
        },
        preservePageViewId: function preservePageViewId() {
          Ne = !0;
        },
        disableAnonymousTracking: function disableAnonymousTracking(e) {
          h.anonymousTracking = !1;
          Aa(e);
          Z();
          lb.executeQueue();
        },
        enableAnonymousTracking: function enableAnonymousTracking(e) {
          var n;
          h.anonymousTracking = null !== (n = e && (null === e || void 0 === e ? void 0 : e.options)) && void 0 !== n ? n : !0;
          Aa(e);
          Jc || Cb();
        },
        clearUserData: R
      }), {
        id: r,
        namespace: y,
        core: Ka,
        sharedState: k
      });
    }(a, c, b, d, f, g);

    var q = _ha(_ha({}, a), {
      addPlugin: function addPlugin(r) {
        var y, w;
        q.core.addPlugin(r);
        null === (w = (y = r.plugin).activateBrowserPlugin) || void 0 === w ? void 0 : w.call(y, q);
      }
    });

    m.forEach(function (r) {
      var y;
      null === (y = r.activateBrowserPlugin) || void 0 === y ? void 0 : y.call(r, q);
    });
    return q;
  }

  function W(a, c) {
    try {
      var b = null !== a && void 0 !== a ? a : Object.keys(nc);
      a = nc;

      for (var d = [], f = 0; f < b.length; f++) {
        var g = b[f];
        a.hasOwnProperty(g) ? d.push(a[g]) : Pa.warn(g + " not configured");
      }

      d.forEach(c);
    } catch (l) {
      Pa.error("Function failed", l);
    }
  }

  function Ue(a, c, b, d, f, g) {
    return nc.hasOwnProperty(a) ? null : (nc[a] = lg(a, c, b, d, f, g), nc[a]);
  }

  function wg() {
    function a() {
      try {
        "hidden" == f.visibilityState && d.bufferFlushers.forEach(function (l) {
          l(!1);
        });
      } catch (l) {
        console.warn("Conviva App Tracker:: Error in visibilityChangeHandler of constructor ".concat(l));
      }
    }

    function c() {
      var l;
      if (!d.hasLoaded) for (d.hasLoaded = !0, l = 0; l < d.registeredOnLoadHandlers.length; l++) {
        d.registeredOnLoadHandlers[l]();
      }
      return !0;
    }

    function b() {
      f.addEventListener ? f.addEventListener("DOMContentLoaded", function m() {
        f.removeEventListener("DOMContentLoaded", m, !1);
        c();
      }) : f.attachEvent && f.attachEvent("onreadystatechange", function q() {
        "complete" === f.readyState && (f.detachEvent("onreadystatechange", q), c());
      });
      sb(g, "load", c, !1);
    }

    var d = new xg(),
        f = document,
        g = window;
    f.visibilityState && sb(f, "visibilitychange", a, !1);
    sb(g, "beforeunload", function () {
      try {
        d.bufferFlushers.forEach(function (l) {
          l(!1);
        });
      } catch (l) {
        console.warn("Conviva App Tracker:: Error in flushBuffers of constructor ".concat(l));
      }
    }, !1);
    "loading" === document.readyState ? b() : c();
    return d;
  }

  var _ha = function ha() {
    _ha = Object.assign || function (a) {
      for (var c, b = 1, d = arguments.length; b < d; b++) {
        c = arguments[b];

        for (var f in c) {
          Object.prototype.hasOwnProperty.call(c, f) && (a[f] = c[f]);
        }
      }

      return a;
    };

    return _ha.apply(this, arguments);
  },
      Sc = {},
      Ve = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

  if (Ve) {
    var We = new Uint8Array(16);

    Sc = function Sc() {
      Ve(We);
      return We;
    };
  } else {
    var Xe = Array(16);

    Sc = function Sc() {
      for (var a = 0, c; 16 > a; a++) {
        0 === (a & 3) && (c = 4294967296 * Math.random()), Xe[a] = c >>> ((a & 3) << 3) & 255;
      }

      return Xe;
    };
  }

  for (var sa = [], Tc = 0; 256 > Tc; ++Tc) {
    sa[Tc] = (Tc + 256).toString(16).substr(1);
  }

  var Ye = function Ye(a, c) {
    c = c || 0;
    return [sa[a[c++]], sa[a[c++]], sa[a[c++]], sa[a[c++]], "-", sa[a[c++]], sa[a[c++]], "-", sa[a[c++]], sa[a[c++]], "-", sa[a[c++]], sa[a[c++]], "-", sa[a[c++]], sa[a[c++]], sa[a[c++]], sa[a[c++]], sa[a[c++]], sa[a[c++]]].join("");
  },
      yg = Sc,
      Ze,
      Xd,
      Yd = 0,
      Zd = 0,
      zg = Sc,
      $d = function $d(a, c, b) {
    b = c && b || 0;
    "string" == typeof a && (c = "binary" === a ? Array(16) : null, a = null);
    a = a || {};
    a = a.random || (a.rng || zg)();
    a[6] = a[6] & 15 | 64;
    a[8] = a[8] & 63 | 128;
    if (c) for (var d = 0; 16 > d; ++d) {
      c[b + d] = a[d];
    }
    return c || Ye(a);
  };

  $d.v1 = function (a, c, b) {
    b = c && b || 0;
    var d = c || [];
    a = a || {};
    var f = a.node || Ze,
        g = void 0 !== a.clockseq ? a.clockseq : Xd;

    if (null == f || null == g) {
      var l = yg();
      null == f && (f = Ze = [l[0] | 1, l[1], l[2], l[3], l[4], l[5]]);
      null == g && (g = Xd = (l[6] << 8 | l[7]) & 16383);
    }

    l = void 0 !== a.msecs ? a.msecs : new Date().getTime();
    var m = void 0 !== a.nsecs ? a.nsecs : Zd + 1,
        q = l - Yd + (m - Zd) / 1E4;
    0 > q && void 0 === a.clockseq && (g = g + 1 & 16383);
    (0 > q || l > Yd) && void 0 === a.nsecs && (m = 0);
    if (1E4 <= m) throw Error("uuid.v1(): Can't create more than 10M uuids/sec");
    Yd = l;
    Zd = m;
    Xd = g;
    l += 122192928E5;
    a = (1E4 * (l & 268435455) + m) % 4294967296;
    d[b++] = a >>> 24 & 255;
    d[b++] = a >>> 16 & 255;
    d[b++] = a >>> 8 & 255;
    d[b++] = a & 255;
    a = l / 4294967296 * 1E4 & 268435455;
    d[b++] = a >>> 8 & 255;
    d[b++] = a & 255;
    d[b++] = a >>> 24 & 15 | 16;
    d[b++] = a >>> 16 & 255;
    d[b++] = g >>> 8 | 128;
    d[b++] = g & 255;

    for (g = 0; 6 > g; ++g) {
      d[b + g] = f[g];
    }

    return c ? c : Ye(d);
  };

  var qb = $d.v4 = $d,
      pb = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      nb;

  (function (a) {
    a[a.none = 0] = "none";
    a[a.error = 1] = "error";
    a[a.warn = 2] = "warn";
    a[a.debug = 3] = "debug";
    a[a.info = 4] = "info";
  })(nb || (nb = {}));

  var Pa = function (a) {
    void 0 === a && (a = nb.warn);
    return {
      setLogLevel: function setLogLevel(c) {
        a = nb[c] ? c : nb.warn;
      },
      warn: function warn(c, b) {
        for (var d = [], f = 2; f < arguments.length; f++) {
          d[f - 2] = arguments[f];
        }

        a >= nb.warn && "undefined" !== typeof console && (f = "Conviva: " + c, b ? console.warn.apply(console, fa([f + "\n", b], d, !1)) : console.warn.apply(console, fa([f], d, !1)));
      },
      error: function error(c, b) {
        for (var d = [], f = 2; f < arguments.length; f++) {
          d[f - 2] = arguments[f];
        }

        a >= nb.error && "undefined" !== typeof console && (f = "Conviva: " + c + "\n", b ? console.error.apply(console, fa([f + "\n", b], d, !1)) : console.error.apply(console, fa([f], d, !1)));
      },
      debug: function debug(c) {
        for (var b = [], d = 1; d < arguments.length; d++) {
          b[d - 1] = arguments[d];
        }

        a >= nb.debug && "undefined" !== typeof console && console.debug.apply(console, fa(["Conviva: " + c], b, !1));
      },
      info: function info(c) {
        for (var b = [], d = 1; d < arguments.length; d++) {
          b[d - 1] = arguments[d];
        }

        a >= nb.info && "undefined" !== typeof console && console.info.apply(console, fa(["Conviva: " + c], b, !1));
      }
    };
  }(),
      $e;

  (function (a) {
    a.response_body = "rsb";
    a.request_body = "rqb";
    a.response_headers = "rsh";
    a.request_headers = "rqh";
  })($e || ($e = {}));

  var af = {},
      bf = {};

  (function () {
    var a = {
      rotl: function rotl(c, b) {
        return c << b | c >>> 32 - b;
      },
      rotr: function rotr(c, b) {
        return c << 32 - b | c >>> b;
      },
      endian: function endian(c) {
        if (c.constructor == Number) return a.rotl(c, 8) & 16711935 | a.rotl(c, 24) & 4278255360;

        for (var b = 0; b < c.length; b++) {
          c[b] = a.endian(c[b]);
        }

        return c;
      },
      randomBytes: function randomBytes(c) {
        for (var b = []; 0 < c; c--) {
          b.push(Math.floor(256 * Math.random()));
        }

        return b;
      },
      bytesToWords: function bytesToWords(c) {
        for (var b = [], d = 0, f = 0; d < c.length; d++, f += 8) {
          b[f >>> 5] |= c[d] << 24 - f % 32;
        }

        return b;
      },
      wordsToBytes: function wordsToBytes(c) {
        for (var b = [], d = 0; d < 32 * c.length; d += 8) {
          b.push(c[d >>> 5] >>> 24 - d % 32 & 255);
        }

        return b;
      },
      bytesToHex: function bytesToHex(c) {
        for (var b = [], d = 0; d < c.length; d++) {
          b.push((c[d] >>> 4).toString(16)), b.push((c[d] & 15).toString(16));
        }

        return b.join("");
      },
      hexToBytes: function hexToBytes(c) {
        for (var b = [], d = 0; d < c.length; d += 2) {
          b.push(parseInt(c.substr(d, 2), 16));
        }

        return b;
      },
      bytesToBase64: function bytesToBase64(c) {
        for (var b = [], d = 0; d < c.length; d += 3) {
          for (var f = c[d] << 16 | c[d + 1] << 8 | c[d + 2], g = 0; 4 > g; g++) {
            8 * d + 6 * g <= 8 * c.length ? b.push("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(f >>> 6 * (3 - g) & 63)) : b.push("=");
          }
        }

        return b.join("");
      },
      base64ToBytes: function base64ToBytes(c) {
        c = c.replace(/[^A-Z0-9+\/]/ig, "");

        for (var b = [], d = 0, f = 0; d < c.length; f = ++d % 4) {
          0 != f && b.push(("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(c.charAt(d - 1)) & Math.pow(2, -2 * f + 8) - 1) << 2 * f | "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(c.charAt(d)) >>> 6 - 2 * f);
        }

        return b;
      }
    };
    bf = a;
  })();

  var ae = {
    utf8: {
      stringToBytes: function stringToBytes(a) {
        return ae.bin.stringToBytes(unescape(encodeURIComponent(a)));
      },
      bytesToString: function bytesToString(a) {
        return decodeURIComponent(escape(ae.bin.bytesToString(a)));
      }
    },
    bin: {
      stringToBytes: function stringToBytes(a) {
        for (var c = [], b = 0; b < a.length; b++) {
          c.push(a.charCodeAt(b) & 255);
        }

        return c;
      },
      bytesToString: function bytesToString(a) {
        for (var c = [], b = 0; b < a.length; b++) {
          c.push(String.fromCharCode(a[b]));
        }

        return c.join("");
      }
    }
  },
      cf = ae;

  (function () {
    var a = bf,
        c = cf.utf8,
        b = cf.bin,
        d = function d(f, g) {
      var l = a.wordsToBytes,
          m = f;
      m.constructor == String ? m = c.stringToBytes(m) : "undefined" !== typeof Buffer && "function" == typeof Buffer.isBuffer && Buffer.isBuffer(m) ? m = Array.prototype.slice.call(m, 0) : Array.isArray(m) || (m = m.toString());
      f = a.bytesToWords(m);
      var q = 8 * m.length;
      m = [];
      var r = 1732584193,
          y = -271733879,
          w = -1732584194,
          u = 271733878,
          k = -1009589776;
      f[q >> 5] |= 128 << 24 - q % 32;
      f[(q + 64 >>> 9 << 4) + 15] = q;

      for (q = 0; q < f.length; q += 16) {
        for (var h = r, t = y, x = w, v = u, E = k, F = 0; 80 > F; F++) {
          if (16 > F) m[F] = f[q + F];else {
            var V = m[F - 3] ^ m[F - 8] ^ m[F - 14] ^ m[F - 16];
            m[F] = V << 1 | V >>> 31;
          }
          V = (r << 5 | r >>> 27) + k + (m[F] >>> 0) + (20 > F ? (y & w | ~y & u) + 1518500249 : 40 > F ? (y ^ w ^ u) + 1859775393 : 60 > F ? (y & w | y & u | w & u) - 1894007588 : (y ^ w ^ u) - 899497514);
          k = u;
          u = w;
          w = y << 30 | y >>> 2;
          y = r;
          r = V;
        }

        r += h;
        y += t;
        w += x;
        u += v;
        k += E;
      }

      l = l.call(a, [r, y, w, u, k]);
      return g && g.asBytes ? l : g && g.asString ? b.bytesToString(l) : a.bytesToHex(l);
    };

    d._blocksize = 16;
    d._digestsize = 20;
    af = d;
  })();

  var mg = af;
  var be = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]),
      Uc = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]),
      Ag = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
      df = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
      ob = Array(576);
  Pb(ob);
  var oc = Array(60);
  Pb(oc);
  var Ib = Array(512);
  Pb(Ib);
  var pc = Array(256);
  Pb(pc);
  var ce = Array(29);
  Pb(ce);
  var Vc = Array(30);
  Pb(Vc);

  var ef,
      ff,
      gf,
      qc = function qc(a, c) {
    a.pending_buf[a.pending++] = c & 255;
    a.pending_buf[a.pending++] = c >>> 8 & 255;
  },
      Da = function Da(a, c, b) {
    a.bi_valid > 16 - b ? (a.bi_buf |= c << a.bi_valid & 65535, qc(a, a.bi_buf), a.bi_buf = c >> 16 - a.bi_valid, a.bi_valid += b - 16) : (a.bi_buf |= c << a.bi_valid & 65535, a.bi_valid += b);
  },
      ib = function ib(a, c, b) {
    Da(a, b[2 * c], b[2 * c + 1]);
  },
      hf = function hf(a, c) {
    var b = 0;

    do {
      b |= a & 1, a >>>= 1, b <<= 1;
    } while (0 < --c);

    return b >>> 1;
  },
      jf = function jf(a, c, b) {
    var d = Array(16);
    var f = 0;
    var g;

    for (g = 1; 15 >= g; g++) {
      f = f + b[g - 1] << 1, d[g] = f;
    }

    for (b = 0; b <= c; b++) {
      f = a[2 * b + 1], 0 !== f && (a[2 * b] = hf(d[f]++, f));
    }
  },
      kf = function kf(a) {
    var c;

    for (c = 0; 286 > c; c++) {
      a.dyn_ltree[2 * c] = 0;
    }

    for (c = 0; 30 > c; c++) {
      a.dyn_dtree[2 * c] = 0;
    }

    for (c = 0; 19 > c; c++) {
      a.bl_tree[2 * c] = 0;
    }

    a.dyn_ltree[512] = 1;
    a.opt_len = a.static_len = 0;
    a.sym_next = a.matches = 0;
  },
      lf = function lf(a) {
    8 < a.bi_valid ? qc(a, a.bi_buf) : 0 < a.bi_valid && (a.pending_buf[a.pending++] = a.bi_buf);
    a.bi_buf = 0;
    a.bi_valid = 0;
  },
      mf = function mf(a, c, b, d) {
    var f = 2 * c,
        g = 2 * b;
    return a[f] < a[g] || a[f] === a[g] && d[c] <= d[b];
  },
      de = function de(a, c, b) {
    var d = a.heap[b];
    var f = b << 1;

    for (; f <= a.heap_len;) {
      f < a.heap_len && mf(c, a.heap[f + 1], a.heap[f], a.depth) && f++;
      if (mf(c, d, a.heap[f], a.depth)) break;
      a.heap[b] = a.heap[f];
      b = f;
      f <<= 1;
    }

    a.heap[b] = d;
  },
      nf = function nf(a, c, b) {
    var d,
        f,
        g = 0,
        l,
        m;

    if (0 !== a.sym_next) {
      do {
        d = a.pending_buf[a.sym_buf + g++] & 255, d += (a.pending_buf[a.sym_buf + g++] & 255) << 8, f = a.pending_buf[a.sym_buf + g++], 0 === d ? ib(a, f, c) : (l = pc[f], ib(a, l + 256 + 1, c), m = be[l], 0 !== m && (f -= ce[l], Da(a, f, m)), d--, l = 256 > d ? Ib[d] : Ib[256 + (d >>> 7)], ib(a, l, b), m = Uc[l], 0 !== m && (d -= Vc[l], Da(a, d, m)));
      } while (g < a.sym_next);
    }

    ib(a, 256, c);
  },
      ee = function ee(a, c) {
    var b = c.dyn_tree;
    var d = c.stat_desc.static_tree,
        f = c.stat_desc.has_stree,
        g = c.stat_desc.elems,
        l;
    var m = -1;
    a.heap_len = 0;
    a.heap_max = 573;

    for (l = 0; l < g; l++) {
      0 !== b[2 * l] ? (a.heap[++a.heap_len] = m = l, a.depth[l] = 0) : b[2 * l + 1] = 0;
    }

    for (; 2 > a.heap_len;) {
      var q = a.heap[++a.heap_len] = 2 > m ? ++m : 0;
      b[2 * q] = 1;
      a.depth[q] = 0;
      a.opt_len--;
      f && (a.static_len -= d[2 * q + 1]);
    }

    c.max_code = m;

    for (l = a.heap_len >> 1; 1 <= l; l--) {
      de(a, b, l);
    }

    q = g;

    do {
      l = a.heap[1], a.heap[1] = a.heap[a.heap_len--], de(a, b, 1), d = a.heap[1], a.heap[--a.heap_max] = l, a.heap[--a.heap_max] = d, b[2 * q] = b[2 * l] + b[2 * d], a.depth[q] = (a.depth[l] >= a.depth[d] ? a.depth[l] : a.depth[d]) + 1, b[2 * l + 1] = b[2 * d + 1] = q, a.heap[1] = q++, de(a, b, 1);
    } while (2 <= a.heap_len);

    a.heap[--a.heap_max] = a.heap[1];
    {
      l = c.dyn_tree;
      q = c.max_code;
      d = c.stat_desc.static_tree;
      f = c.stat_desc.has_stree;
      g = c.stat_desc.extra_bits;
      var r = c.stat_desc.extra_base,
          y = c.stat_desc.max_length;
      var w,
          u,
          k,
          h,
          t = 0;

      for (u = 0; 15 >= u; u++) {
        a.bl_count[u] = 0;
      }

      l[2 * a.heap[a.heap_max] + 1] = 0;

      for (c = a.heap_max + 1; 573 > c; c++) {
        w = a.heap[c], u = l[2 * l[2 * w + 1] + 1] + 1, u > y && (u = y, t++), l[2 * w + 1] = u, w > q || (a.bl_count[u]++, k = 0, w >= r && (k = g[w - r]), h = l[2 * w], a.opt_len += h * (u + k), f && (a.static_len += h * (d[2 * w + 1] + k)));
      }

      if (0 !== t) {
        do {
          for (u = y - 1; 0 === a.bl_count[u];) {
            u--;
          }

          a.bl_count[u]--;
          a.bl_count[u + 1] += 2;
          a.bl_count[y]--;
          t -= 2;
        } while (0 < t);

        for (u = y; 0 !== u; u--) {
          for (w = a.bl_count[u]; 0 !== w;) {
            d = a.heap[--c], d > q || (l[2 * d + 1] !== u && (a.opt_len += (u - l[2 * d + 1]) * l[2 * d], l[2 * d + 1] = u), w--);
          }
        }
      }
    }
    jf(b, m, a.bl_count);
  },
      of = function of(a, c, b) {
    var d,
        f = -1,
        g,
        l = c[1],
        m = 0,
        q = 7,
        r = 4;
    0 === l && (q = 138, r = 3);
    c[2 * (b + 1) + 1] = 65535;

    for (d = 0; d <= b; d++) {
      g = l, l = c[2 * (d + 1) + 1], ++m < q && g === l || (m < r ? a.bl_tree[2 * g] += m : 0 !== g ? (g !== f && a.bl_tree[2 * g]++, a.bl_tree[32]++) : 10 >= m ? a.bl_tree[34]++ : a.bl_tree[36]++, m = 0, f = g, 0 === l ? (q = 138, r = 3) : g === l ? (q = 6, r = 3) : (q = 7, r = 4));
    }
  },
      pf = function pf(a, c, b) {
    var d,
        f = -1,
        g,
        l = c[1],
        m = 0,
        q = 7,
        r = 4;
    0 === l && (q = 138, r = 3);

    for (d = 0; d <= b; d++) {
      if (g = l, l = c[2 * (d + 1) + 1], !(++m < q && g === l)) {
        if (m < r) {
          do {
            ib(a, g, a.bl_tree);
          } while (0 !== --m);
        } else 0 !== g ? (g !== f && (ib(a, g, a.bl_tree), m--), ib(a, 16, a.bl_tree), Da(a, m - 3, 2)) : 10 >= m ? (ib(a, 17, a.bl_tree), Da(a, m - 3, 3)) : (ib(a, 18, a.bl_tree), Da(a, m - 11, 7));

        m = 0;
        f = g;
        0 === l ? (q = 138, r = 3) : g === l ? (q = 6, r = 3) : (q = 7, r = 4);
      }
    }
  },
      Bg = function Bg(a) {
    var c = 4093624447,
        b;

    for (b = 0; 31 >= b; b++, c >>>= 1) {
      if (c & 1 && 0 !== a.dyn_ltree[2 * b]) return 0;
    }

    if (0 !== a.dyn_ltree[18] || 0 !== a.dyn_ltree[20] || 0 !== a.dyn_ltree[26]) return 1;

    for (b = 32; 256 > b; b++) {
      if (0 !== a.dyn_ltree[2 * b]) return 1;
    }

    return 0;
  },
      qf = !1,
      rf = function rf(a, c, b, d) {
    Da(a, d ? 1 : 0, 3);
    lf(a);
    qc(a, b);
    qc(a, ~b);
    b && a.pending_buf.set(a.window.subarray(c, c + b), a.pending);
    a.pending += b;
  };

  var Cg = {
    _tr_init: function _tr_init(a) {
      if (!qf) {
        var c, b;
        var d;
        var f = Array(16);

        for (d = b = 0; 28 > d; d++) {
          for (ce[d] = b, c = 0; c < 1 << be[d]; c++) {
            pc[b++] = d;
          }
        }

        pc[b - 1] = d;

        for (d = b = 0; 16 > d; d++) {
          for (Vc[d] = b, c = 0; c < 1 << Uc[d]; c++) {
            Ib[b++] = d;
          }
        }

        for (b >>= 7; 30 > d; d++) {
          for (Vc[d] = b << 7, c = 0; c < 1 << Uc[d] - 7; c++) {
            Ib[256 + b++] = d;
          }
        }

        for (c = 0; 15 >= c; c++) {
          f[c] = 0;
        }

        for (c = 0; 143 >= c;) {
          ob[2 * c + 1] = 8, c++, f[8]++;
        }

        for (; 255 >= c;) {
          ob[2 * c + 1] = 9, c++, f[9]++;
        }

        for (; 279 >= c;) {
          ob[2 * c + 1] = 7, c++, f[7]++;
        }

        for (; 287 >= c;) {
          ob[2 * c + 1] = 8, c++, f[8]++;
        }

        jf(ob, 287, f);

        for (c = 0; 30 > c; c++) {
          oc[2 * c + 1] = 5, oc[2 * c] = hf(c, 5);
        }

        ef = new ad(ob, be, 257, 286, 15);
        ff = new ad(oc, Uc, 0, 30, 15);
        gf = new ad([], Ag, 0, 19, 7);
        qf = !0;
      }

      a.l_desc = new bd(a.dyn_ltree, ef);
      a.d_desc = new bd(a.dyn_dtree, ff);
      a.bl_desc = new bd(a.bl_tree, gf);
      a.bi_buf = 0;
      a.bi_valid = 0;
      kf(a);
    },
    _tr_stored_block: rf,
    _tr_flush_block: function _tr_flush_block(a, c, b, d) {
      var f;
      var g = 0;

      if (0 < a.level) {
        2 === a.strm.data_type && (a.strm.data_type = Bg(a));
        ee(a, a.l_desc);
        ee(a, a.d_desc);
        of(a, a.dyn_ltree, a.l_desc.max_code);
        of(a, a.dyn_dtree, a.d_desc.max_code);
        ee(a, a.bl_desc);

        for (g = 18; 3 <= g && 0 === a.bl_tree[2 * df[g] + 1]; g--) {
          ;
        }

        a.opt_len += 3 * (g + 1) + 14;
        var l = a.opt_len + 3 + 7 >>> 3;
        f = a.static_len + 3 + 7 >>> 3;
        f <= l && (l = f);
      } else l = f = b + 5;

      if (b + 4 <= l && -1 !== c) rf(a, c, b, d);else if (4 === a.strategy || f === l) Da(a, 2 + (d ? 1 : 0), 3), nf(a, ob, oc);else {
        Da(a, 4 + (d ? 1 : 0), 3);
        c = a.l_desc.max_code + 1;
        b = a.d_desc.max_code + 1;
        g += 1;
        Da(a, c - 257, 5);
        Da(a, b - 1, 5);
        Da(a, g - 4, 4);

        for (l = 0; l < g; l++) {
          Da(a, a.bl_tree[2 * df[l] + 1], 3);
        }

        pf(a, a.dyn_ltree, c - 1);
        pf(a, a.dyn_dtree, b - 1);
        nf(a, a.dyn_ltree, a.dyn_dtree);
      }
      kf(a);
      d && lf(a);
    },
    _tr_tally: function _tr_tally(a, c, b) {
      a.pending_buf[a.sym_buf + a.sym_next++] = c;
      a.pending_buf[a.sym_buf + a.sym_next++] = c >> 8;
      a.pending_buf[a.sym_buf + a.sym_next++] = b;
      0 === c ? a.dyn_ltree[2 * b]++ : (a.matches++, c--, a.dyn_ltree[2 * (pc[b] + 256 + 1)]++, a.dyn_dtree[2 * (256 > c ? Ib[c] : Ib[256 + (c >>> 7)])]++);
      return a.sym_next === a.sym_end;
    },
    _tr_align: function _tr_align(a) {
      Da(a, 2, 3);
      ib(a, 256, ob);
      16 === a.bi_valid ? (qc(a, a.bi_buf), a.bi_buf = 0, a.bi_valid = 0) : 8 <= a.bi_valid && (a.pending_buf[a.pending++] = a.bi_buf & 255, a.bi_buf >>= 8, a.bi_valid -= 8);
    }
  },
      rc = function rc(a, c, b, d) {
    var f = a & 65535 | 0;
    a = a >>> 16 & 65535 | 0;
    var g;

    for (; 0 !== b;) {
      g = 2E3 < b ? 2E3 : b;
      b -= g;

      do {
        f = f + c[d++] | 0, a = a + f | 0;
      } while (--g);

      f %= 65521;
      a %= 65521;
    }

    return f | a << 16 | 0;
  };

  var Dg = new Uint32Array(function () {
    var a,
        c = [];

    for (var b = 0; 256 > b; b++) {
      a = b;

      for (var d = 0; 8 > d; d++) {
        a = a & 1 ? 3988292384 ^ a >>> 1 : a >>> 1;
      }

      c[b] = a;
    }

    return c;
  }());

  var pa = function pa(a, c, b, d) {
    b = d + b;

    for (a ^= -1; d < b; d++) {
      a = a >>> 8 ^ Dg[(a ^ c[d]) & 255];
    }

    return a ^ -1;
  },
      Ab = {
    2: "need dictionary",
    1: "stream end",
    0: "",
    "-1": "file error",
    "-2": "stream error",
    "-3": "data error",
    "-4": "insufficient memory",
    "-5": "buffer error",
    "-6": "incompatible version"
  },
      Jb = {
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    Z_BINARY: 0,
    Z_TEXT: 1,
    Z_UNKNOWN: 2,
    Z_DEFLATED: 8
  };

  var Eg = Cg._tr_init,
      fe = Cg._tr_stored_block,
      Fg = Cg._tr_flush_block,
      xb = Cg._tr_tally,
      Gg = Cg._tr_align,
      yb = Jb.Z_NO_FLUSH,
      Hg = Jb.Z_PARTIAL_FLUSH,
      Ig = Jb.Z_FULL_FLUSH,
      Na = Jb.Z_FINISH,
      sf = Jb.Z_BLOCK,
      ta = Jb.Z_OK,
      tf = Jb.Z_STREAM_END,
      jb = Jb.Z_STREAM_ERROR,
      Jg = Jb.Z_DATA_ERROR,
      ge = Jb.Z_BUF_ERROR,
      Kg = Jb.Z_DEFAULT_COMPRESSION,
      Lg = Jb.Z_FILTERED,
      Wc = Jb.Z_HUFFMAN_ONLY,
      Mg = Jb.Z_RLE,
      Ng = Jb.Z_FIXED,
      Og = Jb.Z_DEFAULT_STRATEGY,
      Pg = Jb.Z_UNKNOWN,
      Ac = Jb.Z_DEFLATED,
      Kb = function Kb(a, c) {
    a.msg = Ab[c];
    return c;
  },
      rb = function rb(a) {
    var c = a.length;

    for (; 0 <= --c;) {
      a[c] = 0;
    }
  },
      Ha = function Ha(a) {
    var c = a.state;
    var b = c.pending;
    b > a.avail_out && (b = a.avail_out);
    0 !== b && (a.output.set(c.pending_buf.subarray(c.pending_out, c.pending_out + b), a.next_out), a.next_out += b, c.pending_out += b, a.total_out += b, a.avail_out -= b, c.pending -= b, 0 === c.pending && (c.pending_out = 0));
  },
      Ia = function Ia(a, c) {
    Fg(a, 0 <= a.block_start ? a.block_start : -1, a.strstart - a.block_start, c);
    a.block_start = a.strstart;
    Ha(a.strm);
  },
      sc = function sc(a, c) {
    a.pending_buf[a.pending++] = c >>> 8 & 255;
    a.pending_buf[a.pending++] = c & 255;
  },
      he = function he(a, c, b, d) {
    var f = a.avail_in;
    f > d && (f = d);
    if (0 === f) return 0;
    a.avail_in -= f;
    c.set(a.input.subarray(a.next_in, a.next_in + f), b);
    1 === a.state.wrap ? a.adler = rc(a.adler, c, f, b) : 2 === a.state.wrap && (a.adler = pa(a.adler, c, f, b));
    a.next_in += f;
    a.total_in += f;
    return f;
  },
      uf = function uf(a, c) {
    var b = a.max_chain_length,
        d = a.strstart;
    var f = a.prev_length,
        g = a.nice_match;
    var l = a.strstart > a.w_size - 262 ? a.strstart - (a.w_size - 262) : 0,
        m = a.window,
        q = a.w_mask,
        r = a.prev,
        y = a.strstart + 258;
    var w = m[d + f - 1],
        u = m[d + f];
    a.prev_length >= a.good_match && (b >>= 2);
    g > a.lookahead && (g = a.lookahead);

    do {
      var k = c;

      if (m[k + f] === u && m[k + f - 1] === w && m[k] === m[d] && m[++k] === m[d + 1]) {
        d += 2;

        for (k++; m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && m[++d] === m[++k] && d < y;) {
          ;
        }

        k = 258 - (y - d);
        d = y - 258;

        if (k > f) {
          a.match_start = c;
          f = k;
          if (k >= g) break;
          w = m[d + f - 1];
          u = m[d + f];
        }
      }
    } while ((c = r[c & q]) > l && 0 !== --b);

    return f <= a.lookahead ? f : a.lookahead;
  },
      Yb = function Yb(a) {
    var c = a.w_size;

    do {
      var b = a.window_size - a.lookahead - a.strstart;

      if (a.strstart >= c + (c - 262)) {
        a.window.set(a.window.subarray(c, c + c - b), 0);
        a.match_start -= c;
        a.strstart -= c;
        a.block_start -= c;
        a.insert > a.strstart && (a.insert = a.strstart);
        var f = void 0,
            g = void 0,
            l = void 0;
        var d = a;
        var m = d.w_size;
        f = l = d.hash_size;

        do {
          g = d.head[--f], d.head[f] = g >= m ? g - m : 0;
        } while (--l);

        f = l = m;

        do {
          g = d.prev[--f], d.prev[f] = g >= m ? g - m : 0;
        } while (--l);

        b += c;
      }

      if (0 === a.strm.avail_in) break;
      b = he(a.strm, a.window, a.strstart + a.lookahead, b);
      a.lookahead += b;
      if (3 <= a.lookahead + a.insert) for (b = a.strstart - a.insert, a.ins_h = a.window[b], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[b + 1]) & a.hash_mask; a.insert && !(a.ins_h = (a.ins_h << a.hash_shift ^ a.window[b + 3 - 1]) & a.hash_mask, a.prev[b & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = b, b++, a.insert--, 3 > a.lookahead + a.insert);) {
        ;
      }
    } while (262 > a.lookahead && 0 !== a.strm.avail_in);
  },
      vf = function vf(a, c) {
    var b = a.pending_buf_size - 5 > a.w_size ? a.w_size : a.pending_buf_size - 5,
        d,
        f,
        g,
        l = 0,
        m = a.strm.avail_in;

    do {
      d = 65535;
      g = a.bi_valid + 42 >> 3;
      if (a.strm.avail_out < g) break;
      g = a.strm.avail_out - g;
      f = a.strstart - a.block_start;
      d > f + a.strm.avail_in && (d = f + a.strm.avail_in);
      d > g && (d = g);
      if (d < b && (0 === d && c !== Na || c === yb || d !== f + a.strm.avail_in)) break;
      l = c === Na && d === f + a.strm.avail_in ? 1 : 0;
      fe(a, 0, 0, l);
      a.pending_buf[a.pending - 4] = d;
      a.pending_buf[a.pending - 3] = d >> 8;
      a.pending_buf[a.pending - 2] = ~d;
      a.pending_buf[a.pending - 1] = ~d >> 8;
      Ha(a.strm);
      f && (f > d && (f = d), a.strm.output.set(a.window.subarray(a.block_start, a.block_start + f), a.strm.next_out), a.strm.next_out += f, a.strm.avail_out -= f, a.strm.total_out += f, a.block_start += f, d -= f);
      d && (he(a.strm, a.strm.output, a.strm.next_out, d), a.strm.next_out += d, a.strm.avail_out -= d, a.strm.total_out += d);
    } while (0 === l);

    if (m -= a.strm.avail_in) m >= a.w_size ? (a.matches = 2, a.window.set(a.strm.input.subarray(a.strm.next_in - a.w_size, a.strm.next_in), 0), a.strstart = a.w_size, a.insert = a.strstart) : (a.window_size - a.strstart <= m && (a.strstart -= a.w_size, a.window.set(a.window.subarray(a.w_size, a.w_size + a.strstart), 0), 2 > a.matches && a.matches++, a.insert > a.strstart && (a.insert = a.strstart)), a.window.set(a.strm.input.subarray(a.strm.next_in - m, a.strm.next_in), a.strstart), a.strstart += m, a.insert += m > a.w_size - a.insert ? a.w_size - a.insert : m), a.block_start = a.strstart;
    a.high_water < a.strstart && (a.high_water = a.strstart);
    if (l) return 4;
    if (c !== yb && c !== Na && 0 === a.strm.avail_in && a.strstart === a.block_start) return 2;
    g = a.window_size - a.strstart;
    a.strm.avail_in > g && a.block_start >= a.w_size && (a.block_start -= a.w_size, a.strstart -= a.w_size, a.window.set(a.window.subarray(a.w_size, a.w_size + a.strstart), 0), 2 > a.matches && a.matches++, g += a.w_size, a.insert > a.strstart && (a.insert = a.strstart));
    g > a.strm.avail_in && (g = a.strm.avail_in);
    g && (he(a.strm, a.window, a.strstart, g), a.strstart += g, a.insert += g > a.w_size - a.insert ? a.w_size - a.insert : g);
    a.high_water < a.strstart && (a.high_water = a.strstart);
    g = a.bi_valid + 42 >> 3;
    g = 65535 < a.pending_buf_size - g ? 65535 : a.pending_buf_size - g;
    b = g > a.w_size ? a.w_size : g;
    f = a.strstart - a.block_start;
    if (f >= b || (f || c === Na) && c !== yb && 0 === a.strm.avail_in && f <= g) d = f > g ? g : f, l = c === Na && 0 === a.strm.avail_in && d === f ? 1 : 0, fe(a, a.block_start, d, l), a.block_start += d, Ha(a.strm);
    return l ? 3 : 1;
  },
      ie = function ie(a, c) {
    for (var b;;) {
      if (262 > a.lookahead) {
        Yb(a);
        if (262 > a.lookahead && c === yb) return 1;
        if (0 === a.lookahead) break;
      }

      b = 0;
      3 <= a.lookahead && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 3 - 1]) & a.hash_mask, b = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
      0 !== b && a.strstart - b <= a.w_size - 262 && (a.match_length = uf(a, b));
      if (3 <= a.match_length) {
        if (b = xb(a, a.strstart - a.match_start, a.match_length - 3), a.lookahead -= a.match_length, a.match_length <= a.max_lazy_match && 3 <= a.lookahead) {
          a.match_length--;

          do {
            a.strstart++, a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 3 - 1]) & a.hash_mask, a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart;
          } while (0 !== --a.match_length);

          a.strstart++;
        } else a.strstart += a.match_length, a.match_length = 0, a.ins_h = a.window[a.strstart], a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 1]) & a.hash_mask;
      } else b = xb(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++;
      if (b && (Ia(a, !1), 0 === a.strm.avail_out)) return 1;
    }

    a.insert = 2 > a.strstart ? a.strstart : 2;
    return c === Na ? (Ia(a, !0), 0 === a.strm.avail_out ? 3 : 4) : a.sym_next && (Ia(a, !1), 0 === a.strm.avail_out) ? 1 : 2;
  },
      Zb = function Zb(a, c) {
    var b;

    for (;;) {
      if (262 > a.lookahead) {
        Yb(a);
        if (262 > a.lookahead && c === yb) return 1;
        if (0 === a.lookahead) break;
      }

      var d = 0;
      3 <= a.lookahead && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 3 - 1]) & a.hash_mask, d = a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
      a.prev_length = a.match_length;
      a.prev_match = a.match_start;
      a.match_length = 2;
      0 !== d && a.prev_length < a.max_lazy_match && a.strstart - d <= a.w_size - 262 && (a.match_length = uf(a, d), 5 >= a.match_length && (a.strategy === Lg || 3 === a.match_length && 4096 < a.strstart - a.match_start) && (a.match_length = 2));

      if (3 <= a.prev_length && a.match_length <= a.prev_length) {
        b = a.strstart + a.lookahead - 3;
        d = xb(a, a.strstart - 1 - a.prev_match, a.prev_length - 3);
        a.lookahead -= a.prev_length - 1;
        a.prev_length -= 2;

        do {
          ++a.strstart <= b && (a.ins_h = (a.ins_h << a.hash_shift ^ a.window[a.strstart + 3 - 1]) & a.hash_mask, a.prev[a.strstart & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = a.strstart);
        } while (0 !== --a.prev_length);

        a.match_available = 0;
        a.match_length = 2;
        a.strstart++;
        if (d && (Ia(a, !1), 0 === a.strm.avail_out)) return 1;
      } else if (a.match_available) {
        if ((d = xb(a, 0, a.window[a.strstart - 1])) && Ia(a, !1), a.strstart++, a.lookahead--, 0 === a.strm.avail_out) return 1;
      } else a.match_available = 1, a.strstart++, a.lookahead--;
    }

    a.match_available && (xb(a, 0, a.window[a.strstart - 1]), a.match_available = 0);
    a.insert = 2 > a.strstart ? a.strstart : 2;
    return c === Na ? (Ia(a, !0), 0 === a.strm.avail_out ? 3 : 4) : a.sym_next && (Ia(a, !1), 0 === a.strm.avail_out) ? 1 : 2;
  },
      Qg = function Qg(a, c) {
    var b, d;
    var f = a.window;

    for (;;) {
      if (258 >= a.lookahead) {
        Yb(a);
        if (258 >= a.lookahead && c === yb) return 1;
        if (0 === a.lookahead) break;
      }

      a.match_length = 0;

      if (3 <= a.lookahead && 0 < a.strstart) {
        b = a.strstart - 1;
        var g = f[b];

        if (g === f[++b] && g === f[++b] && g === f[++b]) {
          for (d = a.strstart + 258; g === f[++b] && g === f[++b] && g === f[++b] && g === f[++b] && g === f[++b] && g === f[++b] && g === f[++b] && g === f[++b] && b < d;) {
            ;
          }

          a.match_length = 258 - (d - b);
          a.match_length > a.lookahead && (a.match_length = a.lookahead);
        }
      }

      3 <= a.match_length ? (g = xb(a, 1, a.match_length - 3), a.lookahead -= a.match_length, a.strstart += a.match_length, a.match_length = 0) : (g = xb(a, 0, a.window[a.strstart]), a.lookahead--, a.strstart++);
      if (g && (Ia(a, !1), 0 === a.strm.avail_out)) return 1;
    }

    a.insert = 0;
    return c === Na ? (Ia(a, !0), 0 === a.strm.avail_out ? 3 : 4) : a.sym_next && (Ia(a, !1), 0 === a.strm.avail_out) ? 1 : 2;
  },
      Rg = function Rg(a, c) {
    var b;

    for (;;) {
      if (0 === a.lookahead && (Yb(a), 0 === a.lookahead)) {
        if (c === yb) return 1;
        break;
      }

      a.match_length = 0;
      b = xb(a, 0, a.window[a.strstart]);
      a.lookahead--;
      a.strstart++;
      if (b && (Ia(a, !1), 0 === a.strm.avail_out)) return 1;
    }

    a.insert = 0;
    return c === Na ? (Ia(a, !0), 0 === a.strm.avail_out ? 3 : 4) : a.sym_next && (Ia(a, !1), 0 === a.strm.avail_out) ? 1 : 2;
  },
      tc = [new bb(0, 0, 0, 0, vf), new bb(4, 4, 8, 4, ie), new bb(4, 5, 16, 8, ie), new bb(4, 6, 32, 32, ie), new bb(4, 4, 16, 16, Zb), new bb(8, 16, 32, 32, Zb), new bb(8, 16, 128, 128, Zb), new bb(8, 32, 128, 256, Zb), new bb(32, 128, 258, 1024, Zb), new bb(32, 258, 258, 4096, Zb)],
      uc = function uc(a) {
    if (!a) return 1;
    var c = a.state;
    return !c || c.strm !== a || 42 !== c.status && 57 !== c.status && 69 !== c.status && 73 !== c.status && 91 !== c.status && 103 !== c.status && 113 !== c.status && 666 !== c.status ? 1 : 0;
  },
      wf = function wf(a) {
    if (uc(a)) return Kb(a, jb);
    a.total_in = a.total_out = 0;
    a.data_type = Pg;
    var c = a.state;
    c.pending = 0;
    c.pending_out = 0;
    0 > c.wrap && (c.wrap = -c.wrap);
    c.status = 2 === c.wrap ? 57 : c.wrap ? 42 : 113;
    a.adler = 2 === c.wrap ? 0 : 1;
    c.last_flush = -2;
    Eg(c);
    return ta;
  },
      xf = function xf(a) {
    var c = wf(a);
    c === ta && (a = a.state, a.window_size = 2 * a.w_size, rb(a.head), a.max_lazy_match = tc[a.level].max_lazy, a.good_match = tc[a.level].good_length, a.nice_match = tc[a.level].nice_length, a.max_chain_length = tc[a.level].max_chain, a.strstart = 0, a.block_start = 0, a.lookahead = 0, a.insert = 0, a.match_length = a.prev_length = 2, a.match_available = 0, a.ins_h = 0);
    return c;
  },
      yf = function yf(a, c, b, d, f, g) {
    if (!a) return jb;
    var l = 1;
    c === Kg && (c = 6);
    0 > d ? (l = 0, d = -d) : 15 < d && (l = 2, d -= 16);
    if (1 > f || 9 < f || b !== Ac || 8 > d || 15 < d || 0 > c || 9 < c || 0 > g || g > Ng || 8 === d && 1 !== l) return Kb(a, jb);
    8 === d && (d = 9);
    var m = new $f();
    a.state = m;
    m.strm = a;
    m.status = 42;
    m.wrap = l;
    m.gzhead = null;
    m.w_bits = d;
    m.w_size = 1 << m.w_bits;
    m.w_mask = m.w_size - 1;
    m.hash_bits = f + 7;
    m.hash_size = 1 << m.hash_bits;
    m.hash_mask = m.hash_size - 1;
    m.hash_shift = ~~((m.hash_bits + 3 - 1) / 3);
    m.window = new Uint8Array(2 * m.w_size);
    m.head = new Uint16Array(m.hash_size);
    m.prev = new Uint16Array(m.w_size);
    m.lit_bufsize = 1 << f + 6;
    m.pending_buf_size = 4 * m.lit_bufsize;
    m.pending_buf = new Uint8Array(m.pending_buf_size);
    m.sym_buf = m.lit_bufsize;
    m.sym_end = 3 * (m.lit_bufsize - 1);
    m.level = c;
    m.strategy = g;
    m.method = b;
    return xf(a);
  };

  var bc = {
    deflateInit: function deflateInit(a, c) {
      return yf(a, c, Ac, 15, 8, Og);
    },
    deflateInit2: yf,
    deflateReset: xf,
    deflateResetKeep: wf,
    deflateSetHeader: function deflateSetHeader(a, c) {
      if (uc(a) || 2 !== a.state.wrap) return jb;
      a.state.gzhead = c;
      return ta;
    },
    deflate: function deflate(a, c) {
      if (uc(a) || c > sf || 0 > c) return a ? Kb(a, jb) : jb;
      var b = a.state;
      if (!a.output || 0 !== a.avail_in && !a.input || 666 === b.status && c !== Na) return Kb(a, 0 === a.avail_out ? ge : jb);
      var d = b.last_flush;
      b.last_flush = c;

      if (0 !== b.pending) {
        if (Ha(a), 0 === a.avail_out) return b.last_flush = -1, ta;
      } else if (0 === a.avail_in && 2 * c - (4 < c ? 9 : 0) <= 2 * d - (4 < d ? 9 : 0) && c !== Na) return Kb(a, ge);

      if (666 === b.status && 0 !== a.avail_in) return Kb(a, ge);
      42 === b.status && 0 === b.wrap && (b.status = 113);
      if (42 === b.status && (d = Ac + (b.w_bits - 8 << 4) << 8, d |= (b.strategy >= Wc || 2 > b.level ? 0 : 6 > b.level ? 1 : 6 === b.level ? 2 : 3) << 6, 0 !== b.strstart && (d |= 32), d += 31 - d % 31, sc(b, d), 0 !== b.strstart && (sc(b, a.adler >>> 16), sc(b, a.adler & 65535)), a.adler = 1, b.status = 113, Ha(a), 0 !== b.pending)) return b.last_flush = -1, ta;
      if (57 === b.status) if (a.adler = 0, b.pending_buf[b.pending++] = 31, b.pending_buf[b.pending++] = 139, b.pending_buf[b.pending++] = 8, b.gzhead) d = (b.gzhead.text ? 1 : 0) + (b.gzhead.hcrc ? 2 : 0) + (b.gzhead.extra ? 4 : 0) + (b.gzhead.name ? 8 : 0) + (b.gzhead.comment ? 16 : 0), b.pending_buf[b.pending++] = d, d = b.gzhead.time & 255, b.pending_buf[b.pending++] = d, d = b.gzhead.time >> 8 & 255, b.pending_buf[b.pending++] = d, d = b.gzhead.time >> 16 & 255, b.pending_buf[b.pending++] = d, d = b.gzhead.time >> 24 & 255, b.pending_buf[b.pending++] = d, d = 9 === b.level ? 2 : b.strategy >= Wc || 2 > b.level ? 4 : 0, b.pending_buf[b.pending++] = d, d = b.gzhead.os & 255, b.pending_buf[b.pending++] = d, b.gzhead.extra && b.gzhead.extra.length && (d = b.gzhead.extra.length & 255, b.pending_buf[b.pending++] = d, d = b.gzhead.extra.length >> 8 & 255, b.pending_buf[b.pending++] = d), b.gzhead.hcrc && (a.adler = pa(a.adler, b.pending_buf, b.pending, 0)), b.gzindex = 0, b.status = 69;else if (b.pending_buf[b.pending++] = 0, b.pending_buf[b.pending++] = 0, b.pending_buf[b.pending++] = 0, b.pending_buf[b.pending++] = 0, b.pending_buf[b.pending++] = 0, d = 9 === b.level ? 2 : b.strategy >= Wc || 2 > b.level ? 4 : 0, b.pending_buf[b.pending++] = d, b.pending_buf[b.pending++] = 3, b.status = 113, Ha(a), 0 !== b.pending) return b.last_flush = -1, ta;

      if (69 === b.status) {
        if (b.gzhead.extra) {
          d = b.pending;

          for (var f = (b.gzhead.extra.length & 65535) - b.gzindex; b.pending + f > b.pending_buf_size;) {
            var g = b.pending_buf_size - b.pending;
            b.pending_buf.set(b.gzhead.extra.subarray(b.gzindex, b.gzindex + g), b.pending);
            b.pending = b.pending_buf_size;
            b.gzhead.hcrc && b.pending > d && (a.adler = pa(a.adler, b.pending_buf, b.pending - d, d));
            b.gzindex += g;
            Ha(a);
            if (0 !== b.pending) return b.last_flush = -1, ta;
            d = 0;
            f -= g;
          }

          g = new Uint8Array(b.gzhead.extra);
          b.pending_buf.set(g.subarray(b.gzindex, b.gzindex + f), b.pending);
          b.pending += f;
          b.gzhead.hcrc && b.pending > d && (a.adler = pa(a.adler, b.pending_buf, b.pending - d, d));
          b.gzindex = 0;
        }

        b.status = 73;
      }

      if (73 === b.status) {
        if (b.gzhead.name) {
          f = b.pending;

          do {
            if (b.pending === b.pending_buf_size) {
              b.gzhead.hcrc && b.pending > f && (a.adler = pa(a.adler, b.pending_buf, b.pending - f, f));
              Ha(a);
              if (0 !== b.pending) return b.last_flush = -1, ta;
              f = 0;
            }

            d = g = b.gzindex < b.gzhead.name.length ? b.gzhead.name.charCodeAt(b.gzindex++) & 255 : 0;
            b.pending_buf[b.pending++] = d;
          } while (0 !== g);

          b.gzhead.hcrc && b.pending > f && (a.adler = pa(a.adler, b.pending_buf, b.pending - f, f));
          b.gzindex = 0;
        }

        b.status = 91;
      }

      if (91 === b.status) {
        if (b.gzhead.comment) {
          f = b.pending;

          do {
            if (b.pending === b.pending_buf_size) {
              b.gzhead.hcrc && b.pending > f && (a.adler = pa(a.adler, b.pending_buf, b.pending - f, f));
              Ha(a);
              if (0 !== b.pending) return b.last_flush = -1, ta;
              f = 0;
            }

            d = g = b.gzindex < b.gzhead.comment.length ? b.gzhead.comment.charCodeAt(b.gzindex++) & 255 : 0;
            b.pending_buf[b.pending++] = d;
          } while (0 !== g);

          b.gzhead.hcrc && b.pending > f && (a.adler = pa(a.adler, b.pending_buf, b.pending - f, f));
        }

        b.status = 103;
      }

      if (103 === b.status) {
        if (b.gzhead.hcrc) {
          if (b.pending + 2 > b.pending_buf_size && (Ha(a), 0 !== b.pending)) return b.last_flush = -1, ta;
          d = a.adler & 255;
          b.pending_buf[b.pending++] = d;
          d = a.adler >> 8 & 255;
          b.pending_buf[b.pending++] = d;
          a.adler = 0;
        }

        b.status = 113;
        Ha(a);
        if (0 !== b.pending) return b.last_flush = -1, ta;
      }

      if (0 !== a.avail_in || 0 !== b.lookahead || c !== yb && 666 !== b.status) {
        d = 0 === b.level ? vf(b, c) : b.strategy === Wc ? Rg(b, c) : b.strategy === Mg ? Qg(b, c) : tc[b.level].func(b, c);
        if (3 === d || 4 === d) b.status = 666;
        if (1 === d || 3 === d) return 0 === a.avail_out && (b.last_flush = -1), ta;
        if (2 === d && (c === Hg ? Gg(b) : c !== sf && (fe(b, 0, 0, !1), c === Ig && (rb(b.head), 0 === b.lookahead && (b.strstart = 0, b.block_start = 0, b.insert = 0))), Ha(a), 0 === a.avail_out)) return b.last_flush = -1, ta;
      }

      if (c !== Na) return ta;
      if (0 >= b.wrap) return tf;
      2 === b.wrap ? (c = a.adler & 255, b.pending_buf[b.pending++] = c, c = a.adler >> 8 & 255, b.pending_buf[b.pending++] = c, c = a.adler >> 16 & 255, b.pending_buf[b.pending++] = c, c = a.adler >> 24 & 255, b.pending_buf[b.pending++] = c, c = a.total_in & 255, b.pending_buf[b.pending++] = c, c = a.total_in >> 8 & 255, b.pending_buf[b.pending++] = c, c = a.total_in >> 16 & 255, b.pending_buf[b.pending++] = c, c = a.total_in >> 24 & 255, b.pending_buf[b.pending++] = c) : (sc(b, a.adler >>> 16), sc(b, a.adler & 65535));
      Ha(a);
      0 < b.wrap && (b.wrap = -b.wrap);
      return 0 !== b.pending ? ta : tf;
    },
    deflateEnd: function deflateEnd(a) {
      if (uc(a)) return jb;
      var c = a.state.status;
      a.state = null;
      return 113 === c ? Kb(a, Jg) : ta;
    },
    deflateSetDictionary: function deflateSetDictionary(a, c) {
      var b = c.length;
      if (uc(a)) return jb;
      var d = a.state,
          f = d.wrap;
      if (2 === f || 1 === f && 42 !== d.status || d.lookahead) return jb;
      1 === f && (a.adler = rc(a.adler, c, b, 0));
      d.wrap = 0;

      if (b >= d.w_size) {
        0 === f && (rb(d.head), d.strstart = 0, d.block_start = 0, d.insert = 0);
        var g = new Uint8Array(d.w_size);
        g.set(c.subarray(b - d.w_size, b), 0);
        c = g;
        b = d.w_size;
      }

      g = a.avail_in;
      var l = a.next_in,
          m = a.input;
      a.avail_in = b;
      a.next_in = 0;
      a.input = c;

      for (Yb(d); 3 <= d.lookahead;) {
        c = d.strstart;
        b = d.lookahead - 2;

        do {
          d.ins_h = (d.ins_h << d.hash_shift ^ d.window[c + 3 - 1]) & d.hash_mask, d.prev[c & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = c, c++;
        } while (--b);

        d.strstart = c;
        d.lookahead = 2;
        Yb(d);
      }

      d.strstart += d.lookahead;
      d.block_start = d.strstart;
      d.insert = d.lookahead;
      d.lookahead = 0;
      d.match_length = d.prev_length = 2;
      d.match_available = 0;
      a.next_in = l;
      a.input = m;
      a.avail_in = g;
      d.wrap = f;
      return ta;
    },
    deflateInfo: "pako deflate (from Nodeca project)"
  },
      Bc = {
    assign: function assign(a) {
      var c = Array.prototype.slice.call(arguments, 1);

      for (; c.length;) {
        var b = c.shift();

        if (b) {
          if ("object" !== _typeof(b)) throw new TypeError(b + "must be non-object");

          for (var d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
          }
        }
      }

      return a;
    },
    flattenChunks: function flattenChunks(a) {
      var c = 0;

      for (var b = 0, d = a.length; b < d; b++) {
        c += a[b].length;
      }

      c = new Uint8Array(c);

      for (var _b = 0, _d = 0, f = a.length; _b < f; _b++) {
        var g = a[_b];
        c.set(g, _d);
        _d += g.length;
      }

      return c;
    }
  };
  var zf = !0;

  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch (a) {
    zf = !1;
  }

  var vc = new Uint8Array(256);

  for (var a = 0; 256 > a; a++) {
    vc[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
  }

  vc[254] = vc[254] = 1;

  var cc = {
    string2buf: function string2buf(a) {
      if ("function" === typeof TextEncoder && TextEncoder.prototype.encode) return new TextEncoder().encode(a);
      var c,
          b,
          d,
          f,
          g,
          l = a.length,
          m = 0;

      for (f = 0; f < l; f++) {
        b = a.charCodeAt(f), 55296 === (b & 64512) && f + 1 < l && (d = a.charCodeAt(f + 1), 56320 === (d & 64512) && (b = 65536 + (b - 55296 << 10) + (d - 56320), f++)), m += 128 > b ? 1 : 2048 > b ? 2 : 65536 > b ? 3 : 4;
      }

      c = new Uint8Array(m);

      for (f = g = 0; g < m; f++) {
        b = a.charCodeAt(f), 55296 === (b & 64512) && f + 1 < l && (d = a.charCodeAt(f + 1), 56320 === (d & 64512) && (b = 65536 + (b - 55296 << 10) + (d - 56320), f++)), 128 > b ? c[g++] = b : (2048 > b ? c[g++] = 192 | b >>> 6 : (65536 > b ? c[g++] = 224 | b >>> 12 : (c[g++] = 240 | b >>> 18, c[g++] = 128 | b >>> 12 & 63), c[g++] = 128 | b >>> 6 & 63), c[g++] = 128 | b & 63);
      }

      return c;
    },
    buf2string: function buf2string(a, c) {
      var b = c || a.length;
      if ("function" === typeof TextDecoder && TextDecoder.prototype.decode) return new TextDecoder().decode(a.subarray(0, c));
      var d;
      var f;
      c = Array(2 * b);

      for (d = f = 0; d < b;) {
        var g = a[d++];

        if (128 > g) {
          c[f++] = g;
          continue;
        }

        var l = vc[g];
        if (4 < l) c[f++] = 65533, d += l - 1;else {
          for (g &= 2 === l ? 31 : 3 === l ? 15 : 7; 1 < l && d < b;) {
            g = g << 6 | a[d++] & 63, l--;
          }

          1 < l ? c[f++] = 65533 : 65536 > g ? c[f++] = g : (g -= 65536, c[f++] = 55296 | g >> 10 & 1023, c[f++] = 56320 | g & 1023);
        }
      }

      a = f;
      if (65534 > a && c.subarray && zf) c = String.fromCharCode.apply(null, c.length === a ? c : c.subarray(0, a));else {
        b = "";

        for (d = 0; d < a; d++) {
          b += String.fromCharCode(c[d]);
        }

        c = b;
      }
      return c;
    },
    utf8border: function utf8border(a, c) {
      c = c || a.length;
      c > a.length && (c = a.length);
      var b = c - 1;

      for (; 0 <= b && 128 === (a[b] & 192);) {
        b--;
      }

      return 0 > b || 0 === b ? c : b + vc[a[b]] > c ? b : c;
    }
  },
      xe = function xe() {
    this.input = null;
    this.total_in = this.avail_in = this.next_in = 0;
    this.output = null;
    this.total_out = this.avail_out = this.next_out = 0;
    this.msg = "";
    this.state = null;
    this.data_type = 2;
    this.adler = 0;
  };

  var ye = Object.prototype.toString,
      Sg = Jb.Z_NO_FLUSH,
      Tg = Jb.Z_SYNC_FLUSH,
      Ug = Jb.Z_FULL_FLUSH,
      Vg = Jb.Z_FINISH,
      Cc = Jb.Z_OK,
      Wg = Jb.Z_STREAM_END,
      ag = Jb.Z_DEFAULT_COMPRESSION,
      cg = Jb.Z_DEFAULT_STRATEGY,
      bg = Jb.Z_DEFLATED;

  ac.prototype.push = function (a, c) {
    var b = this.strm,
        d = this.options.chunkSize;
    if (this.ended) return !1;
    c = c === ~~c ? c : !0 === c ? Vg : Sg;
    "string" === typeof a ? b.input = cc.string2buf(a) : "[object ArrayBuffer]" === ye.call(a) ? b.input = new Uint8Array(a) : b.input = a;
    b.next_in = 0;

    for (b.avail_in = b.input.length;;) {
      if (0 === b.avail_out && (b.output = new Uint8Array(d), b.next_out = 0, b.avail_out = d), (c === Tg || c === Ug) && 6 >= b.avail_out) this.onData(b.output.subarray(0, b.next_out)), b.avail_out = 0;else {
        a = bc.deflate(b, c);

        if (a === Wg) {
          if (0 < b.next_out) this.onData(b.output.subarray(0, b.next_out));
          a = bc.deflateEnd(this.strm);
          this.onEnd(a);
          this.ended = !0;
          return a === Cc;
        }

        if (0 === b.avail_out) this.onData(b.output);else if (0 < c && 0 < b.next_out) this.onData(b.output.subarray(0, b.next_out)), b.avail_out = 0;else if (0 === b.avail_in) break;
      }
    }

    return !0;
  };

  ac.prototype.onData = function (a) {
    this.chunks.push(a);
  };

  ac.prototype.onEnd = function (a) {
    a === Cc && (this.result = Bc.flattenChunks(this.chunks));
    this.chunks = [];
    this.err = a;
    this.msg = this.strm.msg;
  };

  var Xg = {
    Deflate: ac,
    deflate: cd,
    deflateRaw: function deflateRaw(a, c) {
      c = c || {};
      c.raw = !0;
      return cd(a, c);
    },
    gzip: function gzip(a, c) {
      c = c || {};
      c.gzip = !0;
      return cd(a, c);
    },
    constants: Jb
  };
  var Yg = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]),
      Zg = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]),
      $g = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]),
      ah = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);

  var wc = function wc(a, c, b, d, f, g, l, m) {
    var q = m.bits;
    var r, y, w, u;
    var k;
    var h, t, x, v, E, F, V, ca;
    var G = new Uint16Array(16);
    var K = new Uint16Array(16);
    var ka, ma, ia, ja;

    for (r = 0; 15 >= r; r++) {
      G[r] = 0;
    }

    for (y = 0; y < d; y++) {
      G[c[b + y]]++;
    }

    u = q;

    for (w = 15; 1 <= w && 0 === G[w]; w--) {
      ;
    }

    u > w && (u = w);
    if (0 === w) return f[g++] = 20971520, f[g++] = 20971520, m.bits = 1, 0;

    for (q = 1; q < w && 0 === G[q]; q++) {
      ;
    }

    u < q && (u = q);

    for (r = k = 1; 15 >= r; r++) {
      if (k <<= 1, k -= G[r], 0 > k) return -1;
    }

    if (0 < k && (0 === a || 1 !== w)) return -1;
    K[1] = 0;

    for (r = 1; 15 > r; r++) {
      K[r + 1] = K[r] + G[r];
    }

    for (y = 0; y < d; y++) {
      0 !== c[b + y] && (l[K[c[b + y]]++] = y);
    }

    0 === a ? (V = ka = l, ca = 20) : 1 === a ? (V = Yg, ka = Zg, ca = 257) : (V = $g, ka = ah, ca = 0);
    y = t = 0;
    r = q;
    F = g;
    d = u;
    K = 0;
    v = -1;
    h = 1 << u;
    E = h - 1;
    if (1 === a && 852 < h || 2 === a && 592 < h) return 1;

    for (;;) {
      ma = r - K;
      l[y] + 1 < ca ? (ia = 0, ja = l[y]) : l[y] >= ca ? (ia = ka[l[y] - ca], ja = V[l[y] - ca]) : (ia = 96, ja = 0);
      k = 1 << r - K;
      q = x = 1 << d;

      do {
        x -= k, f[F + (t >> K) + x] = ma << 24 | ia << 16 | ja | 0;
      } while (0 !== x);

      for (k = 1 << r - 1; t & k;) {
        k >>= 1;
      }

      0 !== k ? (t &= k - 1, t += k) : t = 0;
      y++;

      if (0 === --G[r]) {
        if (r === w) break;
        r = c[b + l[y]];
      }

      if (r > u && (t & E) !== v) {
        0 === K && (K = u);
        F += q;
        d = r - K;

        for (k = 1 << d; d + K < w;) {
          k -= G[d + K];
          if (0 >= k) break;
          d++;
          k <<= 1;
        }

        h += 1 << d;
        if (1 === a && 852 < h || 2 === a && 592 < h) return 1;
        v = t & E;
        f[v] = u << 24 | d << 16 | F - g | 0;
      }
    }

    0 !== t && (f[F + t] = r - K << 24 | 4194304);
    m.bits = u;
    return 0;
  };

  var Af = Jb.Z_FINISH,
      bh = Jb.Z_BLOCK,
      Xc = Jb.Z_TREES,
      Lb = Jb.Z_OK,
      ch = Jb.Z_STREAM_END,
      dh = Jb.Z_NEED_DICT,
      Oa = Jb.Z_STREAM_ERROR,
      Bf = Jb.Z_DATA_ERROR,
      Cf = Jb.Z_MEM_ERROR,
      eh = Jb.Z_BUF_ERROR,
      Df = Jb.Z_DEFLATED,
      Mb = function Mb(a) {
    if (!a) return 1;
    var c = a.state;
    return !c || c.strm !== a || 16180 > c.mode || 16211 < c.mode ? 1 : 0;
  },
      Ef = function Ef(a) {
    if (Mb(a)) return Oa;
    var c = a.state;
    a.total_in = a.total_out = c.total = 0;
    a.msg = "";
    c.wrap && (a.adler = c.wrap & 1);
    c.mode = 16180;
    c.last = 0;
    c.havedict = 0;
    c.flags = -1;
    c.dmax = 32768;
    c.head = null;
    c.hold = 0;
    c.bits = 0;
    c.lencode = c.lendyn = new Int32Array(852);
    c.distcode = c.distdyn = new Int32Array(592);
    c.sane = 1;
    c.back = -1;
    return Lb;
  },
      Ff = function Ff(a) {
    if (Mb(a)) return Oa;
    var c = a.state;
    c.wsize = 0;
    c.whave = 0;
    c.wnext = 0;
    return Ef(a);
  },
      Gf = function Gf(a, c) {
    var b;
    if (Mb(a)) return Oa;
    var d = a.state;
    0 > c ? (b = 0, c = -c) : (b = (c >> 4) + 5, 48 > c && (c &= 15));
    if (c && (8 > c || 15 < c)) return Oa;
    null !== d.window && d.wbits !== c && (d.window = null);
    d.wrap = b;
    d.wbits = c;
    return Ff(a);
  },
      Hf = function Hf(a, c) {
    if (!a) return Oa;
    var b = new dg();
    a.state = b;
    b.strm = a;
    b.window = null;
    b.mode = 16180;
    c = Gf(a, c);
    c !== Lb && (a.state = null);
    return c;
  },
      If = !0,
      je,
      ke,
      Jf = function Jf(a, c, b, d) {
    var f = a.state;
    null === f.window && (f.wsize = 1 << f.wbits, f.wnext = 0, f.whave = 0, f.window = new Uint8Array(f.wsize));
    d >= f.wsize ? (f.window.set(c.subarray(b - f.wsize, b), 0), f.wnext = 0, f.whave = f.wsize) : (a = f.wsize - f.wnext, a > d && (a = d), f.window.set(c.subarray(b - d, b - d + a), f.wnext), (d -= a) ? (f.window.set(c.subarray(b - d, b), 0), f.wnext = d, f.whave = f.wsize) : (f.wnext += a, f.wnext === f.wsize && (f.wnext = 0), f.whave < f.wsize && (f.whave += a)));
    return 0;
  };

  var kb = {
    inflateReset: Ff,
    inflateReset2: Gf,
    inflateResetKeep: Ef,
    inflateInit: function inflateInit(a) {
      return Hf(a, 15);
    },
    inflateInit2: Hf,
    inflate: function inflate(a, c) {
      var b;
      var d, f;
      var g;
      var l = new Uint8Array(4),
          m = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
      if (Mb(a) || !a.output || !a.input && 0 !== a.avail_in) return Oa;
      b = a.state;
      16191 === b.mode && (b.mode = 16192);
      var q = a.next_out;
      var r = a.output;
      var y = a.avail_out;
      var w = a.next_in;
      var u = a.input;
      var k = a.avail_in;
      var h = b.hold;
      var t = b.bits;
      d = k;
      f = y;
      g = Lb;

      a: for (;;) {
        switch (b.mode) {
          case 16180:
            if (0 === b.wrap) {
              b.mode = 16192;
              break;
            }

            for (; 16 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            if (b.wrap & 2 && 35615 === h) {
              0 === b.wbits && (b.wbits = 15);
              b.check = 0;
              l[0] = h & 255;
              l[1] = h >>> 8 & 255;
              b.check = pa(b.check, l, 2, 0);
              t = h = 0;
              b.mode = 16181;
              break;
            }

            b.head && (b.head.done = !1);

            if (!(b.wrap & 1) || (((h & 255) << 8) + (h >> 8)) % 31) {
              a.msg = "incorrect header check";
              b.mode = 16209;
              break;
            }

            if ((h & 15) !== Df) {
              a.msg = "unknown compression method";
              b.mode = 16209;
              break;
            }

            h >>>= 4;
            t -= 4;
            var x = (h & 15) + 8;
            0 === b.wbits && (b.wbits = x);

            if (15 < x || x > b.wbits) {
              a.msg = "invalid window size";
              b.mode = 16209;
              break;
            }

            b.dmax = 1 << b.wbits;
            b.flags = 0;
            a.adler = b.check = 1;
            b.mode = h & 512 ? 16189 : 16191;
            t = h = 0;
            break;

          case 16181:
            for (; 16 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            b.flags = h;

            if ((b.flags & 255) !== Df) {
              a.msg = "unknown compression method";
              b.mode = 16209;
              break;
            }

            if (b.flags & 57344) {
              a.msg = "unknown header flags set";
              b.mode = 16209;
              break;
            }

            b.head && (b.head.text = h >> 8 & 1);
            b.flags & 512 && b.wrap & 4 && (l[0] = h & 255, l[1] = h >>> 8 & 255, b.check = pa(b.check, l, 2, 0));
            t = h = 0;
            b.mode = 16182;

          case 16182:
            for (; 32 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            b.head && (b.head.time = h);
            b.flags & 512 && b.wrap & 4 && (l[0] = h & 255, l[1] = h >>> 8 & 255, l[2] = h >>> 16 & 255, l[3] = h >>> 24 & 255, b.check = pa(b.check, l, 4, 0));
            t = h = 0;
            b.mode = 16183;

          case 16183:
            for (; 16 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            b.head && (b.head.xflags = h & 255, b.head.os = h >> 8);
            b.flags & 512 && b.wrap & 4 && (l[0] = h & 255, l[1] = h >>> 8 & 255, b.check = pa(b.check, l, 2, 0));
            t = h = 0;
            b.mode = 16184;

          case 16184:
            if (b.flags & 1024) {
              for (; 16 > t;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              b.length = h;
              b.head && (b.head.extra_len = h);
              b.flags & 512 && b.wrap & 4 && (l[0] = h & 255, l[1] = h >>> 8 & 255, b.check = pa(b.check, l, 2, 0));
              t = h = 0;
            } else b.head && (b.head.extra = null);

            b.mode = 16185;

          case 16185:
            if (b.flags & 1024) {
              var v = b.length;
              v > k && (v = k);
              v && (b.head && (x = b.head.extra_len - b.length, b.head.extra || (b.head.extra = new Uint8Array(b.head.extra_len)), b.head.extra.set(u.subarray(w, w + v), x)), b.flags & 512 && b.wrap & 4 && (b.check = pa(b.check, u, v, w)), k -= v, w += v, b.length -= v);
              if (b.length) break a;
            }

            b.length = 0;
            b.mode = 16186;

          case 16186:
            if (b.flags & 2048) {
              if (0 === k) break a;
              v = 0;

              do {
                x = u[w + v++], b.head && x && 65536 > b.length && (b.head.name += String.fromCharCode(x));
              } while (x && v < k);

              b.flags & 512 && b.wrap & 4 && (b.check = pa(b.check, u, v, w));
              k -= v;
              w += v;
              if (x) break a;
            } else b.head && (b.head.name = null);

            b.length = 0;
            b.mode = 16187;

          case 16187:
            if (b.flags & 4096) {
              if (0 === k) break a;
              v = 0;

              do {
                x = u[w + v++], b.head && x && 65536 > b.length && (b.head.comment += String.fromCharCode(x));
              } while (x && v < k);

              b.flags & 512 && b.wrap & 4 && (b.check = pa(b.check, u, v, w));
              k -= v;
              w += v;
              if (x) break a;
            } else b.head && (b.head.comment = null);

            b.mode = 16188;

          case 16188:
            if (b.flags & 512) {
              for (; 16 > t;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              if (b.wrap & 4 && h !== (b.check & 65535)) {
                a.msg = "header crc mismatch";
                b.mode = 16209;
                break;
              }

              t = h = 0;
            }

            b.head && (b.head.hcrc = b.flags >> 9 & 1, b.head.done = !0);
            a.adler = b.check = 0;
            b.mode = 16191;
            break;

          case 16189:
            for (; 32 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            a.adler = b.check = (h >>> 24 & 255) + (h >>> 8 & 65280) + ((h & 65280) << 8) + ((h & 255) << 24);
            t = h = 0;
            b.mode = 16190;

          case 16190:
            if (0 === b.havedict) return a.next_out = q, a.avail_out = y, a.next_in = w, a.avail_in = k, b.hold = h, b.bits = t, dh;
            a.adler = b.check = 1;
            b.mode = 16191;

          case 16191:
            if (c === bh || c === Xc) break a;

          case 16192:
            if (b.last) {
              h >>>= t & 7;
              t -= t & 7;
              b.mode = 16206;
              break;
            }

            for (; 3 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            b.last = h & 1;
            h >>>= 1;
            --t;

            switch (h & 3) {
              case 0:
                b.mode = 16193;
                break;

              case 1:
                v = b;

                if (If) {
                  je = new Int32Array(512);
                  ke = new Int32Array(32);

                  for (x = 0; 144 > x;) {
                    v.lens[x++] = 8;
                  }

                  for (; 256 > x;) {
                    v.lens[x++] = 9;
                  }

                  for (; 280 > x;) {
                    v.lens[x++] = 7;
                  }

                  for (; 288 > x;) {
                    v.lens[x++] = 8;
                  }

                  wc(1, v.lens, 0, 288, je, 0, v.work, {
                    bits: 9
                  });

                  for (x = 0; 32 > x;) {
                    v.lens[x++] = 5;
                  }

                  wc(2, v.lens, 0, 32, ke, 0, v.work, {
                    bits: 5
                  });
                  If = !1;
                }

                v.lencode = je;
                v.lenbits = 9;
                v.distcode = ke;
                v.distbits = 5;
                b.mode = 16199;

                if (c === Xc) {
                  h >>>= 2;
                  t -= 2;
                  break a;
                }

                break;

              case 2:
                b.mode = 16196;
                break;

              case 3:
                a.msg = "invalid block type", b.mode = 16209;
            }

            h >>>= 2;
            t -= 2;
            break;

          case 16193:
            h >>>= t & 7;

            for (t -= t & 7; 32 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            if ((h & 65535) !== (h >>> 16 ^ 65535)) {
              a.msg = "invalid stored block lengths";
              b.mode = 16209;
              break;
            }

            b.length = h & 65535;
            t = h = 0;
            b.mode = 16194;
            if (c === Xc) break a;

          case 16194:
            b.mode = 16195;

          case 16195:
            if (v = b.length) {
              v > k && (v = k);
              v > y && (v = y);
              if (0 === v) break a;
              r.set(u.subarray(w, w + v), q);
              k -= v;
              w += v;
              y -= v;
              q += v;
              b.length -= v;
              break;
            }

            b.mode = 16191;
            break;

          case 16196:
            for (; 14 > t;) {
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            b.nlen = (h & 31) + 257;
            h >>>= 5;
            t -= 5;
            b.ndist = (h & 31) + 1;
            h >>>= 5;
            t -= 5;
            b.ncode = (h & 15) + 4;
            h >>>= 4;
            t -= 4;

            if (286 < b.nlen || 30 < b.ndist) {
              a.msg = "too many length or distance symbols";
              b.mode = 16209;
              break;
            }

            b.have = 0;
            b.mode = 16197;

          case 16197:
            for (; b.have < b.ncode;) {
              for (; 3 > t;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              b.lens[m[b.have++]] = h & 7;
              h >>>= 3;
              t -= 3;
            }

            for (; 19 > b.have;) {
              b.lens[m[b.have++]] = 0;
            }

            b.lencode = b.lendyn;
            b.lenbits = 7;
            v = {
              bits: b.lenbits
            };
            g = wc(0, b.lens, 0, 19, b.lencode, 0, b.work, v);
            b.lenbits = v.bits;

            if (g) {
              a.msg = "invalid code lengths set";
              b.mode = 16209;
              break;
            }

            b.have = 0;
            b.mode = 16198;

          case 16198:
            for (; b.have < b.nlen + b.ndist;) {
              for (;;) {
                var E = b.lencode[h & (1 << b.lenbits) - 1];
                v = E >>> 24;
                E &= 65535;
                if (v <= t) break;
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              if (16 > E) h >>>= v, t -= v, b.lens[b.have++] = E;else {
                if (16 === E) {
                  for (x = v + 2; t < x;) {
                    if (0 === k) break a;
                    k--;
                    h += u[w++] << t;
                    t += 8;
                  }

                  h >>>= v;
                  t -= v;

                  if (0 === b.have) {
                    a.msg = "invalid bit length repeat";
                    b.mode = 16209;
                    break;
                  }

                  x = b.lens[b.have - 1];
                  v = 3 + (h & 3);
                  h >>>= 2;
                  t -= 2;
                } else if (17 === E) {
                  for (x = v + 3; t < x;) {
                    if (0 === k) break a;
                    k--;
                    h += u[w++] << t;
                    t += 8;
                  }

                  h >>>= v;
                  t -= v;
                  x = 0;
                  v = 3 + (h & 7);
                  h >>>= 3;
                  t -= 3;
                } else {
                  for (x = v + 7; t < x;) {
                    if (0 === k) break a;
                    k--;
                    h += u[w++] << t;
                    t += 8;
                  }

                  h >>>= v;
                  t -= v;
                  x = 0;
                  v = 11 + (h & 127);
                  h >>>= 7;
                  t -= 7;
                }

                if (b.have + v > b.nlen + b.ndist) {
                  a.msg = "invalid bit length repeat";
                  b.mode = 16209;
                  break;
                }

                for (; v--;) {
                  b.lens[b.have++] = x;
                }
              }
            }

            if (16209 === b.mode) break;

            if (0 === b.lens[256]) {
              a.msg = "invalid code -- missing end-of-block";
              b.mode = 16209;
              break;
            }

            b.lenbits = 9;
            v = {
              bits: b.lenbits
            };
            g = wc(1, b.lens, 0, b.nlen, b.lencode, 0, b.work, v);
            b.lenbits = v.bits;

            if (g) {
              a.msg = "invalid literal/lengths set";
              b.mode = 16209;
              break;
            }

            b.distbits = 6;
            b.distcode = b.distdyn;
            v = {
              bits: b.distbits
            };
            g = wc(2, b.lens, b.nlen, b.ndist, b.distcode, 0, b.work, v);
            b.distbits = v.bits;

            if (g) {
              a.msg = "invalid distances set";
              b.mode = 16209;
              break;
            }

            b.mode = 16199;
            if (c === Xc) break a;

          case 16199:
            b.mode = 16200;

          case 16200:
            if (6 <= k && 258 <= y) {
              a.next_out = q;
              a.avail_out = y;
              a.next_in = w;
              a.avail_in = k;
              b.hold = h;
              b.bits = t;
              var F = void 0;
              var K = void 0,
                  ka = void 0,
                  ma = void 0,
                  ia = void 0,
                  ja = void 0,
                  X = void 0,
                  R = void 0,
                  Aa = void 0,
                  Z = void 0;
              u = a;
              var Y = u.state;
              Z = u.next_in;
              w = u.input;
              Aa = Z + (u.avail_in - 5);
              R = u.next_out;
              r = u.output;
              X = R - (f - u.avail_out);
              ja = R + (u.avail_out - 257);
              ia = Y.dmax;
              ma = Y.wsize;
              E = Y.whave;
              var V = Y.wnext;
              var ca = Y.window;
              var G = Y.hold;
              x = Y.bits;
              v = Y.lencode;
              t = Y.distcode;
              h = (1 << Y.lenbits) - 1;
              y = (1 << Y.distbits) - 1;

              b: do {
                c: for (15 > x && (G += w[Z++] << x, x += 8, G += w[Z++] << x, x += 8), F = v[G & h];;) {
                  k = F >>> 24;
                  G >>>= k;
                  x -= k;
                  k = F >>> 16 & 255;
                  if (0 === k) r[R++] = F & 65535;else if (k & 16) {
                    q = F & 65535;
                    if (k &= 15) x < k && (G += w[Z++] << x, x += 8), q += G & (1 << k) - 1, G >>>= k, x -= k;
                    15 > x && (G += w[Z++] << x, x += 8, G += w[Z++] << x, x += 8);
                    F = t[G & y];

                    d: for (;;) {
                      k = F >>> 24;
                      G >>>= k;
                      x -= k;
                      k = F >>> 16 & 255;

                      if (k & 16) {
                        ka = F & 65535;
                        k &= 15;
                        x < k && (G += w[Z++] << x, x += 8, x < k && (G += w[Z++] << x, x += 8));
                        ka += G & (1 << k) - 1;

                        if (ka > ia) {
                          u.msg = "invalid distance too far back";
                          Y.mode = 16209;
                          break b;
                        }

                        G >>>= k;
                        x -= k;
                        k = R - X;

                        if (ka > k) {
                          k = ka - k;

                          if (k > E && Y.sane) {
                            u.msg = "invalid distance too far back";
                            Y.mode = 16209;
                            break b;
                          }

                          K = 0;
                          F = ca;

                          if (0 === V) {
                            if (K += ma - k, k < q) {
                              q -= k;

                              do {
                                r[R++] = ca[K++];
                              } while (--k);

                              K = R - ka;
                              F = r;
                            }
                          } else if (V < k) {
                            if (K += ma + V - k, k -= V, k < q) {
                              q -= k;

                              do {
                                r[R++] = ca[K++];
                              } while (--k);

                              K = 0;

                              if (V < q) {
                                k = V;
                                q -= k;

                                do {
                                  r[R++] = ca[K++];
                                } while (--k);

                                K = R - ka;
                                F = r;
                              }
                            }
                          } else if (K += V - k, k < q) {
                            q -= k;

                            do {
                              r[R++] = ca[K++];
                            } while (--k);

                            K = R - ka;
                            F = r;
                          }

                          for (; 2 < q;) {
                            r[R++] = F[K++], r[R++] = F[K++], r[R++] = F[K++], q -= 3;
                          }

                          q && (r[R++] = F[K++], 1 < q && (r[R++] = F[K++]));
                        } else {
                          K = R - ka;

                          do {
                            r[R++] = r[K++], r[R++] = r[K++], r[R++] = r[K++], q -= 3;
                          } while (2 < q);

                          q && (r[R++] = r[K++], 1 < q && (r[R++] = r[K++]));
                        }
                      } else if (0 === (k & 64)) {
                        F = t[(F & 65535) + (G & (1 << k) - 1)];
                        continue d;
                      } else {
                        u.msg = "invalid distance code";
                        Y.mode = 16209;
                        break b;
                      }

                      break;
                    }
                  } else if (0 === (k & 64)) {
                    F = v[(F & 65535) + (G & (1 << k) - 1)];
                    continue c;
                  } else {
                    k & 32 ? Y.mode = 16191 : (u.msg = "invalid literal/length code", Y.mode = 16209);
                    break b;
                  }
                  break;
                }
              } while (Z < Aa && R < ja);

              q = x >> 3;
              Z -= q;
              x -= q << 3;
              u.next_in = Z;
              u.next_out = R;
              u.avail_in = Z < Aa ? 5 + (Aa - Z) : 5 - (Z - Aa);
              u.avail_out = R < ja ? 257 + (ja - R) : 257 - (R - ja);
              Y.hold = G & (1 << x) - 1;
              Y.bits = x;
              q = a.next_out;
              r = a.output;
              y = a.avail_out;
              w = a.next_in;
              u = a.input;
              k = a.avail_in;
              h = b.hold;
              t = b.bits;
              16191 === b.mode && (b.back = -1);
              break;
            }

            for (b.back = 0;;) {
              E = b.lencode[h & (1 << b.lenbits) - 1];
              v = E >>> 24;
              x = E >>> 16 & 255;
              E &= 65535;
              if (v <= t) break;
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            if (x && 0 === (x & 240)) {
              G = v;
              ca = x;

              for (V = E;;) {
                E = b.lencode[V + ((h & (1 << G + ca) - 1) >> G)];
                v = E >>> 24;
                x = E >>> 16 & 255;
                E &= 65535;
                if (G + v <= t) break;
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              h >>>= G;
              t -= G;
              b.back += G;
            }

            h >>>= v;
            t -= v;
            b.back += v;
            b.length = E;

            if (0 === x) {
              b.mode = 16205;
              break;
            }

            if (x & 32) {
              b.back = -1;
              b.mode = 16191;
              break;
            }

            if (x & 64) {
              a.msg = "invalid literal/length code";
              b.mode = 16209;
              break;
            }

            b.extra = x & 15;
            b.mode = 16201;

          case 16201:
            if (b.extra) {
              for (x = b.extra; t < x;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              b.length += h & (1 << b.extra) - 1;
              h >>>= b.extra;
              t -= b.extra;
              b.back += b.extra;
            }

            b.was = b.length;
            b.mode = 16202;

          case 16202:
            for (;;) {
              E = b.distcode[h & (1 << b.distbits) - 1];
              v = E >>> 24;
              x = E >>> 16 & 255;
              E &= 65535;
              if (v <= t) break;
              if (0 === k) break a;
              k--;
              h += u[w++] << t;
              t += 8;
            }

            if (0 === (x & 240)) {
              G = v;
              ca = x;

              for (V = E;;) {
                E = b.distcode[V + ((h & (1 << G + ca) - 1) >> G)];
                v = E >>> 24;
                x = E >>> 16 & 255;
                E &= 65535;
                if (G + v <= t) break;
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              h >>>= G;
              t -= G;
              b.back += G;
            }

            h >>>= v;
            t -= v;
            b.back += v;

            if (x & 64) {
              a.msg = "invalid distance code";
              b.mode = 16209;
              break;
            }

            b.offset = E;
            b.extra = x & 15;
            b.mode = 16203;

          case 16203:
            if (b.extra) {
              for (x = b.extra; t < x;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              b.offset += h & (1 << b.extra) - 1;
              h >>>= b.extra;
              t -= b.extra;
              b.back += b.extra;
            }

            if (b.offset > b.dmax) {
              a.msg = "invalid distance too far back";
              b.mode = 16209;
              break;
            }

            b.mode = 16204;

          case 16204:
            if (0 === y) break a;
            v = f - y;

            if (b.offset > v) {
              v = b.offset - v;

              if (v > b.whave && b.sane) {
                a.msg = "invalid distance too far back";
                b.mode = 16209;
                break;
              }

              v > b.wnext ? (v -= b.wnext, x = b.wsize - v) : x = b.wnext - v;
              v > b.length && (v = b.length);
              G = b.window;
            } else G = r, x = q - b.offset, v = b.length;

            v > y && (v = y);
            y -= v;
            b.length -= v;

            do {
              r[q++] = G[x++];
            } while (--v);

            0 === b.length && (b.mode = 16200);
            break;

          case 16205:
            if (0 === y) break a;
            r[q++] = b.length;
            y--;
            b.mode = 16200;
            break;

          case 16206:
            if (b.wrap) {
              for (; 32 > t;) {
                if (0 === k) break a;
                k--;
                h |= u[w++] << t;
                t += 8;
              }

              f -= y;
              a.total_out += f;
              b.total += f;
              b.wrap & 4 && f && (a.adler = b.check = b.flags ? pa(b.check, r, f, q - f) : rc(b.check, r, f, q - f));
              f = y;

              if (b.wrap & 4 && (b.flags ? h : (h >>> 24 & 255) + (h >>> 8 & 65280) + ((h & 65280) << 8) + ((h & 255) << 24)) !== b.check) {
                a.msg = "incorrect data check";
                b.mode = 16209;
                break;
              }

              t = h = 0;
            }

            b.mode = 16207;

          case 16207:
            if (b.wrap && b.flags) {
              for (; 32 > t;) {
                if (0 === k) break a;
                k--;
                h += u[w++] << t;
                t += 8;
              }

              if (b.wrap & 4 && h !== (b.total & 4294967295)) {
                a.msg = "incorrect length check";
                b.mode = 16209;
                break;
              }

              t = h = 0;
            }

            b.mode = 16208;

          case 16208:
            g = ch;
            break a;

          case 16209:
            g = Bf;
            break a;

          case 16210:
            return Cf;

          default:
            return Oa;
        }
      }

      a.next_out = q;
      a.avail_out = y;
      a.next_in = w;
      a.avail_in = k;
      b.hold = h;
      b.bits = t;
      (b.wsize || f !== a.avail_out && 16209 > b.mode && (16206 > b.mode || c !== Af)) && Jf(a, a.output, a.next_out, f - a.avail_out);
      d -= a.avail_in;
      f -= a.avail_out;
      a.total_in += d;
      a.total_out += f;
      b.total += f;
      b.wrap & 4 && f && (a.adler = b.check = b.flags ? pa(b.check, r, f, a.next_out - f) : rc(b.check, r, f, a.next_out - f));
      a.data_type = b.bits + (b.last ? 64 : 0) + (16191 === b.mode ? 128 : 0) + (16199 === b.mode || 16194 === b.mode ? 256 : 0);
      (0 === d && 0 === f || c === Af) && g === Lb && (g = eh);
      return g;
    },
    inflateEnd: function inflateEnd(a) {
      if (Mb(a)) return Oa;
      var c = a.state;
      c.window && (c.window = null);
      a.state = null;
      return Lb;
    },
    inflateGetHeader: function inflateGetHeader(a, c) {
      if (Mb(a)) return Oa;
      a = a.state;
      if (0 === (a.wrap & 2)) return Oa;
      a.head = c;
      c.done = !1;
      return Lb;
    },
    inflateSetDictionary: function inflateSetDictionary(a, c) {
      var b = c.length;
      var d, f;
      if (Mb(a)) return Oa;
      d = a.state;
      if (0 !== d.wrap && 16190 !== d.mode) return Oa;
      if (16190 === d.mode && (f = rc(1, c, b, 0), f !== d.check)) return Bf;
      if (Jf(a, c, b, b)) return d.mode = 16210, Cf;
      d.havedict = 1;
      return Lb;
    },
    inflateInfo: "pako inflate (from Nodeca project)"
  },
      eg = function eg() {
    this.os = this.xflags = this.time = this.text = 0;
    this.extra = null;
    this.extra_len = 0;
    this.comment = this.name = "";
    this.hcrc = 0;
    this.done = !1;
  };

  var ze = Object.prototype.toString,
      fh = Jb.Z_NO_FLUSH,
      gh = Jb.Z_FINISH,
      ec = Jb.Z_OK,
      le = Jb.Z_STREAM_END,
      me = Jb.Z_NEED_DICT,
      hh = Jb.Z_STREAM_ERROR,
      Kf = Jb.Z_DATA_ERROR,
      ih = Jb.Z_MEM_ERROR;

  dc.prototype.push = function (a, c) {
    var b = this.strm,
        d = this.options.chunkSize,
        f = this.options.dictionary,
        g,
        l;
    if (this.ended) return !1;
    g = c === ~~c ? c : !0 === c ? gh : fh;
    "[object ArrayBuffer]" === ze.call(a) ? b.input = new Uint8Array(a) : b.input = a;
    b.next_in = 0;

    for (b.avail_in = b.input.length;;) {
      0 === b.avail_out && (b.output = new Uint8Array(d), b.next_out = 0, b.avail_out = d);
      c = kb.inflate(b, g);
      c === me && f && (c = kb.inflateSetDictionary(b, f), c === ec ? c = kb.inflate(b, g) : c === Kf && (c = me));

      for (; 0 < b.avail_in && c === le && 0 < b.state.wrap && 0 !== a[b.next_in];) {
        kb.inflateReset(b), c = kb.inflate(b, g);
      }

      switch (c) {
        case hh:
        case Kf:
        case me:
        case ih:
          return this.onEnd(c), this.ended = !0, !1;
      }

      l = b.avail_out;
      if (b.next_out && (0 === b.avail_out || c === le)) if ("string" === this.options.to) {
        var m = cc.utf8border(b.output, b.next_out),
            q = b.next_out - m,
            r = cc.buf2string(b.output, m);
        b.next_out = q;
        b.avail_out = d - q;
        q && b.output.set(b.output.subarray(m, m + q), 0);
        this.onData(r);
      } else this.onData(b.output.length === b.next_out ? b.output : b.output.subarray(0, b.next_out));

      if (c !== ec || 0 !== l) {
        if (c === le) {
          c = kb.inflateEnd(this.strm);
          this.onEnd(c);
          this.ended = !0;
          break;
        }

        if (0 === b.avail_in) break;
      }
    }

    return !0;
  };

  dc.prototype.onData = function (a) {
    this.chunks.push(a);
  };

  dc.prototype.onEnd = function (a) {
    a === ec && (this.result = "string" === this.options.to ? this.chunks.join("") : Bc.flattenChunks(this.chunks));
    this.chunks = [];
    this.err = a;
    this.msg = this.strm.msg;
  };

  var jh = {
    Inflate: dc,
    inflate: dd,
    inflateRaw: function inflateRaw(a, c) {
      c = c || {};
      c.raw = !0;
      return dd(a, c);
    },
    ungzip: dd,
    constants: Jb
  };
  var kh = Xg.Deflate,
      lh = Xg.deflate,
      mh = Xg.deflateRaw,
      nh = Xg.gzip,
      oh = jh.Inflate,
      ph = jh.inflate,
      qh = jh.inflateRaw,
      rh = jh.ungzip;
  var De = {
    Deflate: kh,
    deflate: lh,
    deflateRaw: mh,
    gzip: nh,
    Inflate: oh,
    inflate: ph,
    inflateRaw: qh,
    ungzip: rh,
    constants: Jb
  },
      qa;

  (function (a) {
    a.response_body = "rsb";
    a.request_body = "rqb";
    a.response_headers = "rsh";
    a.request_headers = "rqh";
  })(qa || (qa = {}));

  var aa;

  (function (a) {
    a.TRACEPARENT_HEADER_KEY = "traceparent";

    (function (c) {
      c[c.APP = 0] = "APP";
      c[c.REMOTE = 1] = "REMOTE";
      c[c.MERGE = 2] = "MERGE";
    })(a.CONFIG_PREFERENCES || (a.CONFIG_PREFERENCES = {}));

    (function (c) {
      c[c.DISABLED = 0] = "DISABLED";
      c[c.PERFORMANCE_TIMING = 1] = "PERFORMANCE_TIMING";
      c[c.PERFORMANCE_NAVIGATION_TIMING = 2] = "PERFORMANCE_NAVIGATION_TIMING";
    })(a.PERFORMANCE_CONTEXT || (a.PERFORMANCE_CONTEXT = {}));

    a.REMOTE_CONFIG_STORAGE_KEY = "ConvivaRemoteConfig";
    a.END_POINT_STORAGE_KEY = "ConvivaEndpoint";
    a.DEFAULT_END_POINT = "https://appgw.conviva.com";
    a.REMOTE_CONFIG_URL_PREFIX = "https://rc.conviva.com/js/";
    a.REMOTE_CONFIG_FILE_NAME = "/remote_config.json";
  })(aa || (aa = {}));

  var da = {},
      Ub;

  (function (a) {
    a[a.APP = 0] = "APP";
    a[a.REMOTE = 1] = "REMOTE";
    a[a.MERGE = 2] = "MERGE";
  })(Ub || (Ub = {}));

  var nc = {},
      xg = function () {
    return function () {
      this.outQueues = [];
      this.bufferFlushers = [];
      this.hasLoaded = !1;
      this.registeredOnLoadHandlers = [];
    };
  }(),
      Yc = "undefined" !== typeof window ? wg() : void 0;

  O.addGlobalContexts = function (a, c) {
    W(c, function (b) {
      b.core.addGlobalContexts(a);
    });
  };

  O.addPlugin = function (a, c) {
    W(c, function (b) {
      b.addPlugin(a);
    });
  };

  O.clearGlobalContexts = function (a) {
    W(a, function (c) {
      c.core.clearGlobalContexts();
    });
  };

  O.clearUserData = function (a, c) {
    W(c, function (b) {
      b.clearUserData(a);
    });
  };

  O.convivaAppTracker = function (a) {
    void 0 === a && (a = {});

    try {
      if (Yc) return Ue("CAT", "CAT", "js-".concat("0.6.8"), "", Yc, a);
    } catch (c) {
      console.warn("Conviva App Tracker:: Initialisation failed! " + c);
    }
  };

  O.crossDomainLinker = function (a, c) {
    W(c, function (b) {
      b.crossDomainLinker(a);
    });
  };

  O.disableAnonymousTracking = function (a, c) {
    W(c, function (b) {
      b.disableAnonymousTracking(a);
    });
  };

  O.discardBrace = function (a, c) {
    W(c, function (b) {
      b.discardBrace(a);
    });
  };

  O.discardHashTag = function (a, c) {
    W(c, function (b) {
      b.discardHashTag(a);
    });
  };

  O.enableActivityTracking = function (a, c) {
    W(c, function (b) {
      b.enableActivityTracking(a);
    });
  };

  O.enableActivityTrackingCallback = function (a, c) {
    W(c, function (b) {
      b.enableActivityTrackingCallback(a);
    });
  };

  O.enableAnonymousTracking = function (a, c) {
    W(c, function (b) {
      b.enableAnonymousTracking(a);
    });
  };

  O.flushBuffer = function (a, c) {
    W(c, function (b) {
      b.flushBuffer(a);
    });
  };

  O.newSession = function (a) {
    W(a, function (c) {
      c.newSession();
    });
  };

  O.newTracker = function (a, c, b) {
    void 0 === b && (b = {});
    if (Yc) return Ue(a, a, "js-".concat("0.6.8"), c, Yc, b);
  };

  O.preservePageViewId = function (a) {
    W(a, function (c) {
      c.preservePageViewId();
    });
  };

  O.removeGlobalContexts = function (a, c) {
    W(c, function (b) {
      b.core.removeGlobalContexts(a);
    });
  };

  O.setBufferSize = function (a, c) {
    W(c, function (b) {
      b.setBufferSize(a);
    });
  };

  O.setCollectorUrl = function (a, c) {
    W(c, function (b) {
      b.setCollectorUrl(a);
    });
  };

  O.setCookiePath = function (a, c) {
    W(c, function (b) {
      b.setCookiePath(a);
    });
  };

  O.setCustomTags = function (a, c) {
    W(c, function (b) {
      try {
        b.setCustomTags(a);
      } catch (d) {
        console.warn("Conviva App Tracker:: Unable to set custom tags data!");
      }
    });
  };

  O.setCustomUrl = function (a, c) {
    W(c, function (b) {
      b.setCustomUrl(a);
    });
  };

  O.setDocumentTitle = function (a, c) {
    W(c, function (b) {
      b.setDocumentTitle(a);
    });
  };

  O.setOptOutCookie = function (a, c) {
    W(c, function (b) {
      b.setOptOutCookie(a);
    });
  };

  O.setReferrerUrl = function (a, c) {
    W(c, function (b) {
      b.setReferrerUrl(a);
    });
  };

  O.setUserId = function (a, c) {
    W(c, function (b) {
      b.setUserId(a);
    });
  };

  O.setUserIdFromCookie = function (a, c) {
    W(c, function (b) {
      b.setUserIdFromCookie(a);
    });
  };

  O.setUserIdFromLocation = function (a, c) {
    W(c, function (b) {
      b.setUserIdFromLocation(a);
    });
  };

  O.setUserIdFromReferrer = function (a, c) {
    W(c, function (b) {
      b.setUserIdFromReferrer(a);
    });
  };

  O.setVisitorCookieTimeout = function (a, c) {
    W(c, function (b) {
      b.setVisitorCookieTimeout(a);
    });
  };

  O.trackCustomEvent = function (a, c) {
    W(c, function (b) {
      try {
        b.trackCustomEvent(a);
      } catch (d) {
        console.warn("Conviva App Tracker:: Unable to track custom event! " + d);
      }
    });
  };

  O.trackPageView = function (a, c) {
    W(c, function (b) {
      b.trackPageView(a);
    });
  };

  O.trackSelfDescribingEvent = function (a, c) {
    W(c, function (b) {
      b.core.track(zb({
        event: a.event
      }), a.context, a.timestamp);
    });
  };

  O.trackStructEvent = function (a, c) {
    W(c, function (b) {
      b = b.core;
      var d = b.track,
          f = a.category,
          g = a.action,
          l = a.label,
          m = a.property,
          q = a.value,
          r = xc();
      r.add("e", "se");
      r.add("se_ca", f);
      r.add("se_ac", g);
      r.add("se_la", l);
      r.add("se_pr", m);
      r.add("se_va", null == q ? void 0 : q.toString());
      d.call(b, r, a.context, a.timestamp);
    });
  };

  O.unsetCustomTags = function (a, c) {
    W(c, function (b) {
      try {
        b.unsetCustomTags(a);
      } catch (d) {
        console.warn("Conviva App Tracker:: Unable to set custom tags data!");
      }
    });
  };

  O.updatePageActivity = function (a) {
    W(a, function (c) {
      c.updatePageActivity();
    });
  };

  O.version = "0.6.8";
  Object.defineProperty(O, "__esModule", {
    value: !0
  });
});